{
  "%-pt": "%-punt",
  "'VIR' is the real estate indexation tool that will index all buildings, mortgages and collaborations of a given person or company": "'VIR' is Vastgoed Inventarisatie Rapport dat voor een (niet) natuurlijk persoon al het vastgoed, hypotheken en samenwerkingen in kaart brengt",
  "(discount is not applied)": "(korting wordt niet toegepast)",
  "(provisional)": "(Tijdelijk)",
  "(The user has not yet verified his email)": "(De gebruiker heeft nog niet zijn email geverifieerd)",
  "* Discounts are not applied to the public API.": "* Korting wordt niet toegepast op de publieke API.",
  "... free cash flow in ... year": "{{freeCashFlow}} vrije cashflow in {{year}} jaar",
  "... in ... year": "{{value}} na {{year}} jaar",
  "... is ...": "{{ property }} is {{ value }}",
  "... is invalid": "{{ property }} is ongeldig",
  "... loan in ... year": "{{loan}} hypotheek in {{year}} jaar",
  "... or create new mortgage": "... of maak een nieuwe lopende financiering aan",
  "... or press CTRL + Enter": "... of druk op CTRL + Enter",
  "... repayment in ... year": "{{repayment}} aflossing in {{year}} jaar",
  "... should be between ... and ...": "{{ property }} moet tussen de {{ min }} en {{ max }} liggen",
  "... year": "{{value}} jaar",
  "... years": "{{value}} jaren",
  "...% in ... year": "{{percentage}}% na {{year}} jaar",
  "1 to 5 years": "1 tot 5 jaar",
  "1-255": "1-255",
  "A band of a category by non-residential share: the highest share the row applies to.": "Een band van een categorie naar niet-residentieel aandeel: het hoogste aandeel waarvoor de regel geldt.",
  "A building has room rental": "Een object heeft kamerverhuur",
  "A building in a big city (Randstad, city list) is financed even when its municipality is in an excluded region.": "Een object in een grote stad (Randstad, stedenlijst) wordt gefinancierd ook als de gemeente in een uitgesloten regio ligt.",
  "A building is recreation": "Een object is recreatie",
  "A building that is neither rented out nor for rent is financed on its vacant value instead of its value in rented condition. The vacant value is then also the basis for the renovation, new construction and value caps.": "Een object dat niet verhuurd is en ook niet te huur staat, wordt gefinancierd op de leegwaarde in plaats van de waarde in verhuurde staat. De leegwaarde is dan ook de basis voor de begrenzingen bij verbouwing, nieuwbouw en waarde.",
  "A building with room rental is only financed in a student city.": "Een object met kamerverhuur wordt alleen in een studentenstad gefinancierd.",
  "A combination building gets its maximum loan from the policy above, like any other building.": "Een combinatiepand krijgt zijn maximale lening uit het beleid hierboven, zoals elk ander object.",
  "A combination building has at least the non-residential share": "Een combinatiepand heeft minimaal het niet-residentiële aandeel",
  "A combination building has non-residential rent above": "Een combinatiepand heeft een niet-residentieel huuraandeel boven",
  "A combination building with a rejected unit is rejected as a whole.": "Een combinatiepand met een afgewezen unit wordt in zijn geheel afgewezen.",
  "A final cap at the maximum LTV of the building's own value (after renovation when a renovation with a known value is planned). Makes sure raises from earlier steps never exceed the valuation.": "Een laatste begrenzing op de maximale LTV van de eigen waarde van het object (na verbouwing als er een verbouwing met bekende waarde gepland is). Zorgt dat verhogingen uit eerdere stappen nooit boven de taxatie uitkomen.",
  "A financed building is a combination building": "Een gefinancierd object is een combinatiepand",
  "A lender with rates cannot be deleted": "Een geldverstrekker met tarieven kan niet worden verwijderd",
  "A new financing can only be made if all critical actions have been resolved. Check the actions tab.": "Een nieuwe financiering kan alleen worden gemaakt als alle kritieke acties zijn opgelost. Aantal kritieke acties die openstaan: {{value}}. Bekijk het tabblad 'acties' welke handelingen nog vereist zijn.",
  "A new rate starts as a copy of the current version of the template rate and is registered under the lender, so organizations can select it. Edit its settings afterwards.": "Een nieuw tarief begint als kopie van de huidige versie van het sjabloontarief en wordt onder de geldverstrekker geregistreerd, zodat organisaties het kunnen kiezen. Pas daarna de instellingen aan.",
  "A new version is a copy of the current version; the current version is closed on the day the new one starts.": "Een nieuwe versie is een kopie van de huidige versie; de huidige versie wordt afgesloten op de dag dat de nieuwe ingaat.",
  "A non-residential building is only financed in a big city.": "Een niet-residentieel object wordt alleen in een grote stad gefinancierd.",
  "A rejected unit rejects the building": "Een afgewezen unit wijst het object af",
  "A1Plus": "A+",
  "A2Plus": "A++",
  "A3Plus": "A+++",
  "A4Plus": "A++++",
  "Above": "Boven",
  "Accept": "Accepteren",
  "Acceptance period": "Acceptatieperiode",
  "Accepted": "Geaccepteerd",
  "Accepted by all lenders": "Geaccepteerd door alle geldverstrekkers",
  "AcceptedByLender": "Goedgekeurd door geldverstrekker",
  "Access to the following customer files": "Toegang tot de volgende klantdossiers",
  "Access token is being requested, please wait...": "Authenticatie token wordt verwerkt, een moment geduld s.v.p.",
  "According to our estimate, the house does not fall into the private sector and there is a maximum rent that can be charged. The rent is according to the points system (home valuation system) at ... per month.": "Volgens onze schatting valt de woning niet in de vrije sector en is er een maximale huur die gerekend mag worden. De huur komt volgens het puntensysteem (woningwaarderingsstelsel) uit op {{value}} per maand.",
  "Account created": "Account aangemaakt",
  "Account details": "Account gegevens",
  "Account name": "Tenaamstelling",
  "Account status": "Account status",
  "Account updated": "Account bijgewerkt",
  "Achieved": "Klaar",
  "Act in the exercise of a profession or business": "Handelt in de uitoefening van beroep of bedrijf",
  "Actions": "Acties",
  "Active": "Actief",
  "Actual": "Werkelijk",
  "At least one combination building has more than the non-residential rent share of this row of its unit rent from non-residential (CRE) units. Only combination buildings count, each on its own units; the building with the highest share decides.": "Minimaal één combinatiepand heeft meer dan het niet-residentiële huuraandeel van deze regel van zijn unithuur uit niet-residentiële (CRE) units. Alleen combinatiepanden tellen, elk op zijn eigen units; het pand met het hoogste aandeel beslist.",
  "Non-residential rent share": "Niet-residentieel huuraandeel",
  "The share of a combination building's unit rent that must come from non-residential (CRE) units, strictly above this percentage, for the condition \"A combination building has non-residential rent above\". A unit's rent is its rent income, else its rental value after renovation, else its rental value. The adjustment applies to the whole loan; combine it with the fixed interest period bounds for a surcharge per period band. Ignored for other conditions.": "Het aandeel van de unithuur van een combinatiepand dat uit niet-residentiële (CRE) units moet komen, strikt boven dit percentage, voor de voorwaarde \"Een combinatiepand heeft een niet-residentieel huuraandeel boven\". De huur van een unit is de huurinkomst, anders de huurwaarde na verbouwing, anders de huurwaarde. De aanpassing geldt voor de hele lening; combineer haar met de grenzen van de rentevaste periode voor een opslag per periodeband. Genegeerd bij andere voorwaarden.",
  "add": "toevoegen",
  "Add": "Toevoegen",
  "Add a client": "Voeg een klant toe",
  "Add a client to the account": "Voeg klant aan account toe",
  "Add a fixed interest period:": "Rentevaste periode toevoegen:",
  "Add a loan to value class:": "LTV-klasse toevoegen:",
  "Add addresses": "Adressen toevoegen",
  "Add all ... buildings": "{{value}} panden toevoegen",
  "Add all ... documents": "{{value}} documenten toevoegen",
  "Add an account": "Voeg een gebruiker toe",
  "Add another tenant": "Voeg nog een huurder toe",
  "Add at least 1 building to make use of the dashboard": "Voeg minimaal 1 pand toe om gebruik te maken van het dashboard",
  "Add AVM": "AVM toevoegen",
  "Add building": "Voeg pand toe",
  "Add building value for financing": "Waarde voor financiering toeoegen",
  "Add buildings": "Panden toevoegen",
  "Add buildings to this mortgage": "Voeg panden aan deze financiering toe",
  "Add class": "Klasse toevoegen",
  "Add client": "Voeg klant toe",
  "Add collaboration": "Voeg samenwerking toe",
  "Add collaboration members": "Voeg leden toe",
  "Add company": "Voeg bedrijf toe",
  "Add company shareholders": "Voeg aandeelhouders toe",
  "Add conversation report": "Gespreksverslag toevoegen",
  "Add conversation report here": "Voeg hier een gespreksverslag toe",
  "Add costs, capped by value after renovation": "Kosten optellen, begrensd door waarde na verbouwing",
  "Add director": "Bestuurder toevoegen",
  "Add files": "Bestanden toevoegen",
  "Add loan part": "Voeg leningdeel toe",
  "Add mortgage": "Lopende financiering toevoegen",
  "Add mortgages to this building": "Voeg financieringen aan dit pand toe",
  "Add new": "Toevoegen",
  "Add new building": "Voeg pand toe",
  "Add new client": "Voeg klant toe",
  "Add new renovation": "Voeg verbouwing toe",
  "Add new user": "Voeg nieuwe gebruiker toe",
  "Add new valuation": "Voeg waardering toe",
  "Add note": "Notitie toevoegen",
  "Add note here": "Voeg hier een notitie toe",
  "Add ongoing mortgage": "Toevoegen lopende financiering",
  "Add ongoing mortgage from land registry": "In kadaster gevonden financiering toevoegen",
  "Add ongoing mortgages": "Voeg lopende financieringen toe",
  "Add other owned addresses": "Voeg meer adressen in bezit toe",
  "Add payment details": "Incasso gegevens toevoegen",
  "Add period": "Periode toevoegen",
  "Add person": "Voeg persoon toe",
  "Add region list": "Regiolijst toevoegen",
  "Add renovation": "Verbouwing toevoegen",
  "Add rental contract": "Huurcontract toevoegen",
  "Add required document": "Benodigd document toevoegen",
  "Add room": "Voeg kamer toe",
  "Add row": "Regel toevoegen",
  "Add shareholder": "Aandeelhouder toevoegen",
  "Add tenant": "Voeg huurder toe",
  "Add tenant (company)": "Huurder toevoegen (bedrijf)",
  "Add tenant (person)": "Huurder toevoegen (persoon)",
  "Add UBO": "UBO toevoegen",
  "Add unit": "Voeg eenheid toe",
  "Add user": "Voeg gebruiker toe",
  "Add valuation": "Waardering toevoegen",
  "Add valuation buildings": "Panden toevoegen aan waardering",
  "Add valuator": "Taxateur toevoegen",
  "Add value": "Waarde toevoegen",
  "Add your first building": "Voeg uw eerste pand toe",
  "Add your first mortgage": "Voeg uw eerste lopende financiering toe",
  "Add your first rental contract": "Voeg uw eerste huurcontract toe",
  "Add your first tenant": "Voeg de eerste huurder toe",
  "Added buildings": "Toegevoegde panden",
  "Added to the tariff interest rate when this adjustment applies, in percentage points: +0.10 raises 4.50% to 4.60%, -0.15 lowers it to 4.35%. The applicable adjustments of all groups are summed.": "Wordt bij de tariefrente opgeteld als deze aanpassing geldt, in procentpunten: +0,10 verhoogt 4,50% naar 4,60%, -0,15 verlaagt het naar 4,35%. De geldende aanpassingen van alle groepen worden opgeteld.",
  "Addition": "Toevoeging",
  "Additional building information": "Aanvullende pandinformatie",
  "Additional fee": "Exit fee",
  "additional income required": "aanvullend inkomen vereist",
  "Additional income required": "Aanvullend inkomen vereist",
  "Additional mortgage information": "Aanvullende lopende financiering informatie",
  "Additional remark": "Extra opmerking",
  "AdditionalInformationRequested": "Aanvullende informatie gevraagd",
  "address": "adres",
  "Address": "Adres",
  "Address already financed": "Adres reeds gefinancierd",
  "Address already owned": "Adres reeds in bezit",
  "Address new purchase": "Adres nieuwe aankoop",
  "addresses": "adressen",
  "Addresses": "Adressen",
  "Addresses are being collected and being added to list": "Adressen worden opgehaald en toegevoegd aan de lijst",
  "Addresses on current mortgage not found in land registry": "Adressen op lopende financiering niet gevonden in bij het kadaster",
  "Adjust mortgage": "Aanpassen financiering",
  "Adjust the rental income here": "Pas hier de huuropbrengst aan",
  "Adjust valuations": "Waarderingen aanpassen",
  "Adjust your mortgage": "Pas uw financiering aan",
  "Adjustment": "Aanpassing",
  "Advice": "Advies",
  "Advice based op client profile": "Advies gebaseerd op ingevuld klantprofiel",
  "Advice for contribution own resources and remaining buffer for rental": "Advies voor inbreng eigen geld en resterende buffer voor verhuur",
  "Advice for repayment type, form and fixed-rate interest period": "Advies ten aanzien van aflosvorm, hoogte en rentevast periode",
  "Advice for responsible monthly costs": "Advies ten aanzien van verantwoorde maandlasten",
  "Adviser": "Adviseur",
  "Advisory report": "Adviesrapport",
  "Affordability": "Betaalbaarheid",
  "AFM guideline": "AFM richtlijn",
  "AFM license number": "Afm vergunningsnummer",
  "After": "Na",
  "After realisation": "Na realisatie",
  "After renovation": "Na verbouwing",
  "against": "tegen",
  "AlienDocumentEuOrEaaMemberState": "Alien document EU or EAA member state",
  "Aligning conditions with advisor": "Afstemmen uitgangspunten financiering met adviseur",
  "AligningConditions": "Afstemmen uitgangspunten",
  "All": "Alle",
  "All buildings": "Alle panden",
  "All buildings have at least energy label": "Alle objecten hebben minimaal energielabel",
  "All buildings have energy label at least": "Alle objecten hebben minimaal energielabel",
  "All buildings improve energy label by renovation": "Alle objecten verbeteren energielabel door renovatie",
  "All buildings improve their energy label by renovation": "Alle objecten verbeteren hun energielabel door verbouwing",
  "All document types": "Alle document types",
  "All documents": "Alle documenten",
  "All investment buildings or a selection": "Alle beleggingspanden of een selectie",
  "All proposals": "Alle voorstellen",
  "Allow": "Toestaan",
  "Allow screensharing session": "Wilt u het delen van het scherm toestaan? Sta dit alleen toe wanneer u de bron vertrouwd.",
  "Allowed asset classes": "Toegestane vastgoedcategorieën",
  "Allowed building purposes": "Toegestane bestemmingen",
  "Allowed building statuses": "Toegestane objectstatussen",
  "Allowed financing types": "Toegestane financieringsvormen",
  "Allowed rental usage": "Toegestane wijze van verhuur",
  "Allows consumers": "Toegestaan voor consumenten",
  "Allows professionals": "Toegestaan voor professionals",
  "Already financed": "Reeds gefinancierd",
  "Already financed and new purchase": "Reeds gefinancierd en nieuwe aankoop",
  "Already owned": "Reeds in bezit",
  "Also for ratios": "Ook voor ratio's",
  "Always": "Altijd",
  "Always applies (subject to the repayment variant and duration filters).": "Geldt altijd (binnen de filters op aflosvorm en rentevaste periode).",
  "Amount": "Aantal",
  "Amount collateral": "Bedrag inschrijving",
  "Amount financed": "Bedrag gefinancieerd",
  "Amount of tenants": "Aantal huurders",
  "Amount per year": "Bedrag per jaar",
  "An overview of addresses that are registered with the customer in Unite as 'In possession' and that were not found in the land registry.": "Een overzicht met adressen die in Unite bij de klant staan geregistreerd als 'In bezit' en die niet zijn gevonden in het kadaster.",
  "Analysing document…": "Document analyseren…",
  "and ... other addresses": "... en {{value}} andere adressen",
  "and 1 other address": "en 1 ander adres",
  "and application:": "en aanvraag",
  "and multiple applications": "en meerdere aanvragen",
  "Annually": "Jaarlijks",
  "Annuity": "Annuïteit",
  "Anti speculation clause": "Anti-speculatie beding",
  "Anti speculation clause exit fee": "Anti-speculatie boete",
  "Anti speculation clause exit fee percentage fifth year": "Exit fee anti-speculatiebeding jaar 5 (%)",
  "Anti speculation clause exit fee percentage first year": "Exit fee anti-speculatiebeding jaar 1 (%)",
  "Anti speculation clause exit fee percentage fourth year": "Exit fee anti-speculatiebeding jaar 4 (%)",
  "Anti speculation clause exit fee percentage second year": "Exit fee anti-speculatiebeding jaar 2 (%)",
  "Anti speculation clause exit fee percentage third year": "Exit fee anti-speculatiebeding jaar 3 (%)",
  "Anticipation region": "Anticipeerregio",
  "Any": "Alle",
  "Any building has room rental": "Een object heeft kamerverhuur",
  "Apartment": "Appartement",
  "Applicant name": "Naam van de aanvrager",
  "Applicants": "Aanvragers",
  "Applicants can directly upload documents here and the lender can then check them immediately.": "Aanvragers kunnen hier documenten direct uploaden en de geldverstrekker kan deze vervolgens direct controleren.",
  "Application": "Aanvraag",
  "Application form": "Aanvraagformulier",
  "Application not found": "Aanvraag niet gevonden",
  "Application saved for later": "Aanvraag opgeslagen om later in te dienen",
  "Application status change": "Aanvraag status wijziging",
  "Application submitted": "Aanvraag ingediend",
  "Applications": "Aanvragen",
  "Applies the purchase cap after the renovation step instead of before it. The cap then also limits the part of the loan that comes from renovation costs. Off (default): the purchase cap applies first and renovation costs can be added on top.": "Past het maximum op basis van aankoop toe na de verbouwingsstap in plaats van ervoor. Het maximum begrenst dan ook het deel van de lening dat uit verbouwingskosten komt. Uit (standaard): eerst het maximum op basis van aankoop, daarna kunnen verbouwingskosten erbij.",
  "Applies to": "Geldt voor",
  "Apply for financing": "Financiering aanvragen",
  "Apply for refinancing": "Herfinanciering aanvragen",
  "Archived": "Gearchiveerd",
  "Are the valuations ready and received to be completed?": "Zijn de waarderingen gereed én ontvangen om te worden ingevoerd?",
  "Are there any further particularities?": "Zijn er nog bijzonderheden?",
  "Are there other buildings valuated?": "Zijn er nog andere panden gewaardeerd?",
  "Are you planning to change (renovate) this building?": "Bent u van plan dit pand te veranderen / verbouwen?",
  "Are you planning to split this building in multiple buildings?": "Bent u van plan dit pand te splitsen over meerdere panden?",
  "Are you sure you want to close ...?": "Weet u zeker dat u {{value}} wilt sluiten?",
  "Are you sure you want to complete ...?": "Weet u zeker dat u {{value}} wilt afronden?",
  "Are you sure you want to delete ...?": "Weet u zeker dat u {{value}} wilt verwijderen?",
  "Arrangements": "Afspraken",
  "Ask for a non-committal application": "Vraag vrijblijvend een offerte aan",
  "Ask the client to update the current rental list": "Vraag de klant om de actuele huurlijst bij te werken",
  "Asset class": "Vastgoedcategorie",
  "Assign the remaining share to": "Wijs het resterende aandeel toe aan",
  "Assigned to": "Toegekend aan",
  "Association": "Vereniging",
  "at": "op",
  "At least one building is let by the room.": "Minimaal één object wordt per kamer verhuurd.",
  "at start": "bij aanvang",
  "AtParents": "Bij ouders",
  "AtPartner": "Bij partner",
  "Attach file": "Bestand bijvoegen",
  "Audit log": "Auditlogboek",
  "Authority": "Bevoegdheid",
  "Authorization": "Authorisatie",
  "Authorization expired": "Authorisatie verlopen",
  "Authorization granted": "Authorisatie verleend",
  "Authorization required": "Autorisatie vereist",
  "Authorize": "Autoriseren",
  "Automated": "Modelmatig",
  "Board member": "Bestuurder",
  "Director": "Directeur",
  "Director added": "Bestuurder toegevoegd",
  "Director updated": "Bestuurder bijgewerkt",
  "Directors": "Bestuurders",
  "Does not sign on behalf of the company": "Tekent niet namens de B.V.",
  "Edit director": "Bestuurder wijzigen",
  "Edit shareholder": "Aandeelhouder wijzigen",
  "Enter a share between 0 and 100": "Vul een aandeel tussen 0 en 100 in",
  "former": "voormalig",
  "Function": "Functie",
  "Jointly authorized": "Gezamenlijk bevoegd",
  "Limited authority": "Beperkt bevoegd",
  "Managing director": "Algemeen directeur",
  "Not yet assigned to other shareholders": "Nog niet toegewezen aan andere aandeelhouders",
  "Proxy holder": "Gevolmachtigde",
  "Search person or company": "Zoek persoon of bedrijf",
  "Shareholder added": "Aandeelhouder toegevoegd",
  "Shareholder updated": "Aandeelhouder bijgewerkt",
  "Signs on behalf of the company": "Tekent namens de B.V.",
  "Solely authorized": "Zelfstandig bevoegd",
  "Statutory director": "Statutair directeur",
  "Supervisory director": "Commissaris",
  "The shares add up to": "De aandelen tellen op tot",
  "This customer is already a shareholder": "Deze klant is al aandeelhouder",
  "Value models (AVM)": "Waardemodellen (AVM)",
  "Automatic interest rate reduction upon repayment": "Automatische rentedaling bij aflossen",
  "Automatically generate financing proposals": "Automatisch financieringsvoorstellen genereren",
  "Automatically renewed": "Automatisch vernieuwd",
  "Automatically request valuation at": "Vraag digitaal de waardering aan bij",
  "AutomaticallyRenewed": "Automatisch vernieuwd",
  "Available income for loan per month": "Beschikbaar inkomen voor lening per maand",
  "Available own resources": "Beschikbare eigen middelen",
  "Available soon": "Binnenkort beschikbaar",
  "average p/m": "gemiddeld p/m",
  "AVM added": "AVM toegevoegd",
  "Back": "Terug",
  "Back to automatically search for addresses": "Terug naar automatisch een adres zoeken",
  "Bad": "Slecht",
  "Bad to moderate": "Slecht tot matig",
  "Balance for taxable profit per year": "Saldo fiscale winst",
  "Balance for taxable profit tax partner per year": "Saldo fiscale winst fiscaal partner",
  "Bank account (IBAN)": "Bankrekening (IBAN)",
  "BankAndSavingBalances": "Bank en spaartegoeden",
  "Based on": "Gebaseerd op",
  "Based on:": "Op basis van:",
  "Basic rent": "Kale huur",
  "Basic rent per month": "Kale huur per maand",
  "BasicRent": "Basis huur",
  "Before": "Voor",
  "Before you can create a rental contract you need to a building": "Voordat u een huurcontract kunt aanmaken dient u een pand in te voeren",
  "Best ROE": "Beste ROE",
  "Big cities are never excluded": "Grote steden zijn nooit uitgesloten",
  "Big city": "Grote stad",
  "Big city, good energy label": "Grote stad, goed energielabel",
  "Birthdate": "Geboortedatum",
  "Block the account": "Toegang tot de mijn-omgeving blokkeren",
  "Blocked": "Geblokkeerd",
  "Borrower": "Kredietnemer",
  "Borrowers": "Kredietnemers",
  "Both": "Beiden",
  "Both variants": "Beide aflosvormen",
  "Bought off until": "Afgekocht tot",
  "Box 3 analysis": "Box 3 analyse",
  "Box 3 analysis report not available for a company": "Box 3 analyserapport is niet beschikbaar voor een rechtspersoon",
  "building": "pand",
  "Building": "Pand",
  "Building 1": "Pand 1",
  "Building deposit": "Bouwdepot",
  "Building details": "Pand informatie",
  "Building documents": "Pand documenten",
  "Building information": "Pand informatie",
  "Building information complete": "Pandinformatie compleet",
  "Building information incomplete": "Pandinformatie incompleet",
  "Building information sufficient": "Pandinformatie voldoende",
  "Building is being renovated": "Pand wordt verbouwd",
  "Building selection": "Pand selectie",
  "Building type": "Pand type",
  "Building types the rate does not finance, even though their asset class is allowed. Also checked for the units of a combination building.": "Soorten objecten die het tarief niet financiert, ook al is hun vastgoedcategorie toegestaan. Geldt ook voor de units van een combinatiepand.",
  "BuildingDeposit": "Bouwdepot",
  "buildings": "panden",
  "Buildings": "Panden",
  "Buildings to be financed": "Te financieren adressen",
  "Business": "Bedrijfsruimte",
  "Business address": "Bezoekadres",
  "Businesses": "Bedrijven",
  "BusinessSpace": "Bedrijfsruimte",
  "by": "door",
  "By address": "Via adres",
  "By non-residential share and count": "Op basis van niet-residentieel aandeel en aantal",
  "By owned address": "Adres in bezit",
  "By paying ... in advance": "Door vooraf <strong>{{value}}</strong> te betalen",
  "By reserving ...": "Door <strong>{{value}}</strong> te reserveren",
  "By special rental we mean: sublease, short stay, rental to a non-family or migrant workers and multiple rental contracts.": "Onder bijzonder verhuur verstaan wij: onderverhuur, short-stay, verhuur aan niet-familie of arbeidsmigranten en meerdere huurcontracten.",
  "Cache folder": "Cache map",
  "Cadastral charges will apply": "Kadastrale kosten zijn van toepassing (€ 2,80)",
  "Cadastral designation": "Kadastrale aanduiding",
  "Cadastral designations": "Kadastrale aanduidingen",
  "Cadastral id": "Kadastrale identificatie",
  "Cadastral id not configured": "Kadaster id niet ingesteld",
  "Cadastral id updated": "Kadastraal identificatie bijgewerkt",
  "Cadastral identifier": "Kadaster identificatie",
  "Cadastral known as": "Kadastraal bekend als",
  "Cadastral object": "Kadastraal object",
  "Cadastral object identification": "Kadastraal objectidentificatie",
  "Cadastral registration": "Hypothecaire inschrijving",
  "cadastral registration": "kadastrale registratie",
  "cadastral registrations": "kadastrale registraties",
  "Cafe": "Café",
  "Calculate": "Bereken voorstellen",
  "Calculate net initial yield": "Bereken netto aanvangsrendement",
  "Calculate penalty interest": "Bereken boeterente",
  "Calculate proposals": "Financieringsvoorstellen berekenen",
  "Calculate value in rented condition": "Waarde in verhuurde staat berekenen",
  "Calculated": "Berekend",
  "Calculated on": "Berekend op",
  "Calculated points": "Berekende punten",
  "CalculateNetInitialYield": "Bereken NAR",
  "CalculateNetInitialYieldAfterRenovation": "Bereken NAR na verbouwing",
  "Calculating highest loan": "Hoogste lening berekenen",
  "Calculating market rent": "Markthuur berekenen",
  "Calculating proposals": "Voorstellen worden berekend",
  "Calculation method": "Berekenmethode",
  "Calculations": "Berekeningen",
  "CalculationType": "Berekeningstype",
  "Can be used as a residence without a permit": "Bruikbaar als woning zonder vergunning",
  "Can not find the right the postalcode / house number": "Kan juiste postcode / huisnummer niet selecteren",
  "Cancel": "Annuleren",
  "Cancel application": "Aanvraag annuleren",
  "Canceled": "Geannuleerd",
  "Cancellation date": "Opzegdatum",
  "Cancellation fees": "Annuleringskosten",
  "Cancellation period": "Opzegtermijn",
  "Cancellation period of contract in months": "Opzegtermijn van het contract in maanden",
  "Cancelled": "Geannuleerd",
  "Cancelled RC": "Opgezegd",
  "Cannot calculate penalty interest": "Boeterente kan niet worden berekend",
  "Cannot find a matching financing result": "Kan geen nieuwe financiering vinden",
  "Cap on purchase + planned renovation (see \"Capped by planned investment\").": "Maximum op aankoop + geplande verbouwing (zie \"Begrensd door geplande investering\").",
  "Capped by planned investment": "Begrensd door geplande investering",
  "Capped by value": "Begrensd door waarde",
  "Capped by value vacant": "Begrensd door leegwaarde",
  "Caps the loan at the maximum LTV of the vacant value when a vacant value is known; an extra safety cap on top of the value in rented condition.": "Begrenst de lening op de maximale LTV van de leegwaarde als die bekend is; een extra begrenzing bovenop de waarde in verhuurde staat.",
  "Carried out by a (main) contractor": "Uitgevoerd door een (hoofd-)aannemer",
  "Cash on cash": "Cash on cash",
  "Cashflow progress": "Cashflow opbouw",
  "Categorize": "Koppelen",
  "Categorize document": "Categoriseer document",
  "Category": "Categorie",
  "Caution": "Let op",
  "Chamber of commerce number": "KvK-nummer",
  "Change selection": "Wijzig selectie",
  "Changes are only applied to newly created financings.": "Aanpassingen worden alleen toegepast op nieuwe berekeningen.",
  "Changes are saved to the calculation service and apply to new calculations of every organization using this rate.": "Wijzigingen worden opgeslagen in de berekening en gelden voor nieuwe berekeningen van elke organisatie die dit tarief gebruikt.",
  "Changing the existing renovation details will delete previous renovations": "Als bestaande verbouwingsgegevens worden aangepast, worden eerdere verbouwingen verwijderd.",
  "Characteristic": "Kenmerk",
  "Chat": "Bericht",
  "Check": "Controleren",
  "Check owners of this address": "Controleer eigenaren van dit adres",
  "Check the company data found in the Land Registry with the data noted in Unite. The data from the land register is the data recorded at the last acquisition of this company.": "Controleer de bedrijfsgegevens die gevonden zijn in het kadaster met de gegevens die genoteerd zijn in Unite. De gegevens uit het kadaster zijn de gegevens die bij de laatste verkrijging van dit bedrijf zijn geregistreerd door de notaris.",
  "Check the fields that you want to update with the data from the land registry.": "Vink de velden aan die u wilt bijwerken met de gegevens uit het Kadaster.",
  "Check the personal data found in the Land Registry with the data recorded in Unite. The data from the land register is the data that was registered with the last acquisition of this person.": "Controleer de persoonsgegevens die gevonden zijn in het kadaster met de gegevens die genoteerd zijn in Unite. De gegevens uit het kadaster zijn de gegevens die bij de laatste verkrijging van deze persoon zijn geregistreerd door de notaris.",
  "Check the rental income": "Controleer de huuropbrengst",
  "Check the values that you want to copy to the building": "Vink de waardes aan die u wilt overschrijven naar het pand",
  "Check the values that you woulde like to override": "Vink de waardes aan die u wilt overschrijven",
  "Checked": "Gecontroleerd",
  "Checking cadastral ids": "Kadaster identificatie nummers worden gecontroleerd",
  "Checking the customers investment profile": "Bezig met controleren van de klant zijn beleggingsprofiel",
  "Choose a document": "Kies een document",
  "Choose another document": "Kies een ander document",
  "Choose your desired lender": "Kies uw gewenste geldverstrekker",
  "Choose your profile": "Kies uw profiel",
  "city": "Plaats",
  "City": "Stad",
  "Clear conversation": "Gesprek wissen",
  "Click": "Klik",
  "Client": "Klant",
  "Client adviser": "Klant adviseur",
  "Client dashboard": "Klant dashboard",
  "Client details": "Klantinformatie",
  "Client documents (including related clients)": "",
  "Client type": "Type klant",
  "Clients": "Klanten",
  "Close": "Sluit",
  "Closed": "Afgerond",
  "Closing": "Closing",
  "Closing commission": "Afsluitprovisie",
  "Closing commission is not refunded in case of interim repayment.": "Afsluitprovisie wordt niet terugbetaald bij tussentijdse aflossing.",
  "Closing fee": "Afsluitprovisie",
  "Code": "Code",
  "Collaboration": "Samenwerking",
  "Collaboration information": "Samenwerkingsinformatie",
  "Collaboration members": "Leden van samenwerking",
  "Collaborations": "Samenwerkingen",
  "Collaborations / purchase information / groundlease": "Samenwerkingen / koopsom / erfpacht",
  "Collaborations are put together by collecting the owners of each cadastral designation on the object list entitled to the land registry. A collaboration is proposed for every combination of owner and ownership relationship.": "Samenwerkingen worden samengesteld door van iedere kadastrale aanduiding (perceel of appartementsrecht) de eigenaren op te halen. Voor iedere combinatie van eigenaar en eigendomsverhouding wordt een samenwerking voorgesteld.",
  "Collaborations were not included in this report, building might be owned by multiple owners": "Samenwerkingen zijn niet meegenomen in dit rapport, gevonden panden kunnen meerdere eigenaren hebben",
  "Collateral type": "Type onderpand",
  "Collateral value": "Waarde onderpand",
  "CollectingAdditionalInformation": "Aanvullende gegevens verzamelen",
  "CollectingInformation": "Gegevens verzamelen",
  "Combination": "Combinatiepand",
  "combination building": "combinatiepand",
  "Combination building": "Combinatiepand",
  "Combination building by its non-residential value share.": "Combinatiepand naar het aandeel niet-residentiële waarde.",
  "Combination building in a portfolio of more than two combination buildings.": "Combinatiepand in een portefeuille met meer dan twee combinatiepanden.",
  "Combination building with mixed units.": "Combinatiepand met gemengde units.",
  "Combination building with only residential units.": "Combinatiepand met alleen woonunits.",
  "Combination building, non residential share above 60%": "Combinatiepand, niet-residentieel aandeel boven 60%",
  "Combination building, non residential share up to 40%": "Combinatiepand, niet-residentieel aandeel tot 40%",
  "Combination building, non residential share up to 50%": "Combinatiepand, niet-residentieel aandeel tot 50%",
  "Combination building, non residential share up to 60%": "Combinatiepand, niet-residentieel aandeel tot 60%",
  "Combination buildings": "Combinatiepanden",
  "Combination calculation": "Combinatieberekening",
  "Combination calculation pending": "Combinatieberekening ingepland",
  "Combination calculation running": "Combinatieberekening loopt",
  "Combination portfolio": "Portefeuille met combinatiepanden",
  "Combinations": "Combinaties",
  "Combined buildings": "Combinatiepanden",
  "Combined proposals": "Combinatie berekeningen",
  "Combining fixed interest periods": "Combineren rentevast perioden",
  "Coming": "Komende",
  "Commercial": "Commercieel",
  "Commercial building.": "Commercieel object.",
  "Commercial rental": "Commerciele verhuur",
  "Commercial rental property conversion": "Commerciele uitponding",
  "CommercialRental": "Commerciele verhuur",
  "CommercialRentalPropertyConversion": "Commerciele uitponding",
  "Commission": "Provisie",
  "Commission amount": "Provisiebedrag",
  "Commission lender": "Provisie geldverstrekker",
  "Commission percentage": "Provisie percentage",
  "Commission with renovation": "Provisie bij renovatie",
  "Company": "Bedrijf",
  "Company corporation tax": "Onderneming vennootschapsbelasting",
  "Company income tax": "Onderneming inkomstenbelasting",
  "Company information": "Bedrijfsinformatie",
  "Company name": "Bedrijfsnaam",
  "CompanyCorporationTax": "Onderneming vennootschapsbelasting",
  "CompanyIncomeTax": "Onderneming inkomstenbelasting",
  "Compared to LTV": "Vergeleken met LTV",
  "Compensation": "Vergoeding",
  "Compensations": "Vergoedingen",
  "Complete": "Voltooien",
  "Complete the renovation": "Verbouwing voltooien",
  "Complete the split": "Splitsing voltooien",
  "Completed": "Voltooid",
  "Completed date": "Datum voltooid",
  "Completed renovation costs are added to the purchase amount before the purchase cap is applied, so a recently bought and already renovated building is capped on purchase amount + renovation.": "Afgeronde verbouwingskosten worden bij het aankoopbedrag opgeteld voordat het maximum op basis van aankoop wordt toegepast, zodat een recent gekocht en al verbouwd object begrensd wordt op aankoopbedrag + verbouwing.",
  "Completion date": "Datum klaar",
  "Completion guarantee": "Afbouwgarantie",
  "Compositions": "Combinaties",
  "Concept": "Concept",
  "Concept application": "Conceptaanvraag",
  "Concept mortgage": "Concept lopende financiering",
  "Condition": "Voorwaarde",
  "Conditions": "Voorwaarden",
  "Configuration check": "Configuratiecontrole",
  "Confirm": "Bevestig",
  "Confirm term sheet documents": "Bevestig de documenten van de indicatieve offerte",
  "Connect": "Verbinden",
  "Connect mortgage": "Koppel lopende financiering",
  "Connect to existing mortgage": "Koppel aan bestaande lopende financiering",
  "Connect to this customer": "Verbind aan deze klant",
  "Connected addresses": "Verbonden adressen in bezit",
  "Conservatory": "Conservatoir",
  "Construction deposit": "Bouwdepot",
  "construction year": "Bouwjaar",
  "Construction year": "Bouwjaar",
  "ConstructionYear": "Bouwjaar",
  "Consult": "Adviesgesprek",
  "Consumer": "Consument",
  "Consumers": "Consumenten",
  "Contact": "Contact",
  "Contact details": "Contactgegevens",
  "Contact information": "Contactgegevens",
  "Contact person": "Contactpersoon",
  "Contact/UBO": "Contactpersoon/UBO",
  "Continue as professional": "Doorgaan als professional",
  "Contract duration": "Contractduur",
  "Contract number (or reference)": "Contractnummer (of referentie)",
  "Contract status": "Status van het contract",
  "Contribution own resources": "Inbreng eigen middelen",
  "Contribution to housing costs per month": "Kostgeld per maand",
  "Conversation report": "Gespreksverslagen",
  "Cooperation": "Cooperatie",
  "Cost buyer": "Kosten koper",
  "Costs": "Kosten",
  "Costs buyer": "Kosten koper",
  "Could not reach the assistant. Please try again.": "De assistent is niet bereikbaar. Probeer het opnieuw.",
  "Country": "Land",
  "Coverage ratios": "Dekkingsgraad",
  "Coverage ratios (after 5 year)": "Dekkingsgraad (na 5 jaar)",
  "Create account": "Account aanmaken",
  "Create an arrangement": "Maak afspraak",
  "Create application": "Aanvraag aanmaken",
  "Create collaboration": "Samenwerking aanmaken",
  "Create customer & start VIR": "Klant aanmaken & VIR starten",
  "Create discount arrangement": "Maak kortingsafspraak",
  "Create lender": "Geldverstrekker aanmaken",
  "Create loan part": "Maak leningdeel",
  "Create new application": "Maak een nieuwe aanvraag aan",
  "Create new building": "Maak nieuw pand",
  "Create new client": "Maak nieuwe klant",
  "Create new financing": "Maak nieuwe financiering",
  "Create new mortgage": "Maak nieuwe lopende financiering",
  "Create new ongoing mortgage": "Maak nieuwe lopende financiering",
  "Create new rental contract": "Maak nieuw huurcontract",
  "Create new report": "Maak nieuw rapport",
  "Create new room": "Maak nieuwe kamer",
  "Create new scale": "Maak nieuwe schaal",
  "Create new task": "Maak nieuwe taak",
  "Create new tenant": "Maak nieuwe huurder",
  "Create new unit": "Maak nieuwe eenheid",
  "Create new user": "Gebruiker toevoegen",
  "Create new valuation": "Nieuwe waardering toevoegen",
  "Create own lender rate": "Maak eigen banktarief",
  "Create own offer": "Maak eigen aanbieding",
  "Create profile": "Profiel aanmaken",
  "Create rate": "Tarief aanmaken",
  "Create version": "Versie aanmaken",
  "Created": "Aangemaakt",
  "Created at": "Aangemaakt op",
  "Created by": "Aangemaakt door",
  "Creating collaboration": "Samenwerking aanmaken",
  "Creating financing": "Berekening wordt aangemaakt",
  "Credit interest": "Creditrente",
  "Credit proposal": "Kredietvoorstel",
  "Credits": "Kredieten",
  "Criminal": "Strafrechterlijk",
  "Critical": "Kritisch",
  "CryptoCurrency": "Crypto geld",
  "current": "huidig",
  "Current": "Huidig",
  "Current document": "Huidig document",
  "Current interest": "Huidige rente",
  "Current LTV": "Huidige LTV",
  "Current mortgage": "Huidige financiering",
  "Current rent income": "Huidige huuropbrengst",
  "Current state": "Huidige status",
  "Current value": "Huidige waarde",
  "Currently financed": "Nu gefinancierd",
  "Currently rented out": "Op dit moment verhuurd",
  "CurrentRentIncome": "Huidige huuropbrengst",
  "Custom": "Zelfgemaakt",
  "Custom application": "Maatwerk aanvraag",
  "Customer": "Klant",
  "Customer has been created and VIR has been started": "Klant is aangemaakt en VIR is gestart",
  "Customer is already in the list": "Klant staat al in de lijst",
  "Customer label": "Klant label",
  "customers": "klanten",
  "Customers": "Klanten",
  "customized": "maatwerk",
  "Customized": "Maatwerk",
  "Customized report": "Maatwerk rapport",
  "Dashboard": "Dashboard",
  "Data unknown": "Gegevens onbekend",
  "Date": "Datum",
  "Date of the valuation": "Datum waardering",
  "Dates": "Datums",
  "Days": "Dagen",
  "days": "dagen",
  "days from": "dagen vanaf",
  "Days until reset window": "Dagen tot bedenktijd",
  "Debt or obligations charges": "Schuldenlast",
  "Debt service coverage ratio": "Debt service coverage ratio",
  "Debt yield": "Lening lasten dekking",
  "Debtors Risk": "Debiteurenrisico",
  "DebtorsRisk": "Debiteurenrisico",
  "Debts (not related to real estate)": "Schulden (geen betrekking op onroerend goed)",
  "Debts on real estate": "Schulden op onroerend goed",
  "Debts or obligations": "Schulden of verplichtingen",
  "DebtYieldNetRentResidential": "Lening lasten dekking netto huur residentieel",
  "DebtYieldRatioGrossRent": "LLD Bruto huur",
  "DebtYieldRatioGrossRentResidential": "LLD Bruto huur residentieel",
  "DebtYieldRatioNetRent": "LLD Netto huur",
  "DebtYieldRatioNetRentResidential": "LLD Netto huur residentieel",
  "Default": "Standaard",
  "Default mediation fee": "Standaard bemiddelingskosten",
  "Default valuation costs": "Standaard taxatiekosten",
  "Delete": "Verwijder",
  "Delete lender?": "Geldverstrekker verwijderen?",
  "Delete link": "Verwijder koppeling",
  "Delete link with mortgage": "Verijder koppeling met financiering",
  "Delete rate": "Tarief verwijderen",
  "Delete rate?": "Tarief verwijderen?",
  "deleted": "verwijderd",
  "Deleted": "Verwijderd",
  "Deleted buildings": "Verwijderde panden",
  "Deliver document": "Document aanleveren",
  "Delivery deed price": "Kosten leveringsakte",
  "Deny": "Weigeren",
  "Descripition": "Omschrijving",
  "Description": "Beschrijving",
  "Detach document": "Ontkoppel document",
  "Details": "Details",
  "Details of the renovation": "Details van de verbouwing",
  "Did the previous owner own the property for more than 6 months on the date the current owner acquired the property?": "Had de vorige eigenaar het pand langer dan 6 maanden in eigendom op de datum dat de huidige eigenaar het pand in bezit heeft verkregen?",
  "Did you split this property over multiple buildings?": "Heeft u dit pand gesplitst over meerdere panden?",
  "Direct check out: loan": "Direct uitboeken: lening",
  "Directly": "Nu direct",
  "Disagio": "Disagio",
  "Discontinue": "Beëindigen",
  "Discontinue rate": "Tarief beëindigen",
  "Discontinuing closes the current version on the given day; from then on the rate is no longer offered to any organization. It can be resumed later.": "Beëindigen sluit de huidige versie af op de opgegeven dag; vanaf dan wordt het tarief aan geen enkele organisatie meer aangeboden. Het kan later worden hervat.",
  "Discount": "Korting",
  "Discount arrangements": "Kortingsafspraken",
  "Discount per lender": "Korting per geldverstrekker",
  "Discount percentage": "Korting percentage",
  "Discriminator": "Onderscheid",
  "Distribution of building type": "Verdeling van het type pand",
  "Distribution of energy label": "Verdeling energielabels",
  "Distribution of free sector and social rent": "Verdeling van vrije sector en sociale huur",
  "Distribution of rent income (free sector or social rent)": "Verdeling van huurinkomsten (vrije sector of sociale huur)",
  "Distribution of rent income (residential or non-residential)": "Verdeling van huurinkomsten (residentieel of non-residentieel)",
  "district": "Buurt",
  "Divide loan over buildings": "Verdeel lening over panden",
  "Divide operating costs": "Verdeel exploitatiekosten",
  "Divide pro rato": "Verdeel pro rato",
  "Divide purchase value over units": "Verdeel de aankoopkosten over de eenheden",
  "Divide renovation costs over units": "Verdeel de verbouwingskosten over de eenheden",
  "Divide rental income": "Verdeel huuropbrengst",
  "Divide rental value": "Verdeel huurwaarde",
  "Divide repayment amount over buildings": "Verdeel de aflossing over panden",
  "Divide value in rented condition": "Verdeel waarde in verhuurde staat",
  "Divide value over buildings": "Verdeel waarde over panden",
  "Divide value vacant": "Verdeel leegwaarde",
  "DividendPayment": "Dividend uitkering",
  "Divorce": "Scheiding",
  "Do not offer this period in this class": "Deze periode niet aanbieden in deze klasse",
  "Do not use the appraised values ​​(younger than 1 year old) when calculation financing proposals.": "Negeer gewaardeerde waardes (jonger dan 1 jaar oud) bij het berekenen van financieringsvoorstellen.",
  "Do you want a duration shorter or longer than 2 years?": "Wenst u een financiering met een looptijd langer dan 2 jaar?",
  "Do you want to create a new application or overwrite an existing?": "Wilt u een nieuwe aanvraag maken of een bestaande aanvraag bijwerken?",
  "Do you want to finance the renovation costs?": "Wilt u de verbouwingskosten financieren?",
  "Do you wish to finance other buildings?": "Wenst u nog andere panden mee te financieren?",
  "Do you wish to merge other buildings?": "Wil u nog andere panden toevoegen om samen te voegen?",
  "Do you wish to move all selected buildings to the same customer?": "Wenst u alle geselecteerde panden naar dezelfde klant te verplaatsen?",
  "Do you wish to move other buildings?": "Wilt u nog andere panden verplaatsen?",
  "Document": "Document",
  "Document concerns": "Document betreft",
  "Document details": "Documentinformatie",
  "Document management": "Documentbeheer",
  "Document name": "Documentnaam",
  "Document number": "Documentnummer",
  "Document search": "Document zoeken",
  "Document sent": "Document verzonden",
  "Document type": "Documentsoort",
  "Documents": "Documenten",
  "Documents to check": "Te controleren documenten",
  "Documents to send": "Aan te leveren documenten",
  "DocumentsAtTheNotary": "Stukken bij de notaris",
  "DocumentStatusAccepted": "Goedgekeurd",
  "DocumentStatusAcceptedByLender": "Goedgekeurd door {{name}}",
  "DocumentStatusReceived": "Doorsturen aan {{name}}",
  "DocumentStatusReceivedByLender": "Verzonden aan {{name}}",
  "DocumentStatusRejected": "Afgekeurd",
  "DocumentStatusRejectedByLender": "Afgekeurd door {{name}}",
  "DocumentStatusRequest": "Opvragen bij klant",
  "DocumentStatusRequested": "Opgevraagd bij klant",
  "DocumentType": "Documenttype",
  "Does ... own dutch real estate?": "Heeft {{value}} Nederlands vastgoed in bezit?",
  "Does repayment apply?": "Is er aflossing van toepassing?",
  "Does the customer act in the exercise of a profession or business?": "Handelt de klant in de uitoefening van beroep of bedrijf?",
  "Does the customer has income from his own business?": "Heeft de klant ook inkomen uit zijn/haar bedrijf?",
  "Does the customer have any debts or obligations?": "Heeft de klant schulden of verplichtingen?",
  "Does the customer have buildings for rent?": "Heeft de klant panden in bezit voor de verhuur?",
  "Does the customer want to include the income of its tax partner?": "Wil de klant het inkomen van zijn of haar fiscaal partner meerekenen?",
  "Does the customer's tax partner has income from his/her own business?": "Heeft de fiscaal partner van klant ook inkomen uit zijn/haar bedrijf?",
  "Does the student loan fall under the new loan system?": "Valt uw studieschuld onder het nieuwe leenstelsel?",
  "Donation": "Schenking",
  "Done": "Klaar",
  "Done, continue": "Klaar, doorgaan",
  "Download": "Download",
  "Download building overview": "Download pandenlijst",
  "Download documents": "Download documenten",
  "Download form": "Download formulier",
  "Download rental contracts": "Download huurlijst",
  "Download rental contracts (anonymized)": "Download huurlijst (geanonimiseerd)",
  "download report": "download rapport",
  "Download report": "Rapport downloaden",
  "Download the rental list from Unite": "Download de huurlijst uit Unite",
  "Draft application": "Conceptaanvraag maken",
  "Draft application created": "Conceptaanvraag aangemaakt",
  "Draft applications created": "Conceptaanvragen aangemaakt",
  "Drag and drop files here": "Sleep uw bestanden hier naartoe",
  "Drag or drop a file from your device or search for an existing document in Unite.": "Sleep een bestand van je apparaat of selecteer een bestaand document in Unite",
  "Draws": "Trekkingen",
  "DSCR": "DSCR",
  "DSCR (Gross Rent Residential)": "DSCR (Bruto huur residentieel)",
  "DSCR (Gross Rent)": "DSCR (Bruto huur)",
  "DSCR (Net Rent Residential)": "DSCR (Netto huur residentieel)",
  "DSCR (Net Rent)": "DSCR (Netto huur)",
  "DSCR Gross Rent": "DSCR Bruto Huur",
  "DSCR Gross Rent (5 year)": "DSCR Bruto Huur (5 jaar)",
  "DSCR Gross Rent Residential": "DSCR Bruto Huur Residentieel",
  "DSCR Gross Rent Residential (after renovation)": "DSCR Bruto Huur Residentieel (na verbouwing)",
  "DSCR Net Rent": "DSCR Netto Huur",
  "DSCR Net Rent (5 year)": "DSCR Netto Huur (5 jaar)",
  "DSCR Net Rent (after renovation)": "DSCR Netto Huur (na verbouwing)",
  "DSCR Net Rent Income": "DSCR Netto huuropbrengst",
  "DSCR Net Rent Residential": "DSCR Netto Huur Residentieel",
  "DscrGrossRent": "DSCR bruto huur",
  "DscrGrossRentResidential": "DSCR bruto huur residentieel",
  "DscrNetRent": "DSCR netto huur",
  "DscrNetRentResidential": "DSCR netto huur residentieel",
  "Due Diligence": "CDD",
  "DueDiligenceExplanation": "CDD uitleg",
  "DueDiligenceResult": "CDD",
  "Duration": "Duur",
  "Duration in months": "Looptijd in maanden",
  "Duration of the renovations": "Duur van de verbouwing",
  "Duration:": "Duur:",
  "DurationInMonths": "Looptijd in maanden",
  "During closing, the application is converted to ongoing mortgage. This action cannot be undone.": "Tijdens het sluiten wordt de applicatie omgezet in lopende hypotheek. Deze actie kan niet ongedaan gemaakt worden.",
  "Dutch": "Nederlands",
  "DutchAliensDocument": "Nederlands vreemdelingendocument",
  "DutchAliensIdentityCard": "Nederlandse asielzoeker identiteitskaart",
  "DutchIdentityCard": "Nederlandse identiteitskaart",
  "DutchPassport": "Nederlands paspoort",
  "DY": "LLD",
  "DY (Net Rent)": "LLD (Netto huur)",
  "DY Gross Rent": "LLD Bruto Huur",
  "DY Gross Rent (5 year)": "LLD Bruto Huur (5 jaar)",
  "DY Gross Rent Residential": "LLD Bruto Huur Residentieel",
  "DY Net Rent": "LLD Netto Huur",
  "DY Net Rent (5 year)": "LLD Netto Huur (5 jaar)",
  "DY Net Rent Residential": "LLD Netto Huur Residential",
  "E-mailing and uploading documents is a time-consuming and error-prone job.": "Documenten e-mailen en uploaden is een tijdrovende en foutgevoelige klus.",
  "Each line must be a postcode of four digits and the category, separated by a semicolon": "Elke regel moet een postcode van vier cijfers en de categorie bevatten, gescheiden door een puntkomma",
  "Each member of this collaboration needs to provide details about their investment profile before we can show the right financing proposals": "Ieder lid van deze samenwerking dient informatie te verschaffen over zijn beleggingsprofiel voordat we de juiste financieringsmogelijkheden kunnen tonen",
  "Edit": "Bewerk",
  "Edit account": "Bewerk gebruiker",
  "Edit AVM": "AVM bewerken",
  "Edit client": "Bewerk klant",
  "Edit document": "Bewerk document",
  "Edit due diligence fields": "Bewerk CDD",
  "Edit income": "Inkomen bijwerken",
  "Edit information": "Bewerk informatie",
  "Edit postcodes": "Postcodes bewerken",
  "Edit profile": "Profiel bijwerken",
  "Edit regions": "Regio's bewerken",
  "Edit rental contract": "Bewerk huurcontract",
  "Edit situation fields": "Bewerk situatie velden",
  "Edit tenant": "Bewerk huurder",
  "Edit the value in rented condition per address below": "Bewerk de waarde in verhuurde staat in onderstaande tabel",
  "Edit valuator": "Taxateur bewerken",
  "Eligibility": "Acceptatiecriteria",
  "Email": "Email",
  "Employment": "Loondienst",
  "Empty": "Leeg",
  "Enabled": "Actief",
  "End date": "Einddatum",
  "End date contract": "Einddatum contract",
  "End date fixed-rate period": "Datum einde rentevast periode",
  "EndDate": "Einddatum",
  "Energy index": "Energie-Index",
  "Energy label": "Energielabel",
  "Energy label after renovation": "Energielabel na verbouwing",
  "Energy label based on rental value and operating costs": "Energielabel gabaseerd op de huurwaarde en exploitatiekosten",
  "Energy label expiry date": "Energielabel einddatum",
  "Energy performance expiry date": "Energieprestatie verloopdatum",
  "Energy performance registration date": "Energieprestatie registratiedatum",
  "EnergyIndex": "Energie index",
  "EnergyLabelAfterRenovation": "Energielabel na verbouwing",
  "English": "Engels",
  "Enter an address ... owns": "Voer een adres in dat {{value}} bezit",
  "Enter an address this customer owns": "Voer een adres in dat in bezit is van deze klant",
  "Enter manually": "Handmatig invoeren",
  "Enter the address by street or postal code": "Voer het adres in op basis van straat of postcode",
  "Enter the address manually": "Adres handmatig invoeren",
  "Enter the address of which we will retrieve the owners": "Voer het adres in waarvan de we de eigenaars moeten ophalen",
  "Enter the effective interest discount (50 basis points discount = 0.5%)": "Voer de effectieve rente korting in (50 basispunten korting = 0.5%)",
  "Enter the land registry settings. Entering wrong settings might cause VIR and other cadastral features to fail.": "Vul de kadaster instellingen in. Het invullen van onjuiste instellingen kan er voor zorgen dat VIR en andere kadastrale functies niet meer werken.",
  "Enter your valuation details here": "Voer hier uw waarderingsgegevens in",
  "entered on": "ingevoerd op",
  "Entities": "Entiteiten",
  "Entity": "Entiteit",
  "Equal date and duration": "Gelijke datum en duur",
  "Equal start date and duration for all buildings": "Gelijke startdatum en duur voor alle panden",
  "Equity": "Vermogen",
  "Equity position": "Vermogenspositie",
  "Equity progress": "Vermogensopbouw",
  "Error": "Fout",
  "Error while retrieving portal settings": "Fout bij ophalen 'Mijn Omgeving' instellingen",
  "Estimated": "Geschat",
  "Estimated costs": "Geschatte kosten",
  "Estimated rent": "Verwachte huur",
  "Estimated value": "Geschatte waarde",
  "Estimated value by municipality": "WOZ-waarde",
  "Estimated value in rented condition": "Waarde in verhuurde staat (geschat)",
  "Estimated value pro rata": "Geschatte waarde pro rato",
  "estimated value when rented": "geschatte waarde wanneer gehuurd",
  "EstimatedRentalValue": "Verwachte huurwaarde",
  "EstimatedRentalValueAfterRenovation": "Verwachte huurwaarde na verbouwing",
  "EstimatedValue": "Geschatte waarde",
  "EstimatedValueByMunicipality": "WOZ-waarde",
  "Estimation date": "Datum schatting",
  "Eternally": "Permanent",
  "Every building has an energy label equal to or better than the energy label of this row. A missing label fails the condition.": "Elk object heeft een energielabel gelijk aan of beter dan het energielabel van deze regel. Een ontbrekend label voldoet niet.",
  "Every building is renovated from label C or worse to a better label.": "Elk object wordt verbouwd van label C of slechter naar een beter label.",
  "Every owned addres was collected and added to list": "Ieder adres in bezit is opgehaald en toegevoegd aan de lijst",
  "Everything is uploaded. Good job!": "Alles is geüpload. Goed gedaan!",
  "Excel": "Excel",
  "Excellent": "Uitstekend",
  "Excl. VAT": "Excl. BTW",
  "Excluded area": "Uitgesloten gebied",
  "Excluded in the Randstad": "Uitgesloten in de Randstad",
  "Excluded regions": "Uitgesloten regio's",
  "Executed": "Gepasseerd",
  "Executed this year": "Dit jaar gepasseerd",
  "Executing applications": "Passeeroverzicht",
  "Execution date": "Passeerdatum",
  "Executional": "Executoriaal",
  "ExecutionDate": "Passeerdatum",
  "Existing": "Bestaand",
  "Existing client": "Bestaande klant",
  "Existing documents": "Bestaande documenten",
  "Exit fee": "Exit fee",
  "Exit fee for durations up to 36 months": "Exit fee bij looptijden tot en met 36 maanden",
  "Exit fee percentage": "Uitstapkosten percentage",
  "Expected purchase date": "Verwachte aankoopdatum",
  "Expected rent": "Verwachte huur",
  "Expected rent income": "Verwachte huurinkomsten",
  "Expected rental value after renovation": "Verwachte huurwaarde na verbouwing",
  "expected sale value": "verwachte verkoopwaarde",
  "Expected sale value": "Verwachte verkoopwaarde",
  "Expected sales value": "Verwachte verkoopwaarde",
  "Expected share of the net rental income compared to the total income in the next 3 years?": "Hoeveel procent van de klant zijn totale inkomen bestaat uit netto (kale) huurinkomsten in de komende 3 jaar?",
  "Expected value": "Verwachte waarde",
  "Expected value after renovation": "Verwachte waarde na verbouwing",
  "Expected value on sale": "Verwachte verkoopwaarde",
  "ExpectedRentIncome": "Verwachte huuropbrengst",
  "ExpectedRentIncomeAfterRenovation": "Verwachte huuropbrengst na verbouwing",
  "ExpectedValue": "Verwachte waarde",
  "ExpectedValueAfterRenovation": "Verwachte waarde na verbouwing",
  "Expiration date": "Expiratiedatum",
  "ExpirationDate": "Expiratiedatum",
  "Expired": "Verlopen",
  "Expires": "Verloopt",
  "Expiring mortgages": "Aflopende financieringen",
  "Explanation": "Uitleg",
  "Explanation of application": "Toelichting aanvraag",
  "Explanation of the financial position": "Toelichting op vermogenspositie",
  "Explanation of the income test": "Toelichting op de inkomenstoets",
  "explanationAccountAlreadyExists": "U kunt niet nog een gebruiker aanmaken met deze klant, omdat er al een account met deze emailadres bestaat. U kunt wel een andere account aanmaken vanuit het 'Mijn Omgeving' scherm en dan deze klant eraan koppelen.",
  "Explanations": "Uitleg",
  "Export": "Exporteren",
  "Extended automatically": "Stilzwijgend verlengd",
  "Factor purchase/rent": "Factor aankoop/huur",
  "Factor value/rent": "Factor waarde/huur",
  "Failed": "Gefaald",
  "Failed to submit application": "Indienen aanvraag mislukt",
  "False": "Onwaar",
  "Family situation": "Familie situatie",
  "FamilySituation": "Familie situatie",
  "Featured": "Uitgelicht",
  "Featured (max 3)": "Aanbevolen (max 3)",
  "Fee for existing clients": "Vergoeding voor bestaande klanten",
  "Fee for new clients": "Vergoeding voor nieuwe klanten",
  "Fee type": "Vergoedingstype",
  "Fees": "Vergoedingen",
  "Female": "Vrouw",
  "Field name": "Veldnaam",
  "Fieldname": "Veldnaam",
  "Fill in the new addresses": "Vul de nieuwe adressen in",
  "Filter": "Filter",
  "Filter building": "Filter pand",
  "Filter results": "Filter resultaten",
  "Filters": "Filters",
  "FinalEnergyLabel": "Definitief energie label",
  "Finalizing": "Afronding",
  "Finance renovation costs": "Financier de verbouwingskosten",
  "Financed": "Gefinancierd",
  "Financed at": "Gefinancieerd bij",
  "Financial situation": "Financiële situatie",
  "FinancialSituation": "Financiele situatie",
  "financing": "berekening",
  "Financing": "Berekening",
  "Financing advice for": "Financieringsadvies voor",
  "Financing advice requests": "Financieringsadvies aanvragen",
  "Financing charges": "Financieringslasten",
  "Financing expenses": "Financieringskosten",
  "Financing expires": "Financiering loopt af",
  "Financing information": "Financieringinformatie",
  "Financing options": "Financieringsmogelijkheden",
  "Financing ratios": "Financieringsratio's",
  "Financing requested": "Financiering aangevraagd",
  "Financing requests": "Financiering verzoeken",
  "Financing type": "Financieringstype",
  "Financing value": "Financieringswaarde",
  "Financing value based on": "Financieringswaarde gebasseerd op",
  "Financing value mediation fees": "Financieringswaarde voor bemiddelingskosten",
  "Financing with exact loan amount": "Financiering met exact leenbedrag",
  "FinancingExpenses": "Financieringslasten",
  "FinancingLender": "Financiering-geldverstrekker",
  "FinancingMortgage": "Financiering-hypotheek",
  "financings": "berekeningen",
  "Financings": "Berekeningen",
  "Find cadastral id": "Kadastraal identificatienummer opzoeken",
  "Find owners": "Zoek eigenaren",
  "Finish": "Afronden",
  "First": "Eerste",
  "First mortgage charges per month": "Lasten eerste hypotheek per maand",
  "First name": "Voornaam",
  "First select the buildings that you want to finance": "Selecteer eerst de panden die u wilt financieren",
  "First select the buildings that you want to see in the dashboard": "Selecteer eerst de panden die u in de dashboard wilt zien",
  "FIRST_PAGE_LABEL": "Eerste pagina",
  "FirstName": "Voornaam",
  "Fixed": "Vast",
  "Fixed interest": "Vaste rente",
  "Fixed interest period used for ratios": "Rentevaste periode voor ratio's",
  "Fixed percentage": "Vast percentage",
  "Fixed-rate": "Rentevast",
  "Fixed-rate interest period": "Rentevaste periode",
  "Fixed-rate period (year)": "Rentevaste periode (jaar)",
  "FixedFeeNewCustomers": "Vaste vergoeding nieuwe klanten",
  "FoodServiceIndustry": "Horeca",
  "for": "voor",
  "For a recent purchase with a planned renovation, caps the loan at an LTV of (purchase amount + future renovation costs). Uses the \"Planned investment\" maximum LTV when the rate has one, otherwise the building's own LTV.": "Begrenst bij een recente aankoop met geplande verbouwing de lening op een LTV van (aankoopbedrag + toekomstige verbouwingskosten). Gebruikt de maximale LTV \"Geplande investering\" als het tarief die heeft, anders de eigen LTV van het object.",
  "For each cadastral designation (plot or apartment right) it is checked whether there is mortgage security on it. The mortgage securities can be added here as current financing or linked to an existing current financing.": "Voor ieder kadastrale aanduiding (perceel of appartementsrecht) wordt gekeken of er hypothecaire zekerheid op gevestigd is. De hypothecaire zekerheden kunnen hier worden toegevoegd als lopende financiering of gekoppeld aan een bestaande lopende financiering.",
  "For each cadastral designation (plot or apartment right) that we find in the land registry, the addresses are searched for. Addresses that are not yet known in Unite are suggested here to add.": "Voor ieder kadastrale aanduiding (perceel of appartementsrecht) dat we vinden in het kadaster, worden de adressen erbij gezocht. Adressen die nog niet bekend zijn in Unite worden hier voorgesteld om toe te voegen.",
  "For how much did you renovate this building?": "Voor hoeveel heeft u dit pand verbouwd?",
  "For how much money do you want to renovate this building?": "Voor hoeveel geld wilt u dit pand verbouwen?",
  "For new construction the maximum loan is the maximum LTV of the value after realisation (the vacant value after realisation when the building will not be rented, otherwise the value in rented condition after realisation). Overrides the rules before it.": "Bij nieuwbouw is de maximale lening de maximale LTV van de waarde na realisatie (de leegwaarde na realisatie als het object niet verhuurd wordt, anders de waarde in verhuurde staat na realisatie). Gaat voor de eerdere regels.",
  "For what amount did you buy this building?": "Voor welk bedrag hebt u dit pand gekocht?",
  "For what amount do you expect to buy this building?": "Voor welk bedrag verwacht u dit pand te kopen?",
  "For what rate would you like to create an application?": "Voor welk tarief wilt u een aanvraag opmaken?",
  "For which values are only totals available?": "Van welke waarden zijn er alleen totalen beschikbaar?",
  "For your information: the seizures found in the land register.": "Ter informatie: de beslagleggingen die gevonden zijn in het kadaster.",
  "found": "gevonden",
  "Found addresses": "Gevonden adressen",
  "Found buildings": "Gevonden panden",
  "Found cadastral owners": "Gevonden kadastrale eigenaren",
  "Found collaborations": "Gevonden samenwerkingen",
  "Found mortgage": "Gevonden hypotheek",
  "Found mortgages": "Gevonden hypotheken",
  "Found owners": "Gevonden eigenaren",
  "Found value": "Gevonden waarde",
  "Foundation": "Stichting",
  "Founding date": "Oprichtdatum",
  "FoundingDate": "Oprichtingdatum",
  "Free cash flow": "Vrije cashflow",
  "Free cashflow": "Vrije cashflow",
  "Free choice fixed interest period when extending": "Vrije keus rentevast periode bij verlenging",
  "Free report": "Gratis rapport",
  "Free sector": "Vrije sector",
  "FreeCashFlow": "Vrije cashflow",
  "from": "uit",
  "From amount": "Vanaf bedrag",
  "From duration in months": "Vanaf looptijd in maanden",
  "From employment": "Loondienst",
  "From fixed interest period": "Vanaf rentevaste periode",
  "From high to low": "Van hoog naar laag",
  "From loan": "Vanaf lening",
  "From loan to value": "Vanaf LTV",
  "From low to high": "Van laag naar hoog",
  "From LTV": "Vanaf LTV",
  "From non-residential share": "Vanaf niet-residentieel aandeel",
  "From own business": "Eigen bedrijf",
  "From part of total": "Vanaf deel van totaal",
  "From percentage": "Vanaf percentage",
  "From period in months": "Vanaf periode in maanden",
  "From what LTV-percentage is the loan repayment free?": "Vanaf welke percentage?",
  "FromEmployment": "Loondienst",
  "FromOwnBusiness": "Eigen bedrijf",
  "Full match": "Volledige overeenkomst",
  "Full name": "Volledige naam",
  "Full penalty interest": "Volledige boeterente",
  "Full repayment": "Volledige terugbetaling",
  "Fully matched buildings": "Volledig overeenkomende panden",
  "Funded": "Gefinancieerd",
  "Garage": "Garage",
  "Gender": "Geslacht",
  "General": "Algemeen",
  "Generate box3 analysis": "Genereer box3 analyse",
  "Generate mid rent analysis": "Genereer middenhuur analyse",
  "Generate proposals": "Genereer voorstellen",
  "generated report": "gegenereerd rapport",
  "generated reports": "gegenereerde rapporten",
  "Generated reports": "Gegenereerde rapporten",
  "Generating": "Genereren",
  "Generating and download report": "Rapport genereren en downloaden",
  "Generating indicative financing proposals.": "Indicatieve financieringsvoorstellen worden gegenereerd.",
  "Generating report": "Rapport genereren",
  "Given names": "Officiële voornamen",
  "Go to": "Ga naar",
  "Go to the ongoing mortgage": "Ga naar lopende financiering",
  "Good": "Goed",
  "Good afternoon ...": "Goedemiddag {{name}}",
  "Good evening ...": "Goedenavond {{name}}",
  "Goodmorning ...": "Goedemorgen {{name}}",
  "Grant cadastre": "Verleen toegang",
  "Gross": "Bruto",
  "Gross income per year": "Bruto jaarinkomen",
  "Gross income tax partner per year": "Bruto jaarinkomen van fiscaal partner",
  "Gross initial yield": "Bruto aanvangsrendement",
  "Gross rendement (GIY)": "Bruto rendement (BAR)",
  "Gross rent": "Bruto huur",
  "Gross rent (residential)": "Bruto huur (residentieel)",
  "Gross rent income": "Bruto huurinkomen",
  "Gross rent residential": "Bruto huur residentieel",
  "Gross rental value": "Bruto huurwaarde",
  "Gross return": "Bruto rendement",
  "GrossInitialYield": "BAR",
  "GrossInitialYieldAfterRenovation": "BAR na verbouwing",
  "GrossRent": "Bruto huur",
  "GrossRentResidential": "Bruto huur residentieel",
  "Ground lease": "Erfpacht",
  "Ground lease bought off": "Erfpacht afgekocht",
  "Ground lease by public entity": "Erfpacht uitgegeven door openbaar lichaam",
  "Ground lease contribution": "Erfpacht bijdrage",
  "Ground lease end date": "Erfpacht afgekocht tot",
  "GroundLease": "Erfpacht",
  "GroundLeaseBoughtOff": "Erfpacht afgekocht",
  "GroundLeaseEndDate": "Erfpacht einddatum",
  "Group": "Groep",
  "Guarantor": "Borg",
  "Guarantors": "Borgstellers",
  "guideline": "richtlijn",
  "Handling costs are ...": "Afhandelingskosten bedragen {{value}}",
  "has": "heeft",
  "has an outdated income profile, consider updating before comparing financing proposals": "heeft een verouderd inkomensprofiel, overweeg om deze bij te werken alvorens financieringen te vergelijken",
  "has an outdated investment profile, consider updating before comparing financing proposals": "heeft een verouderd beleggingsprofiel, overweeg om deze bij te werken alvorens financieringen te vergelijken",
  "Has been sold": "Is verkocht",
  "has been split!": "is gesplitst!",
  "Has combination building": "Heeft combinatiepand",
  "Has combination building rnhb": "Heeft combinatiepand (RNHB)",
  "Has existing buildings": "Heeft bestaande objecten",
  "Has existing buildings rnhb": "Heeft bestaande objecten (RNHB)",
  "Has room rental": "Heeft kamerverhuur",
  "Has the current owner owned the property for more than 6 months?": "Heeft de huidige eigenaar het pand langer dan 6 maanden in eigendom?",
  "Has the customer previously taken out a second mortgage and he / she has not fully spent this loan on your own home?": "Heeft de klant eerder een tweede hypotheek afgesloten en heeft hij/zij deze lening niet volledig besteed aan uw eigen woning?",
  "Has the mortgage already been added?": "Is de financiering al toegevoegd?",
  "Has the renovation already taken place?": "Heeft de verbouwing reeds plaatsgevonden?",
  "Has this building already been financed?": "Is dit pand reeds gefinancierd?",
  "Have all properties been valued separately?": "Zijn alle panden afzonderlijk gewaardeerd?",
  "Have you already carried out a renovation?": "Heeft u reeds een verbouwing uitgevoerd?",
  "Have you previously used equity on your own home to borrow money and used that money for the purchase of a car, boat, second home or investment property, for example?": "Heb je eerder overwaarde op je eigen woning gebruikt om geld te lenen en dat geld bijvoorbeeld gebruikt voor de aanschaf van een auto, boot, tweede woning of beleggingspand?",
  "Have you purchased this building in the past 12 months?": "Heeft u dit pand in de afgelopen 12 maanden gekocht?",
  "Have you renovated this building in the past 12 months?": "Heeft u dit pand in de afgelopen 12 maanden verbouwd?",
  "Hello": "Hallo",
  "here": "hier",
  "Hide accepted documents": "Verberg geaccepteerde documenten",
  "Hide all": "Verberg alle",
  "Hide rejections": "Verberg afwijzingen",
  "Hide result list": "Verberg resultaten",
  "High to low": "Hoog naar laag",
  "Highest free cash flow": "Hoogste vrije cashflow",
  "Highest free cashflow": "Hoogste vrije cashflow",
  "Highest liquid assets": "Hoogste liquide middelen",
  "Highest loan": "Hoogste lening",
  "Highest return on equity": "Hoogste Return on Equity",
  "Home": "Home",
  "Hotel": "Hotel",
  "House": "Woning",
  "House number": "Huisnummer",
  "House number addition": "Huisnummertoevoeging",
  "Hi {{name}}, how can I help you today?": "Hoi {{name}}, hoe kan ik je vandaag helpen?",
  "How can I help you today?": "Hoe kan ik je vandaag helpen?",
  "How high is the remaining loan?": "Hoe hoog is de resterende lening?",
  "How high is the share of the net rental income compared to the total income?": "Hoeveel procent van de klant zijn totale inkomen bestaat uit netto (kale) huurinkomsten?",
  "How is the borrowers income currently being earned?": "Hoe wordt het inkomen van de kredietnemer momenteel verdiend?",
  "How long does the current fixed-rate period last?": "Hoe lang duurt de huidige rentevast periode nog?",
  "How many properties do you plan to purchase for commercial rental in the next 3 years?": "Hoeveel panden is de klant van plan aan te kopen bestemd voor commerciële verhuur in de komende 3 jaar?",
  "How many rented objects did the client buy in the past 5 years?": "Hoeveel verhuurde objecten heeft de klant gekocht in de afgelopen 5 jaren?",
  "How many rented objects does the customer currently own?": "Hoeveel verhuurde objecten heeft de klant momenteel in bezit?",
  "How many rented objects has the client sold in the past 5 years?": "Hoeveel verhuurde objecten heeft de klant verkocht in de afgelopen 5 jaren?",
  "How many units will it be?": "Hoeveel eenheden worden het?",
  "How many years of professional experience in the real estate sector does the client have?": "Hoeveel jaar professionele ervaring in de vastgoedsector heeft de klant?",
  "How many years remain from the original contract duration?": "Hoeveel jaar resteert er nog van de originele contractduur?",
  "How much are the customer's monthly payments from other rental mortgages?": "Hoeveel bedragen de klant zijn maandlasten van andere verhuurhypotheken?",
  "How much are the customer's net rental income per month?": "Hoeveel bedragen de netto huuropbrengsten van de klant per maand?",
  "How much are the total operating costs?": "Hoeveel bedragen de totale exploitatiekosten?",
  "How much debt does the client have on real estate?": "Hoeveel schulden heeft de klant op onroerend goed?",
  "How much debt does the customer have (not real estate)?": "Hoeveel schulden heeft de klant (geen betrekking op onroerend goed)?",
  "How much does the client own in investments (not real estate)?": "Hoeveel bezit de klant aan beleggingen (geen onroerend goed)?",
  "How much does the customer have in savings, receivables and other?": "Hoeveel bezit de klant aan spaargeld, vorderingen en overige?",
  "How much does the customer own in real estate?": "Hoeveel bezit de klant aan onroerend goed?",
  "How much interest do you pay?": "Hoeveel rente betaalt u?",
  "How much is the balance for taxable profit of the customer's tax partner?": "Hoeveel bedraagt het saldo fiscale winst van de fiscaal partner?",
  "How much is the customer's balance for taxable profit?": "Hoeveel bedraagt de klant zijn saldo fiscale winst?",
  "How much is the customer's gross income per year?": "Hoeveel bedraagt de klant zijn bruto inkomen per jaar",
  "How much is the customer's own home mortgage interest rate?": "Welke rente betaalt de klant op uw eigen woning hypotheek?",
  "How much is the customer's own home mortgage loan?": "Hoeveel bedraagt de klant zijn eigen woning hypotheek?",
  "How much is the customer's profit after tax?": "Hoeveel bedraagt de klant zijn winst na belasting?",
  "How much is the gross income of the customer's tax partner?": "Hoeveel bedraagt het bruto inkomen van zijn of haar fiscaal partner?",
  "How much is the net rental income per year from rented objects?": "Hoeveel bedraagt het netto huurinkomen per jaar uit verhuurde objecten?",
  "How much is the profit after tax of the customer's tax partner?": "Hoeveel bedraagt de winst na belasting van de fiscaal partner?",
  "How much is the total rental income?": "Hoeveel bedraag de totale huuropbrengst?",
  "How much is the total rental value?": "Hoeveel bedraagt de totale huurwaarde?",
  "How much own resources does the customer have available to invest in real estate?": "Hoeveel eigen middelen heeft de klant beschikbaar om te investeren in vastgoed?",
  "How much rent does the customer pay per month?": "Hoeveel huur betaalt de klant per maand?",
  "How much rooms and board does the customer pay per month?": "Hoeveel kost en inwoning betaalt de klant per maand?",
  "How much student debt does the client have?": "Hoeveel studieschuld heeft de klant?",
  "How planned (future) renovation costs affect the maximum loan of a building. Only applies when the building has future renovation costs.": "Hoe geplande (toekomstige) verbouwingskosten de maximale lening van een object beïnvloeden. Geldt alleen als het object toekomstige verbouwingskosten heeft.",
  "How the maximum loan of a combination building (a building with units) is determined.": "Hoe de maximale lening van een combinatiepand (een object met units) wordt bepaald.",
  "I already own this building": "Ik heb dit pand al in bezit",
  "I have sold this building": "Ik heb dit pand verkocht",
  "I know the exact loan amount": "Ik weet het exacte leenbedrag",
  "I use a fixed fee per financing": "Ik gebruik een vaste vergoeding per financiering",
  "I use a variable fee per financing": "Ik gebruik een variabele vergoeding per financiering",
  "I want to buy this building": "Ik wil dit pand kopen",
  "I want to continue renting out this building": "Ik wil dit pand blijven verhuren",
  "I want to rent out this building": "Ik wil dit pand verhuren",
  "I want to sell this building": "Ik wil dit pand verkopen",
  "I want to split this building": "Ik wil dit pand splitsen",
  "I want to use this building for myself": "Ik wil dit pand zelf gaan gebruiken",
  "IBAN": "IBAN",
  "IBAN Owner": "IBAN Eigenaar",
  "ICR": "ICR",
  "ICR (Gross Rent Residential)": "ICR (Bruto huur residentieel)",
  "ICR (Gross Rent)": "ICR (Bruto huur)",
  "ICR (Net Rent Residential)": "ICR (Netto huur residentieel)",
  "ICR (Net Rent)": "ICR (Netto huur)",
  "ICR Gross Rent": "ICR Bruto Huur",
  "ICR Gross Rent (5 year)": "ICR Bruto Huur (5 jaar)",
  "ICR Gross Rent Residential": "ICR Bruto Huur Residentieel",
  "ICR Gross Rent Residential (after renovation)": "ICR Bruto Huur Residentieel (na verbouwing)",
  "ICR Net Rent": "ICR Netto Huur",
  "ICR Net Rent (5 year)": "ICR Netto Huur (5 jaar)",
  "ICR Net Rent Residential": "ICR Netto Huur Residentieel",
  "IcrGrossRent": "ICR bruto huur",
  "IcrGrossRentResidential": "ICR bruto huur residentieel",
  "IcrNetRent": "ICR netto huur",
  "IcrNetRentAfterRenovation": "ICR netto huur na verbouwing",
  "IcrNetRentResidential": "ICR netto huur residentieel",
  "Id": "Id",
  "Identity": "Identiteit",
  "Identity document": "Identiteitsdocument",
  "IdentityCardEuOrEaaMemberStateOrSwitzerlandWithPhoto": "Identiteitskaart EU/EER lidstaat of Zwitserland (met foto)",
  "IdentityDocument": "Identiteitsdocument",
  "If a number of addresses share a connection to the public space, but are not split in the cadastral register, then it is a combination building. Mortgage security can only be established on the property as a whole.": "Indien een aantal adressen samen een aansluiting op de openbare ruimte delen, maar niet kadastraal gesplitst zijn dan zien veel geldverstrekkers het als een combinatiepand. Er kan alleen hypothecaire zekerheid worden gevestigd op het pand als geheel.",
  "If data deviating from a known address is found in our data sources (Land Registry, WOZ-waardeloket, EP Online), it is proposed here to update the properties in Unite.": "Indien van een bekend adres afwijkende data wordt gevonden in onze databronnen (Kadaster, WOZ-waardeloket, EP Online) dan wordt hier voorgesteld om het pand in Unite bij te werken.",
  "If one of the selected buildigs has a active mortgage, this mortgage will automatically be transfered to the other portfolio. This will only work then all buildings linked to this mortgage have been selected to move to the other portfolio.": "Indien aan bovenstaande panden een lopende hypotheek gekoppeld is, dan verhuist deze lopende financiering automatisch mee naar de andere portefeuille. Voorwaarde hiervoor is wel dat alle panden die verbonden zijn aan deze lopende financiering geselecteerd zijn om mee te verhuizen naar de andere portefeuille.",
  "If the appraisal later shows that the appraised monthly rent is lower than entered, there is a chance that the loan will be lower.": "Als later uit de waardering blijkt dat de gewaardeerde huur per maand lager is dan ingevuld bestaat de kans dat de lening lager uitvalt.",
  "If the house is in the private sector, click Save. If you are not sure, enter the points according to the landlord or adjust the rent per month downwards. Then click Save.": "Indien de woning in de vrije sector valt, klik dan op Opslaan. Indien u dit niet zeker weet vul dan de punten volgens de verhuurder in of pas de huur per maand naar beneden aan. Klik daarna op Opslaan. ",
  "If the lender is not in the list, request IT to add lender": "Als de geldverstrekker niet in de lijst staat? Verzoek IT om deze toe te voegen",
  "Ignore": "Negeren",
  "Ignore valuations": "Waarderingswaardes negeren",
  "Import": "Importeren",
  "Imported": "Geimporteerd",
  "in": "in",
  "In big city": "In grote stad",
  "In rooms": "Op kamers",
  "In the event of an interim repayment, the remaining amount in the interest deposit will be repaid.": "Bij vroegtijdige aflossing wordt het resterende bedrag in het rentedepot terugbetaald.",
  "in the first year": "in het eerste jaar",
  "in the second year": "in het tweede jaar",
  "in the third year": "in het derde jaar",
  "In the unlikely event that the permit is not granted, the object can still be used as a single house without another permit (possibly with a small renovation)": "Mocht de vergunning onverhoopt niet worden verleend, is het object dan zonder andere vergunning alsnog als één woning te gebruiken (eventueel met een kleine verbouwing)",
  "Include collaborations": "Inclusief samenwerkingen",
  "Include income tax partner": "Inkomen fiscaal partner meerekenen",
  "Include invalid": "Inclusief ongeldige",
  "Include mortgages": "Inclusief hypotheken",
  "Include vacancy": "Leegstand meenemen",
  "Included in owners association contribution": "Zit in VvE",
  "Includes interest for ratios": "Inclusief rente voor ratio's",
  "Including added value": "Inclusief meerwaarde",
  "Income": "Inkomen",
  "Income and liabilities": "Inkomen en verplichtingen",
  "Income from own business": "Inkomen uit eigen bedrijf",
  "Income from own business tax partner": "Inkomen uit eigen bedrijf fiscaal partner",
  "Income source": "Bron van inkomen",
  "Income source tax partner": "Bron van inkomen fiscaal partner",
  "Income sources": "Inkomstenbronnen",
  "Income sufficient to pay for own home": "Inkomen voldoende om eigen woning lasten te voldoen",
  "Index operating costs": "Indexatie exploitatiekosten",
  "Index real estate": "Indexatie waarde vastgoed",
  "Index rent": "Indexatie huuropbrengst",
  "Indexation": "Indexatie",
  "Information": "Informatie",
  "information": "informatie",
  "Inheritance": "Erfenis",
  "Initials": "Initialen",
  "InProgress": "In behandeling",
  "InProgressClosing": "In behandeling closing",
  "InProgressLoanAgreement": "In behandeling leningsovereenkomst",
  "InProgressTermSheet": "In behandeling indicatieve offerte",
  "InRooms": "Op kamers",
  "Insert the valuations": "Voer de waarderingen in",
  "Insert valuations": "Waarderingen invoeren",
  "Inspections": "Inspecties",
  "Insurance": "Verzekering",
  "InsurancePolicyPayment": "Uitkering verzekering",
  "interest": "rente",
  "Interest": "Rente",
  "Interest (ratio calculation / 5 year)": "Rente (ratio berekening / 5 jaar)",
  "Interest (ratio calculation)": "Rente (ratio berekening)",
  "Interest adjustments": "Renteaanpassingen",
  "Interest amount": "Rentebedrag",
  "interest and repayment": "rente en aflossing",
  "Interest charges": "Rente",
  "Interest charges deposit": "Rente over bouwdepot",
  "Interest compensation": "Rentevergoeding",
  "Interest compensation type": "Soort rentevergoeding",
  "Interest coverage ratio": "Interest coverage ratio",
  "Interest deposit": "Rente depot",
  "Interest deposits": "Rentedepots",
  "Interest discount": "Rente korting",
  "Interest discount based on portfolio size": "Rente korting obv portefeuille grootte",
  "Interest discount from portfolio size": "Rentekorting vanaf portefeuilleomvang",
  "Interest discount percentage": "Rentekortingspercentage",
  "Interest discount purchased": "Rentekorting ingekocht",
  "Interest discounts by loan amount": "Rentekortingen op basis van leenbedrag",
  "Interest from start": "Rente vanaf start",
  "Interest guarantee": "Rentegarantie",
  "Interest guarantee extendable": "Verlengen rentegarantie",
  "Interest guarantee extendable in days": "Rentegarantie verlengbaar in dagen",
  "Interest guarantee extending costs percentage": "Kostenpercentage verlenging rentegarantie",
  "Interest is fixed until": "Rente staat vast tot",
  "Interest period": "Rentevast periode",
  "Interest period in months": "Rentevast periode in maanden",
  "Interest rate": "Rentepercentage",
  "Interest rate (min 5 year)": "Rentepercentage (min 5 jaar)",
  "Interest rate per year": "Rentepercentage per jaar",
  "Interest rate with discount": "Rente inclusief korting",
  "Interest rates": "Rentes",
  "Interest reflection period": "Rentebedenktijd",
  "Interest reflection period in months": "Rentebedenktijd in maanden",
  "Interest surcharges": "Renteopslagen",
  "Interest-only possible from": "Aflossingsvrij mogelijk vanaf",
  "InterestDeposit": "Rentedepot",
  "InterestPeriodInMonths": "Rente periode in maanden",
  "InterestRatePerYear": "Rente percentage",
  "Interim increase": "Tussentijds verhogen",
  "internal": "intern",
  "Into": "Tot",
  "Investment": "Belegging",
  "Investment plan": "Investeringsplan",
  "Investment profile": "Beleggingsprofiel",
  "Investments (not real estate)": "Beleggingen (geen onroerend goed)",
  "InvestmentWithRenovation": "Belegging met verbouwing",
  "Is ... a company?": "Is {{value}} een rechtspersoon?",
  "is closed!": "is afgerond!",
  "is created!": "is aangemaakt!",
  "is deleted!": "is verwijderd!",
  "Is existing customer": "Is bestaande klant",
  "is higher than maximum of": "is hoger dan het maximum van",
  "Is it sublet?": "Wordt het onderverhuurd?",
  "is linked to": "is gekoppeld aan",
  "is lower than minimum of": "is lager dan het minimum van",
  "is opened!": "is in behandeling genomen",
  "Is primary contact": "Is contactpersoon",
  "Is template": "Is sjabloon",
  "Is the loan partially repayable?": "Is de lening gedeeltelijk aflossingsvrij",
  "Is the real estate part of the clients pension provision?": "Is het vastgoed onderdeel van de klant zijn pensioenvoorziening?",
  "Is the selling party in the deed of sale also the current owner of the property?": "Is de verkopende partij in de koopakte ook de huidige eigenaar van het pand?",
  "Is the taxpartner applicant?": "Is de fiscaal partner ook aanvrager?",
  "Is there a buffer available to absorb 6 months of vacancy?": "Is er een buffer aanwezig om 6 maanden leegstand op te vangen?",
  "Is there a rental of non-self-contained living spaces?": "Is er sprake van verhuur van onzelfstandige woonruimtes?",
  "Is there a repayment?": "Lost u de lening af?",
  "Is there a second mortgage?": "Is er sprake van een tweede hypotheek?",
  "Is there a special rental?": "Is er sprake van bijzonder verhuur?",
  "Is this building currently rented out?": "Is dit pand momenteel verhuurd?",
  "Is this building rented out for more than 12 months?": "Is dit pand al langer dan 12 maanden verhuurd?",
  "is updated!": "is aangepast!",
  "Indexed as": "Geïndexeerd als",
  "Issued": "Uitgegeven",
  "It is only possible to merge buildings into a combination building if they have the same cadastral designation.": "Het is alleen mogelijk om panden samen te voegen tot een combinatiepand als deze dezelfde cadastrale aanduiding hebben.",
  "It works like this:": "Het werkt als volgt:",
  "ITEMS_PER_PAGE_LABEL": "Items per pagina",
  "Key": "Sleutel",
  "Label": "Label",
  "LABEL_BUILDING_ACTIONS": "Hier vindt u acties die u helpen bij het compleet maken alle gegevens van uw pand. Hoe completer de informatie, hoe accurater de gegevens in uw dashboard en een eventueel financieringsverzoek.",
  "LABEL_BUILDING_MORTGAGES": "Lopende financieringen zijn van invloed op het rendement dat u maakt op een pand. Indien u ze invoert kan uw adviseur ook tijdig uw situatie opnieuw doorrekenen. Omdat lopende financieringen soms complex zijn opgebouwd bieden we twee opties.",
  "LABEL_BUILDING_RENOVATIONS": "U kunt hier verbouwingen toevoegen die u heeft gedaan of nog gaat doen. Dit beïnvloed uw rendement in het dashboard omdat uw totale investeringen in het pand stijgen. Een verbouwing, kan wanneer hij hier voltooid wordt, ook leiden tot meer oppervlakte en andere huurinkomsten.",
  "LABEL_BUILDING_RENTALCONTRACTS": "Op een pand kunt u huurcontracten toevoegen. Bij het aanvragen van een nieuwe financiering zal een hypotheekverstrekker vragen om een huurlijst. Uw adviseur kan deze aan de hand van de hier in gevulde gegevens eenvoudig aanleveren.",
  "LABEL_BUILDING_VALUATIONS": "U kunt ons verzoeken om een taxatierapport in uw administratie toe te voegen. Dit taxatierapport is van groot belang bij toekomstige berekeningen van financieringen.",
  "LABEL_DESCRIPTION_APPLICATIONS": "Hier kunt u uw lopende en onlangs voltooide aanvragen zien. Tevens heeft u de mogelijkheid om een advies aan te vragen.",
  "LABEL_DESCRIPTION_BUILDINGS": "Hier kunt u uw panden toevoegen, bewerken en verwijderen. Een pand is een pand met een enkel adres. Indien een pand meerdere verhuurbare woonunits heeft dan kunt u dit aangeven bij het pand. Ieder pand wordt voorzien van een aantal icoontjes die de status van het pand vertegenwoordigd. Uitleg over de icoontjes vindt u onderaan.",
  "LABEL_DESCRIPTION_MORTGAGES": "Hier kunt u lopende financieringen toevoegen, wijzigen en verwijderen",
  "LABEL_DESCRIPTION_RENTALCONTRACTS": "Hier kunt u uw huurcontracten beheren. Een huurcontract is gekoppeld aan een pand en kan meerdere huurders bevatten.",
  "LABEL_FINANCING_NO_INCOME_OTHER": "Helaas is het niet mogelijk om financieringsmogelijkheden te tonen omdat van een of meerdere deelnemers uit de samenwerking informatie over het inkomen en financiële verplichtingen ontbreekt.",
  "LABEL_FINANCING_NO_INCOME_PERSON": "Om je de juiste financieringsmogelijkheden te tonen dien je eerst informatie over de klant zijn inkomen en financiële verplichtingen in vullen.",
  "LABEL_FINANCING_NO_PROFILE_PERSON": "Om je de juiste financieringsmogelijkheden te tonen dien je eerst een beleggingsprofiel voor de klant aan te maken",
  "LABEL_FIRST_PAGE": "Eerste pagina",
  "LABEL_ITEMS_PER_PAGE": "Items per pagina",
  "LABEL_LAST_PAGE": "Laatste pagina",
  "LABEL_MULTIPLE_LOAN_PARTS": "Op deze financiering zijn meerdere leningdelen van toepassing, daardoor zijn sommige velden niet aanpasbaar. Indien u een veld wilt wijzigen, neem dan contact op met uw adviseur.",
  "LABEL_NEXT_PAGE": "Volgende pagina",
  "LABEL_PREVIOUS_PAGE": "Vorige pagina",
  "LABEL_RANGE_PAGE_1": "0 van {{length}}",
  "LABEL_RANGE_PAGE_2": "{{startIndex}} - {{endIndex}} van {{length}}",
  "LABEL_TASK_FINANCINGADVICE_TITLE": "Financieringsadvies",
  "LABEL_TASK_MORTGAGE_BUTTON": "Voeg mijn lopende financiering toe",
  "LABEL_TASK_MORTGAGE_COMPLETED": "We hebben uw verzoek ontvangen en zullen de lopende financiering zo spoedig mogelijk toevoegen",
  "LABEL_TASK_MORTGAGE_DESCRIPTION": "Voeg alle relevante documenten toe en wij zullen de lopende financiering voor u toevoegen",
  "LABEL_TASK_MORTGAGE_DOCUMENTS": "Meest recente jaaropgave;Leningovereenkomst;",
  "LABEL_TASK_MORTGAGE_HEADER": "Toevoegen lopende financiering",
  "LABEL_TASK_MORTGAGE_TITLE": "Toevoegen lopende financiering",
  "LABEL_TASK_VALUATION_BUTTON": "Voeg deze waardering toe",
  "LABEL_TASK_VALUATION_COMPLETED": "We hebben uw verzoek ontvangen en zullen de waardering zo spoedig mogelijk toevoegen",
  "LABEL_TASK_VALUATION_DESCRIPTION": "Upload het taxatierapport en vermeld eventuele bijzonderheden",
  "LABEL_TASK_VALUATION_DOCUMENTS": "Taxatierapport",
  "LABEL_TASK_VALUATION_HEADER": "Toevoegen waardering",
  "LABEL_TASK_VALUATION_TITLE": "Toevoegen waardering",
  "Labor / knowledge migrants": "Kennis-/arbeidsmigranten",
  "Land registry": "Kadaster",
  "Last requested on ...": "Laatst opgevraagd op {{value}}",
  "Last update": "Laatste update",
  "Last VIR Report processed": "Laatste VIR rapport verwerkt",
  "LAST_PAGE_LABEL": "Laatste pagina",
  "Latest upload": "Laatste upload",
  "Layout": "Indeling",
  "Layout after splitting": "Indeling na splitsen",
  "Leave": "Laten staan",
  "Leave empty to let Unite estimate the value in rented condition": "Laat leeg om Unite de waarde in verhuurde staat te laten schatten",
  "Legal form": "Rechtsvorm",
  "Leisure": "Recreatief",
  "Lender": "Geldverstrekker",
  "Lender accounts": "Rekeningen geldverstrekker",
  "Lender commission": "Afsluitprovisie",
  "Lender commission + Interest for the entire duration + Exit fee": "Afsluitprovisie + Rente voor de gehele looptijd + Exit-fee",
  "Lender created": "Geldverstrekker aangemaakt",
  "Lender dashboard": "Dashboard geldverstrekker",
  "Lender deleted": "Geldverstrekker verwijderd",
  "Lender saved": "Geldverstrekker opgeslagen",
  "Lender under supervision of afm": "Geldverstrekker onder toezicht AFM",
  "Lender under supervision of dnb": "Geldverstrekker onder toezicht DNB",
  "Lenders": "Geldverstrekkers",
  "Less than 1 year": "Minder dan 1 jaar",
  "Less than 25%": "Minder dan 25%",
  "Less than €1.000.000": "Minder dan €1.000.000",
  "Less than €20.000": "Minder dan €20.000",
  "Less than €25.000": "Minder dan €25.000",
  "Less than €5.000": "Minder dan €5.000",
  "Let Assets add your ongoing mortgages": "Laat Assets uw lopende financieringen toevoegen",
  "Let us add the valuation report": "Laat ons het taxatierapport toevoegen",
  "Let us add your mortgage": "Laat ons uw lopende financiering toevoegen",
  "Level": "Niveau",
  "Limited partnership": "Commanditaire vennootschap",
  "LimitedCompany": "Naamloze Vennootschap",
  "LimitedPartnership": "Commanditaire vennootschap",
  "Limits the adjustment to fixed-interest periods from this number of months (inclusive).": "Beperkt de aanpassing tot rentevaste periodes vanaf dit aantal maanden (inclusief).",
  "Limits the adjustment to fixed-interest periods up to this number of months (inclusive).": "Beperkt de aanpassing tot rentevaste periodes tot en met dit aantal maanden.",
  "Limits the adjustment to one repayment variant: repayment free (interest only) or repaying. Empty applies it to both.": "Beperkt de aanpassing tot één aflosvorm: aflossingsvrij of aflossend. Leeg geldt voor beide.",
  "Linear": "Lineair",
  "Link to application": "Koppel aan aanvraag",
  "Link to building": "Koppel aan pand",
  "Link to client": "Gekoppeld aan klant",
  "Link to mortgage": "Koppel aan financiering",
  "Linked accounts": "Gekoppelde accounts",
  "Linked addresses": "Gekoppelde adressen",
  "Linked buildings": "Gekoppelde panden",
  "Linked clients": "Gelinkte klanten",
  "Linked mortgages": "Gekoppelde financieringen",
  "Liquid assets": "Liquide middelen",
  "List of buildings": "Lijst van panden",
  "Listed postcode": "Postcode in lijst",
  "Living group / house sharing": "Woongroep / woningdelen",
  "Living situation": "Woonsituatie",
  "Living with parents": "Inwonend bij ouders",
  "Living with partner": "Inwonend bij partner",
  "LivingTogether with cohabitation contract": "Samenwonend met een samenlevingscontract",
  "LivingTogether without cohabitation contract": "Samenwonend zonder een samenlevingscontract",
  "LivingTogetherWithCohabitationContract": "Samenwonend met een samenlevingscontract",
  "LivingTogetherWithoutCohabitationContract": "Samenwonend zonder een samenlevingscontract",
  "Loading": "Ophalen",
  "Loading ...": "Laden ...",
  "Loading account": "Account wordt geladen",
  "Loading application": "Aanvraag wordt geladen",
  "Loading applications": "Aanvragen worden geladen",
  "Loading building properties": "Pand eigenschappen worden geladen",
  "Loading buildings": "Panden worden geladen",
  "Loading cadastral mortgages": "Hypotheken ophalen",
  "Loading collaborations": "Samenwerkingen worden geladen",
  "Loading combined buildings": "Ophalen combinatiepanden",
  "Loading contact": "Contactpersoon wordt opgehaald",
  "Loading customer": "Klant wordt geladen",
  "Loading documents": "Document worden geladen",
  "Loading financing": "Financiering ophalen",
  "Loading land registry settings": "Kadastrale instellingen worden geladen",
  "Loading latest VIR session": "Laatste VIR sessie wordt geladen",
  "Loading loan parts": "Ophalen leningdelen",
  "Loading mortgages": "Lopende financieringen ophalen",
  "Loading not found mortgages": "Niet gevonden lopende financieringen worden geladen",
  "Loading penalty interest": "Boeterente wordt geladen",
  "Loading persons": "Personen worden geladen",
  "Loading rental contracts": "Huurcontracten worden geladen",
  "Loading seizures": "Ophalen beslagleggingen",
  "Loading UBO": "UBO wordt opgehaald",
  "Loading unmatched registrations": "Niet gematchte registraties worden geladen",
  "Loading value options": "Waardes worden geladen",
  "Loan": "Lening",
  "Loan amount": "Leenbedrag",
  "Loan direct payout": "Direct uitgekeerd",
  "Loan exceeds the total investment, that's why the return on equity could not be calculated.": "De lening is groter dan de totale investing, daarom kan het rendement op eigen vermogen niet worden berekend.",
  "Loan exceeds the total investment, that's why the return on own investment could not be calculated.": "De lening is groter dan de totale investering, daarom kan het rendement op de investering niet worden berekend.",
  "Loan part": "Leningdeel",
  "Loan parts": "Leningdelen",
  "Loan to cost": "Loan to cost",
  "Loan to income test": "LTI toets",
  "Loan to value": "Loan to value",
  "Loan to value (5 year)": "Loan to value (5 jaar)",
  "Loan, interest and repayment": "Lening, rente en aflossing",
  "LoanAgreement": "Leningovereenkomst",
  "LoanAgreementApproved": "Leningovereenkomst akkoord",
  "LoanAgreementDelivered": "Leningsovereenkomst geleverd",
  "LoanAgreementInProgress": "Leningsovereenkomst in behandeling",
  "LoanAgreementReceived": "Leningovereenkomst ontvangen",
  "LoanAgreementRequested": "Leningovereenkomst aangevraagd",
  "LoanDirectPayout": "Lening (direct)",
  "Loanpart": "Leningdeel",
  "LoanPart": "Leningdeel",
  "Loanparts": "Leningdelen",
  "LoanProvidedByFinancialInstitution": "Lening vanuit financieel instituut",
  "LoanProvidedByNonFinancialInstitution": "Lening vanuit niet financieel instituut",
  "LoanProvidedByOwnCompany": "Lening vanuit eigen bedrijf",
  "Location": "Plaats",
  "Location lists": "Locatie",
  "Location rating": "Locatie beoordeling",
  "LocationRating": "Locatie beoordeling",
  "Login": "Log in",
  "Login as advisor": "Log in als adviseur",
  "Logo": "Logo",
  "Logout": "Uitloggen",
  "Long": "Lang",
  "Longer": "Langer",
  "Lot": "Kavel",
  "Low to high": "Laag naar hoog",
  "Lower of rented and vacant value": "Laagste van waarde verhuurde staat en leegwaarde",
  "Lower of rented and vacant value, unless renovated": "Laagste van waarde verhuurde staat en leegwaarde, tenzij verbouwd",
  "Lowest": "Laagste",
  "Lowest costs": "Laagste kosten",
  "Lowest interest": "Laagste rente",
  "Lowest of rented value, vacant value and investment": "Laagste van waarde verhuurde staat, leegwaarde en investering",
  "Lowest own contribution": "Laagste eigen bijdrage",
  "LTV": "LTV",
  "LTV % repayment free": "LTV % aflossingsvrij",
  "LTV category 1": "LTV-categorie 1",
  "LTV category 1, good energy label": "LTV-categorie 1, goed energielabel",
  "LTV category 1, room rental": "LTV-categorie 1, kamerverhuur",
  "LTV category 2": "LTV-categorie 2",
  "LTV category 2, good energy label": "LTV-categorie 2, goed energielabel",
  "LTV category 2, room rental": "LTV-categorie 2, kamerverhuur",
  "LTV category 3": "LTV-categorie 3",
  "LTV category 3, good energy label": "LTV-categorie 3, goed energielabel",
  "LTV category 3, room rental": "LTV-categorie 3, kamerverhuur",
  "LTV category of the postcode of the building.": "LTV-categorie van de postcode van het object.",
  "madam": "mevrouw",
  "Magic filter": "Magisch filter",
  "Mailing address": "Postadres",
  "Maintenance": "Onderhoud",
  "Maintenance condition rating": "Onderhoudsstaat beoordeling",
  "Make a good proposal": "Maak een goed voorstel",
  "Make an account": "Maak een gebruikersaccount aan",
  "Male": "Man",
  "Manage new units": "Beheer nieuwe eenheden",
  "Management": "Beheer",
  "Manual": "Handmatig",
  "Marital status": "Burgerlijke staat",
  "MaritalStatus": "Burgerlijke staat",
  "Mark as repayed": "Markeer als afgelost",
  "Market rent": "Markthuur",
  "Market value": "Marktwaarde",
  "MarketRent": "Markthuur",
  "Married according international law": "Gehuwd volgens internationale wet",
  "Married community property": "Gehuwd in gemeenschap van goederen",
  "Married prenup": "Gehuwd met huwelijke voorwaarden",
  "MarriedAccordingInternationalLaw": "Gehuwd volgens internationale wet",
  "MarriedCommunityProperty": "Gehuwd in gemeenschap van goederen",
  "MarriedPrenup": "Gehuwd met huwelijke voorwaarden",
  "Match ongoing mortgage": "Match lopende financiering",
  "Matched": "Gevonden",
  "Matched addresses": "Gevonden adressen",
  "Matched on": "Vergeleken op",
  "Matches collaboration": "Komt overeen met samenwerking",
  "matching buildings based on the following properties": "vergelijkbare panden die overeenkomen op de volgende eigenschappen",
  "Matching existing mortgages": "Overeenkomende bestaande lopende financieringen",
  "Max loan": "Maximale lening",
  "Max theoretical space": "Max theoretische ruimte",
  "Max. loan": "Max. lening",
  "Max. LTV": "Max. LTV",
  "Maximal": "Maximale",
  "Maximum": "Maximaal",
  "Maximum acceptance period in days": "Maximale acceptatietermijn in dagen",
  "Maximum additional income": "Max aanvullend inkomen",
  "Maximum allowed charges per month": "Maximale toegestane lasten per maand",
  "Maximum amount": "Maximaal bedrag",
  "Maximum contract duration": "Maximale contractduur",
  "Maximum duration": "Maximale duur",
  "Maximum fee": "Maximale vergoeding",
  "Maximum fee per financing": "Maximale vergoeding per financiering",
  "Maximum financing amount": "Maximale financieringsbedrag",
  "Maximum in percentage from loan": "Maximaal percentage van lening",
  "Maximum in percentage from purchase value": "Maximaal percentage van koopsom",
  "Maximum in percentage from value": "Maximaal percentage van waarde",
  "Maximum in percentage from value after renovation": "Maximaal percentage van waarde na renovatie",
  "Maximum liquid assets": "Maximaal liquide middelen",
  "Maximum loan": "Maximale lening",
  "Maximum loan after 1 year": "Maximale lening na 1 jaar",
  "Maximum loan after renovation": "Maximale lening na verbouwing",
  "Maximum loan per building": "Maximale lening per object",
  "Maximum loan per rate": "Maximale lening per tarief",
  "Maximum loan policy": "Beleid maximale lening",
  "Maximum loan to value": "Maximale LTV",
  "Maximum loan to value repayment free": "Maximale LTV aflossingsvrij",
  "Maximum loans": "Maximale leningen",
  "Maximum LTV": "Maximale LTV",
  "Maximum mediation fees percentage": "Maximaal percentage bemiddelingskosten",
  "Maximum non-residential rent share of the portfolio": "Maximaal niet-residentieel huuraandeel van de portefeuille",
  "Maximum non-residential value share of the portfolio": "Maximaal niet-residentieel waardeaandeel van de portefeuille",
  "Maximum notary fees percentage": "Maximaal percentage notariskosten",
  "Maximum number of mixed use buildings": "Maximaal aantal panden met gemengd gebruik",
  "Maximum number of rental contracts": "Maximaal aantal huurcontracten",
  "Maximum number of residential buildings": "Maximaal aantal woningen",
  "Maximum period completing file in days from term sheet": "Maximale termijn compleet dossier in dagen na offerte",
  "Maximum period to pass at notary in days": "Maximale termijn passeren bij notaris in dagen",
  "Maximum portfolio size": "Maximale portefeuille grootte",
  "Maximum refinancing amount percentage": "Maximaal percentage herfinancieringsbedrag",
  "Maximum repayment rate": "Maximaal aflossingspercentage",
  "Maximum valuation costs percentage": "Maximaal percentage taxatiekosten",
  "Maximum value above purchase price": "Maximale waarde boven koopsom",
  "MaximumLoan": "Maximale lening",
  "Mediation fees": "Bemiddelingskosten",
  "Members": "Leden",
  "Merge": "Samenvoegen",
  "Merge buildings": "Panden samenvoegen",
  "Message": "Melding",
  "Mid rent analysis": "Middenhuur analyse",
  "Middle name": "Tussenvoegsel",
  "Min. loan": "Min. lening",
  "Minimal": "Minimale",
  "Minimal ... is ...": "Minimale {{ property }} is {{ value }}",
  "Minimum": "Minimaal",
  "Minimum amount": "Minimaal bedrag",
  "Minimum contract duration": "Minimale contractduur",
  "Minimum debt yield": "Minimale debt yield",
  "Minimum dscr": "Minimale DSCR",
  "Minimum duration": "Minimale looptijd",
  "Minimum energy label": "Minimaal energielabel",
  "Minimum fee": "Minimale vergoeding",
  "Minimum financing amount": "Minimale financieringsbedrag",
  "Minimum free cash flow": "Minimale vrije kasstroom",
  "Minimum free cashflow": "Minimale vrije cashflow",
  "Minimum gross income": "Minimaal bruto inkomen",
  "Minimum icr": "Minimale ICR",
  "Minimum icr without additional income": "Minimale ICR zonder aanvullend inkomen",
  "Minimum loan": "Minimale lening",
  "Minimum loan to value": "Minimale LTV",
  "Minimum loan to value repayment free": "Minimale LTV aflossingsvrij",
  "Minimum number of residential buildings": "Minimaal aantal woningen",
  "Minimum penalty early repayment": "Minimale boete vervroegd aflossen",
  "Minimum repayment rate": "Minimale aflossingspercentage",
  "Minimum repayment rate for ratios at start": "Minimaal aflossingspercentage voor ratio's bij aanvang",
  "Minimum share of value in listed postcodes": "Minimaal waardeaandeel in postcodelijst",
  "Minimum value in rented condition": "Minimale waarde in verhuurde staat",
  "MinimumLoan": "Minimale lening",
  "Missed interest payments": "Ontbrekende rente betalingen",
  "Missing interest": "Maandelijks renteverlies",
  "Missing interest rate": "Huidig rentetarief ontbreekt",
  "Missing start date": "Ontbrekende startdatum",
  "Missing value according to lender at start date": "Waarde volgens geldverstrekker ontbreekt op startdatum",
  "Mixed combination building": "Gemengd combinatiepand",
  "Mixed portfolio": "Gemengde portefeuille",
  "Mixed use": "Gemengd gebruik",
  "Mixed use: maximum non-residential rent share": "Gemengd gebruik: maximaal niet-residentieel huuraandeel",
  "Mixed use: maximum non-residential value share": "Gemengd gebruik: maximaal niet-residentieel waardeaandeel",
  "Mixed use: minimum non-residential value share": "Gemengd gebruik: minimaal niet-residentieel waardeaandeel",
  "Miximal ... is ...": "Maximale {{ property }} is {{ value }}",
  "mo": "mnd",
  "Mobile": "Mobiel",
  "Model": "Model",
  "Moderate": "Matig",
  "Modified at": "Gewijzigd op",
  "MoneyTransfer": "Geld uitboeken",
  "Month": "Maand",
  "Monthly": "Maandelijks",
  "Monthly charges": "Maandelijkse betaling",
  "Monthly charges for other rental mortgages": "Maandlasten van andere verhuurhypotheken",
  "Monthly payment is ... and consists out of": "Maandelijkse betaling bedraagt <strong>{{value}}</strong> en bestaat uit",
  "months": "maanden",
  "Months": "Maanden",
  "More information": "Meer informatie",
  "More than 10": "Meer dan 10",
  "More than 5": "Meer dan 5",
  "More than 5 years": "Meer dan 5 jaar",
  "More than 50%": "Meer dan 50%",
  "More than €1.000.000": "Meer dan €1.000.000",
  "More than €100.000": "Meer dan €100.000",
  "More than €80.000": "Meer dan €80.000",
  "Mortgage": "Hypotheek",
  "Mortgage amount": "Financieringssbedrag",
  "Mortgage deed price": "Kosten hypotheekakte",
  "Mortgage details": "Financieringsinformatie",
  "Mortgage documents": "Lopende financiering documenten",
  "Mortgage number": "Financieringskenmerk",
  "Mortgage processed!": "Hypotheek verwerkt!",
  "Mortgage provided": "Hypotheek verstrekt",
  "Mortgage registration": "Hypothecaire inschrijving",
  "Mortgage registration amount": "Bedrag hypothecaire inschrijving",
  "Mortgage saved": "Lopende financiering opgeslagen",
  "MortgageBuilding": "HypotheekPand",
  "MortgageDeedDraft": "Concept hypotheekakte",
  "MortgagePassed": "Hypotheek gepasseerd",
  "mortgages": "financieringen",
  "Mortgages": "Hypotheken",
  "Mortgages / seizures": "Hypotheken / beslagleggingen",
  "Mortgages in reflection period": "Financieringen in rentebedenktijd",
  "Move buildings": "Verplaats panden",
  "Move to": "Verplaatsen",
  "Moved buildings": "Verplaatste panden",
  "Mr.": "Dhr.",
  "Mrs.": "Mevr.",
  "multi-tenant building": "verzamelgebouw",
  "Multiple applications": "Meerdere aanvragen",
  "Multiple buildings": "Meerdere panden",
  "Multiple loans and lenders": "Combineer geldverstrekkers",
  "Multiple mortgages": "Meerdere financieringen",
  "Multiple owners": "Meerdere eigenaren",
  "Multiple owners have been found at this address. Please select the owner for whom you wish to generate the report.": "Op dit adres zijn meerdere eigenaren gevonden. Kies de eigenaar voor wie je het rapport wenst te genereren.",
  "Municipality": "Gemeente",
  "Municipality in a shrinking region.": "Gemeente in een krimpregio.",
  "Municipality in the Randstad or on the city list, with a good energy label.": "Gemeente in de Randstad of op de stedenlijst, met een goed energielabel.",
  "Municipality in the Randstad or on the city list.": "Gemeente in de Randstad of op de stedenlijst.",
  "n.a.": "n.v.t.",
  "n/a": "n.v.t.",
  "Name": "Naam",
  "Name account holder": "Naam rekeninghouder",
  "Name of the room": "Naam van de kamer",
  "Name of the template": "Naam van het sjabloon",
  "Name of the unit": "Naam van de eenheid",
  "Name of the unit: ": "Naam van de eenheid: ",
  "Name of UBO": "Naam van de UBO",
  "Nationality": "Nationaliteit",
  "Navigate to the customer": "Navigeer naar de klant",
  "Net": "Netto",
  "Net initial yield": "Netto aanvangsrendement",
  "Net rendement (NIY)": "Netto rendement (NAR)",
  "Net rent": "Netto huur",
  "Net rent (residential)": "Netto huur (residentieel)",
  "Net rent income": "Netto huurinkomen",
  "Net rent residential": "Netto huur residentieel",
  "Net rent value": "Netto huurwaarde",
  "Net rental income (next 3 year)": "Netto huurinkomsten (komende 3 jaar)",
  "Net rental income per month": "Netto huurinkomsten per maand",
  "Net rental income per year": "Netto huurinkomsten per jaar",
  "Net rental income share of total income": "Aandeel huurinkosten tov totale inkomen",
  "Net rental income share of total income (next 3 year)": "Aandeel huurinkosten tov totale inkomen (komende 3 jaar)",
  "Net rental value": "Netto huurwaarde",
  "Net return": "Netto rendement",
  "NetInitialYield": "NAR",
  "NetInitialYieldAfterRenovation": "NAR na verbouwing",
  "NetRent": "Netto huur",
  "NetRentIncome": "Netto huur opbrengst",
  "NetRentResidential": "Netto huur residentieel",
  "New": "Nieuw",
  "New application": "Nieuwe aanvraag",
  "New building": "Nieuw pand",
  "New buildings": "Nieuwe panden",
  "New company": "Nieuw bedrijf",
  "New construction uses value after realisation": "Nieuwbouw gebruikt waarde na realisatie",
  "New conversation": "Nieuw gesprek",
  "Recent conversations": "Recente gesprekken",
  "No conversations yet": "Nog geen gesprekken",
  "Conversation": "Gesprek",
  "Documents for your attention": "Documenten die je aandacht vragen",
  "For your attention": "Vraagt je aandacht",
  "Waiting for your answer": "Wacht op je antwoord",
  "Finished": "Afgerond",
  "In progress": "Bezig",
  "The assistant is working on this document…": "De assistent is bezig met dit document…",
  "Delete conversation": "Gesprek verwijderen",
  "New financing": "Nieuwe financiering",
  "New interest": "Nieuwe rente",
  "New interest based on": "",
  "New lender": "Nieuwe geldverstrekker",
  "New lender rate": "Nieuw banktarief",
  "New loan": "Nieuwe lening",
  "New mortgage": "Nieuwe lopende financiering",
  "New ongoing mortgage": "Nieuwe lopende financiering",
  "New person": "Nieuw persoon",
  "new purchase": "nieuwe aankoop",
  "New purchase": "Nieuwe aankoop",
  "New rate": "Nieuw tarief",
  "New rate created": "Nieuw tarief aangemaakt",
  "New registrations": "Nieuwe registraties",
  "New rent income": "Nieuwe huuropbrengst",
  "New rental contract": "Nieuw huurcontract",
  "New rentalcontract end date": "Nieuwe einddatum huurcontract",
  "New rentalcontract name": "Nieuw huurcontract kenmerk",
  "New report": "Nieuw rapport",
  "New room": "Nieuwe kamer",
  "New tenant": "Nieuw huurcontract",
  "New unit": "Nieuwe eenheid",
  "New value": "Nieuwe waarde",
  "New version": "Nieuwe versie",
  "New version created": "Nieuwe versie aangemaakt",
  "Next borrower": "Volgende kredietnemer",
  "Next building": "Volgende pand",
  "Next mortgage": "Volgende lopende financiering",
  "Next property": "Volgend object",
  "Next step": "Volgende stap",
  "Next tab": "Volgende tab",
  "NEXT_PAGE_LABEL": "Volgende pagina",
  "No": "Nee",
  "No account": "Geen account",
  "No actions": "Geen acties",
  "No actions found. Good job!": "Geen acties gevonden. Goed bezig!",
  "No applications found": "Geen aanvragen gevonden",
  "No arrangements found": "Geen afspraken gevonden",
  "No audit entries found": "Geen audit log regels gevonden",
  "No audit log found": "Geen audit log gevonden",
  "No automated value models found": "Geen geautomatiseerde waardemodellen gevonden",
  "No bound": "Geen grens",
  "No buildings found": "Geen panden gevonden",
  "No buildings found that are no longer unowned.": "Geen panden gevonden die niet langer in bezit zijn.",
  "No buildings were found that were not included in this valuation": "Geen panden gevonden die niet zijn ingevoerd bij deze waardering",
  "No clients found": "Geen klanten gevonden",
  "No combination building": "Geen combinatiepand",
  "No combination building rnhb": "Geen combinatiepand (RNHB)",
  "No combined buildings found": "Geen combinatiepanden gevonden",
  "No conversation reports yet": "Nog geen gespreksverslagen",
  "No date": "Geen datum",
  "No dates found": "Geen datums gevonden",
  "No documents": "Geen documenten",
  "No documents found": "Geen documenten gevonden",
  "No documents required": "Geen documenten benodigd",
  "No documents uploaded yet": "Nog geen documenten geüpload",
  "No executing applications found": "Geen te passeren aanvragen gevonden",
  "No expiring mortgages found": "Geen aflopende financieringen gevonden",
  "No financial position known": "Geen financiele positie bekend",
  "No financings found": "Geen financieringen gevonden",
  "No generated reports found": "Geen gegenereerde rapporten gevonden",
  "No income": "Geen inkomen",
  "No income check": "Geen inkomenstoets",
  "No income known": "Geen inkomen bekend",
  "No interest rates configured": "Geen rentes geconfigureerd",
  "No issues found": "Geen problemen gevonden",
  "No limit": "Geen maximum",
  "No linked accounts found": "Geen gekoppelde gebruikers gevonden",
  "No loan parts found": "Geen leningdelen gevonden",
  "No longer valid from": "Niet meer geldig vanaf",
  "no longer valid from": "niet meer geldig vanaf",
  "No lower bound": "Geen ondergrens",
  "No minimum": "Geen minimum",
  "No mortgages found": "Geen lopende financieringen gevonden",
  "No mortgages in reflection period found": "Geen financieringen in rentebedenktijd gevonden",
  "No new buildings found": "Geen nieuwe panden gevonden",
  "No new documents found": "Geen nieuwe documenten gevonden",
  "No new registered addresses found": "Geen nieuwe adresregistraties gevonden",
  "No notes yet": "Nog geen notities",
  "No offers found": "Geen aanbiedingen gevonden",
  "No ongoing mortgages found": "Geen lopende financieringen gevonden",
  "No ongoing renovation found": "Geen lopende verbouwingen gevonden",
  "No owners found": "Geen eigenaren gevonden",
  "No persons found": "Geen personen gevonden",
  "No postcodes listed": "Geen postcodes in de lijst",
  "No profile filled": "Geen profiel ingevuld",
  "No properties found for valuation": "Geen objecten gevonden voor waarderingen",
  "No proposals found": "Geen voorstellen gevonden",
  "No purchase cap": "Geen maximum op basis van aankoop",
  "No rates": "Geen tarieven",
  "No recent financings found": "Geen recente berekeningen gevonden",
  "No recent reports found": "Geen recente rapporten gevonden",
  "No regions listed": "Geen regio's in de lijst",
  "No removed mortgages found": "Alle lopende financieringen zijn gevonden",
  "No renovation records submitted yet.": "Er zijn nog geen verbouwingen ingevoerd.",
  "No renovations found": "Geen verbouwingen gevonden",
  "No rental contracts found": "Geen huurcontracten gevonden",
  "No results": "Geen resultaten",
  "No room rental": "Geen kamerverhuur",
  "No scales found": "Geen schalen gevonden",
  "No separate ratio test interest": "Geen aparte rente voor ratiotoetsen",
  "No tasks found": "Geen taken gevonden",
  "No tenants found": "Geen huurders gevonden",
  "No units found": "Geen eenheden gevonden",
  "No unregistered adresses found": "Geen niet langer geregistreerde adressen gevonden",
  "No updated buildings found": "Geen bijgewerkte panden gevonden",
  "No updated collaborations found": "Geen bijgewerkte samenwerkingen gevonden",
  "No updated mortgages found": "Geen nieuwe of bijgewerkte financieringen gevonden",
  "No upper bound": "Geen bovengrens",
  "No users found": "Geen gebruikers gevonden",
  "No valid input": "Geen geldige invoer",
  "No valuation records submitted yet.": "Er zijn nog geen waarderingen ingevoerd.",
  "No valuations found": "Geen taxatierapporten gevonden",
  "No valuators found": "Geen taxateurs gevonden",
  "No value found": "Geen waarde gevonden",
  "No versions found for this rate": "Geen versies gevonden voor dit tarief",
  "Non eligible building types": "Uitgesloten soorten objecten",
  "Non residential": "Niet-residentieel",
  "Non-family tenants": "Huurders vormen geen gezin",
  "Non-linked": "Niet-gekoppelde",
  "Non-linked documents": "Niet gelinkte documenten",
  "Non-residential": "Non-residentieel",
  "Non-residential building.": "Niet-residentieel object.",
  "Non-residential only in big cities": "Niet-residentieel alleen in grote steden",
  "None": "Geen",
  "NonResidential": "Non-residentieel",
  "Normal rental only": "Alleen reguliere verhuur",
  "Not": "Niet",
  "Not assigned": "Niet toegekend",
  "Not available": "Niet beschikbaar",
  "Not available for interest refinancing analysis": "Niet beschikbaar voor herfinanciering analyserapport",
  "Not financed": "Niet gefinancieerd",
  "Not found addresses": "Niet gevonden adressen",
  "Not in the decision table": "Niet in de beslistabel",
  "Not linked": "Niet gekoppeld",
  "Not observed": "Niet geobserveerd",
  "Not rated": "Niet beoordeeld",
  "Not recognised, please categorize the document": "Niet herkend, koppel het document handmatig",
  "Not rented": "Niet verhuurd",
  "not requested yet": "nog niet opgevraagd",
  "Not visible": "Niet zichtbaar",
  "Notaries": "Notarissen",
  "Notary": "Notaris",
  "Notary fees": "Notariskosten",
  "Note": "Notitie",
  "Notes": "Notities",
  "Nothing configured": "Niets geconfigureerd",
  "Nothing found": "Niets gevonden",
  "Nothing found, click to enter details manually": "Niets gevonden, klik om een adres handmatig in te voeren",
  "Notifications": "Notificaties",
  "Number": "Nummer",
  "Number of applications": "Aantal aanvragen",
  "Number of buildings": "Aantal panden",
  "Number of buildings planned to purchase": "Aantal panden gepland te kopen",
  "Number of buildings purchased (last 5 years)": "Aantal panden gekocht (laatste 5 jaar)",
  "Number of buildings sold (last 5 years)": "Aantal panden verkocht (laatste 5 jaar)",
  "Number of days interest guarantee": "Aantal dagen rentegarantie",
  "Number of linked clients": "Aantal gelinkte klanten",
  "Number of owned buildings": "Aantal panden in bezit",
  "Number of owned rental properties": "Hoeveel verhuurde objecten heeft de klant in bezit?",
  "Number of potential rental contracts": "Aantal mogelijke huurcontracten",
  "Number of potential sublet contracts": "Aantal mogelijke onderverhuur contracten",
  "Number of proposals": "Aantal voorstellen",
  "Number of rental contracts": "Aantal huurcontracten",
  "Number of rooms": "Aantal kamers",
  "Number of sublet contracts": "Aantal onderverhuur contracten",
  "Number of the mortgage": "Financieringskenmerk van de lopende financiering",
  "Number of units": "Aantal eenheden",
  "Number of years anti speculation clause": "Aantal jaren anti-speculatiebeding",
  "Number of years experience": "Aantal jaar professionele ervaring in de vastgoedsector?",
  "NumberOfRentalContracts": "Aantal huurcontracten",
  "NumberOfRentalContractsAfterRenovation": "Aantal huurcontracten na verbouwing",
  "NumberOfSubletContracts": "Aantal onderverhuur contracten",
  "Numbers": "Getallen",
  "Object rating": "Object beoordeling",
  "ObjectRating": "Object beoordeling",
  "objects": "objecten",
  "of": "van",
  "Offer": "Aanbieding",
  "Offer this period in this class": "Deze periode aanbieden in deze klasse",
  "Office": "Kantoor",
  "Offices": "Kantoren",
  "OK": "OK",
  "Old value": "Oude waarde",
  "on": "aanroepen op",
  "On a later moment": "Op een later moment",
  "On which building does the rental contract apply?": "Op welk adres wilt u een huurcontract toevoegen?",
  "On: the purchase cap is the maximum LTV of the building times the purchase amount (e.g. 80% of the purchase price). Off: the cap is the purchase amount itself. Only matters when there is a purchase cap.": "Aan: het maximum op basis van aankoop is de maximale LTV van het object maal het aankoopbedrag (bijv. 80% van de koopsom). Uit: het maximum is het aankoopbedrag zelf. Alleen van belang als er een maximum op basis van aankoop is.",
  "One owner found at this address:": "Eén eigenaar gevonden op dit adres:",
  "One per line": "Eén per regel",
  "One postcode per line: the postcode and the category, separated by a semicolon (for example 1012;Cat1). Paste from a spreadsheet works too.": "Eén postcode per regel: de postcode en de categorie, gescheiden door een puntkomma (bijvoorbeeld 1012;Cat1). Plakken vanuit een spreadsheet werkt ook.",
  "ongoing mortgage": "lopende financiering",
  "Ongoing mortgage": "Lopende financiering",
  "ongoing mortgages": "lopende financieringen",
  "Ongoing mortgages": "Lopende financieringen",
  "ongoing valuation": "lopende waardering",
  "ongoing valuations": "lopende waarderingen",
  "Only a rate no version of which has applied yet can be deleted": "Alleen een tarief waarvan nog geen versie heeft gegolden kan worden verwijderd",
  "Only residential": "Alleen residentieel",
  "Only the buildings that are intended for renting and the buildings that are rented are included in the Dashboard": "Alleen de panden die voor de verhuur bestemd zijn en de panden die verhuurd zijn worden meegenomen in het Dashboard.",
  "Only the first 500 postcodes are shown; use the filter to find a postcode.": "Alleen de eerste 500 postcodes worden getoond; gebruik het filter om een postcode te vinden.",
  "Only the residential units of a combination building count towards its maximum loan.": "Alleen de woonunits van een combinatiepand tellen mee voor de maximale lening.",
  "Only the statuses purchase and owned will be included": "Alleen de statussen eigendom en kopen worden opgenomen",
  "Only valuators that support digital requests are listed here": "Alleen taxateurs die digitale verzoeken ondersteunen worden hier getoond.",
  "Open application": "Open aanvraag",
  "Open building (new window)": "Open pand (nieuw scherm)",
  "Open combination building": "Open combinatie pand",
  "Open documents": "Openstaande documenten",
  "Open quick calculation": "Open als snelle berekening",
  "Open Unite Assistant": "Unite Assistant openen",
  "Operating costs": "Exploitatiekosten",
  "Operating costs per year": "Exploitatiekosten per jaar",
  "OperatingCosts": "Onderhoudskosten",
  "optional": "optioneel",
  "Optional": "Optioneel",
  "or": "of",
  "Or choose an existing borrower to take over": "Of kies een kredietnemer om gegevens van over te nemen",
  "Or choose an existing valuation to take over": "Of kies een bestaande waardering om over te nemen",
  "or enter an address manually": "of voer handmatig een adres in",
  "or to...": "of...",
  "Or upload a document": "Of upload een document",
  "Order": "Volgorde",
  "Order by": "Volgorde",
  "Organization": "Organisatie",
  "Organization information": "Organisatie informatie",
  "Origin own assets": "Herkomst eigen middelen",
  "Origin own resources": "Herkomst eigen middelen",
  "Original collateral value": "Or. waarde onderpand",
  "Original interest": "Originele rente",
  "Original LTV": "Aanvang LTV",
  "Originally build as": "Orgineel gebouwd als",
  "OriginOwnResources": "Herkomst eigen middelen",
  "Other": "Overige",
  "Other costs": "Overige kosten",
  "Other deposit": "Overige depots",
  "OtherDeposit": "Overig depot",
  "Outstanding loan at reference date": "Bedrag lening op peildatum",
  "Outstanding mortgage amount": "Openstaand hypotheek bedrag",
  "Overview": "Overzicht",
  "Own": "Eigen",
  "Own contribution": "Eigen bijdrage",
  "Own contribution:": "Eigen bijdrage:",
  "Own estimate": "Eigen schatting",
  "Own home mortgage charges per month": "Hypotheeklasten eigen woning per maand",
  "Own home mortgage interest": "Rente op eigen woning hypotheek",
  "Own home mortgage loan": "Hypotheek bedrag eigen woning",
  "Own offer": "Eigen aanbieding",
  "Own offers": "Eigen aanbiedingen",
  "Own resources are, for example, money that is freely available in your (savings) account, is invested in shares or can be borrowed via the equity on your own home or from parents / own company.": "Eigen middelen is bijvoorbeeld geld dat vrij beschikbaar is op je (spaar)rekening, belegd is in aandelen of via de overwaarde op je eigen woning of van ouders / eigen onderneming kan worden geleend.",
  "Own use": "Eigen gebruik",
  "Owned": "Eigendom",
  "owned": "in bezit",
  "Owned addresses": "Adressen in bezit",
  "Owned addresses are being retrieved": "Adressen in bezit worden opgehaald",
  "Owned buildings for rent": "Panden in bezit voor verhuur",
  "Owner": "Eigenaar",
  "Owner IBAN stated": "IBAN eigenaar vermeld",
  "Owners": "Eigenaars",
  "Owners are being retrieved": "Eigenaren worden opgehaald",
  "Owners association": "VvE",
  "Owners association contribution": "Bijdrage VvE",
  "Owners description": "Beschrijving eigenaren",
  "OwnersAssociation": "VVE",
  "OwnersDescription": "Beschrijving eigenaren",
  "Ownership information is accurate": "Eigendomsinformatie is accuraat",
  "Ownership share differs from share in matching collaboration": "Aandeel in eigendom wijkt af in gematchte samenwerking",
  "Ownership verified": "Eigendomsinformatie geverifieerd",
  "Owns house": "Bezit huis",
  "Owns more than 3 rental properties": "Bezit meer dan 3 verhuurde panden?",
  "OwnsHouse": "Bezit huis",
  "OwnUse": "Eigen gebruik",
  "p/m": "p/m",
  "Parameters": "Parameters",
  "Parking": "Parkeergelegenheid",
  "Particularities": "Bijzonderheden",
  "Partner alimony": "Partneralimentatie",
  "Partnership": "Maatschap",
  "PartnerShip": "Maatschap",
  "PartnershipUnderFirm": "Vennootschap onder firma",
  "Pass through arrangement": "Doorgeef regeling",
  "PassportCountryOfOrigin": "Paspoort land van herkomst",
  "Password": "Wachtwoord",
  "Password reset email sent": "Wachtwoord opnieuw instellen e-mail verstuurd",
  "Password reset mail sent": "Wachtwoord reset e-mail verstuurd",
  "Pay attention: ": "Let op: ",
  "Payer name": "Naam rekeninghouder",
  "Payment": "Incasso",
  "Payment details": "Incasso gegevens",
  "Payment details2": "Betaalgegevens",
  "Penalty": "Boete",
  "Penalty free repayment": "Boetevrije aflossing",
  "Penalty interest": "Boeterente",
  "Penalty Interest": "Boeterente",
  "Penalty interest amount": "Bedrag boeterente",
  "Penalty-free repayment": "Boetevrije aflossing",
  "Pending": "In afwachting",
  "Pending applications": "Lopende aanvragen",
  "Pension": "Pensioen",
  "per month": "per maand",
  "Per month": "Per maand",
  "per year": "per jaar",
  "Percentage": "Percentage",
  "Period": "Periode",
  "Period in months": "Periode in maanden",
  "Permits available": "Vergunningen aanwezig",
  "Permits irrevocably": "Vergunningen onherroepelijk",
  "Permits requested": "Vergunningen aangevraagd",
  "Permits required": "Vergunningen benodigd",
  "PermitsAvailable": "Vergunningen beschikbaar",
  "PermitsIrrevocably": "Vergunningen onherroepelijk",
  "PermitsRequired": "Vergunningen vereist",
  "Permitted finance charges": "Toegestane financieringslast",
  "Person": "Persoon",
  "Person of contact": "Contactpersoon",
  "Personal information": "Persoonsinformatie",
  "Personal secure environment for fast processing": "Persoonlijke beveiligde omgeving voor snelle verwerking",
  "persons": "personen",
  "Persons": "Personen",
  "Phone": "Telefoon",
  "Places": "Plaatsen",
  "Planned investment": "Geplande investering",
  "Planned renovation does not change the maximum loan.": "Een geplande verbouwing verandert de maximale lening niet.",
  "Please add": "Gelieve bij te voegen",
  "Please add a rejection reason": "Vul een afwijzingsreden in",
  "Please add UBOs": "Gelieve UBO's toe te voegen",
  "please check": "graag controleren",
  "Please edit the value for addresses in the 'Other' category on the grid.": "Bewek de waardes in verhuurde staat voor 'Overig' adressen in de tabel",
  "Please enter combination building valuations separately": "Combinatiepand waarderingen kunnen enkel los worden opgevoerd",
  "Please enter company information before adding shareholders": "Gelieve eerst de bedrijfsgegevens in te voeren alvorens UBO's toe te voegen",
  "Please explain clearly why does document does not match the current needs. The reason will be visible to the customer.": "Geef s.v.p. duidelijk aan waarom het document niet voldoet. De afwijzingsreden is zichtbaar voor de klant.",
  "Please fill out all required fields": "Gelieve alle verplichte velden in te voeren",
  "Please make sure that the client has an email. Otherwise we can not create an account.": "Zorg ervoor dat de klant een e-mail heeft. Anders kunnen we geen account maken.",
  "Please mark an UBO as the primary contact": "Gelieve van één van de UBO's het primaire contactpersoon te maken",
  "Please select a building": "Gelieve een pand te selecteren",
  "Please select a document type": "Gelieve een documentsoort te selecteren",
  "Please select a file that is smaller than 1 mb": "Gelieve een bestand te selecteren dat kleiner is dan 1 mb.",
  "Please select a file with the .jpg or .png extension": "Gelieve een bestand te selecteren met de .png of .jpg extensie",
  "Please select at leaste one guarantor or borrower": "Selecteer ten minste één kredietnemer of borg",
  "Please select the application to update": "Selecteer hier de aanvraag die u wenst bij te werken",
  "Please setup a cadastral id first.": "Gelieve eerst een kadaster id in te stellen",
  "Please setup a cadastral id for each member of the collaboration first.": "Gelieve een kadaster id voor ieder lid van de samenwerking in te stellen",
  "Points rent": "Punten huur",
  "Points total": "Punten totaal",
  "PointsRent": "Puntenhuur",
  "Portal": "Mijn Omgeving",
  "Portal accounts": "Mijn omgeving-gebruikers",
  "Portfolio above threshold": "Portefeuille boven drempel",
  "Portfolio cap above the loan threshold (€ 1.5M).": "Portefeuillemaximum boven de leningdrempel (€ 1,5 mln).",
  "Portfolio that mixes residential and other buildings.": "Portefeuille met zowel woningen als andere objecten.",
  "Possible valuators": "Mogelijke taxateurs",
  "Possibly": "Mogelijk",
  "Postalcode": "Postcode",
  "Postcode": "Postcode",
  "Postcode category": "Postcodecategorie",
  "Postcodes": "Postcodes",
  "Postcodes saved": "Postcodes opgeslagen",
  "Practice space": "Praktijkruimte",
  "PracticeSpace": "Praktijkruimte",
  "Pre-discuss with Unite+": "Voorleggen aan Unite+",
  "Predicted financing amount": "Voorspelling te financieren bedrag",
  "Predicted mediation fees": "Voorspelling bemiddelingskosten",
  "Preferred loan": "Gewenste lening",
  "PreferredLoan": "Gewenste lening",
  "present": "heden",
  "Press on a required document to choose your document": "Druk op een vereist document om uw document te kiezen",
  "Preview": "Preview",
  "Previous borrower": "Vorige kredietnemer",
  "Previous building": "Vorige pand",
  "Previous mortgage": "Vorige lopende financiering",
  "Previous step": "Vorige stap",
  "PREVIOUS_PAGE_LABEL": "Vorige pagina",
  "Previously found mortgage securities that are no longer found in the land registry are displayed here.": "Eerder gevonden hypothecaire zekerheden die niet langer worden gevonden in het kadaster worden hier weergegeven.",
  "Price purchase": "Prijs aankoop",
  "Price rent": "Prijs huur",
  "Price value": "Prijs waarde",
  "Prior renovation": "Voor verbouwing",
  "PrivateCompany": "Besloten vennootschap",
  "PrizeMoney": "Prijzengeld",
  "Pro rato loan": "Pro rato lening",
  "Process changes": "Verwerk wijzigingen",
  "Process VIR": "VIR verwerken",
  "Processing changes": "Wijzigingen worden verwerkt",
  "Processing existing addresses": "Bestaande adressen verwerken",
  "Product": "Product",
  "Profession": "Beroep",
  "Professional": "Professioneel",
  "Professional experience": "Professionele ervaring",
  "Professionals": "Professionals",
  "Profile": "Profiel",
  "Profit after tax per year": "Winst na belasting",
  "Profit after tax tax partner per year": "Winst na belasting fiscaal partner",
  "Progress": "Ontwikkeling",
  "Properties": "Objecten",
  "Property count": "Aantal objecten",
  "Proposal": "Voorstel",
  "Proposal information": "Voorstel informatie",
  "Proposals": "Voorstellen",
  "ProRatoLoan": "Pro rato lening",
  "Providing mortgage": "Verstrekken hypotheek",
  "Province": "Provincie",
  "Provision": "Provisie",
  "Provisional energy label": "Voorlopig energielabel",
  "Public API": "Publieke API",
  "Purchase": "Kopen",
  "Purchase cap": "Maximum op basis van aankoop",
  "Purchase cap after renovation": "Maximum op basis van aankoop na renovatie",
  "Purchase cap applies loan to value": "Maximum op basis van aankoop past LTV toe",
  "Purchase cap includes completed renovation": "Maximum op basis van aankoop inclusief afgeronde renovatie",
  "Purchase costs": "Aankoopkosten",
  "Purchase date": "Aankoopdatum",
  "Purchase price": "Aanschafprijs",
  "Purchase price including costs": "Koopsom inclusief kosten",
  "Purchase protection act applies in ... for homes with a max estimated value by municipality of ...": "Wet opkoopbescherming is van toepassing in {{area}} voor woningen met een maximale WOZ waarde van {{max}}",
  "Purchase sum": "Aankoopsom",
  "purchase value": "koopsom",
  "Purchase value": "Koopsom",
  "Purchase value pro rata": "Koopsom pro rato",
  "PurchaseCosts": "Aankoopkosten",
  "PurchaseDate": "Aankoopdatum",
  "PurchaseValue": "Koopsom",
  "PurchaseValueIncludingCosts": "Koopsom inclusief kosten",
  "PurchaseValueIncludingCostsAndRenovation": "Koopsom inclusief kosten en verbouwing",
  "Purpose": "Doel",
  "Purpose of the real estate": "Doel van het vastgoed",
  "Quick calculation": "Snelle berekening",
  "Quick refinancing": "Snelle herfinanciering",
  "Raises to purchase price plus completed renovation": "Verhoogt tot koopsom plus afgeronde renovatie",
  "Randstad": "Randstad",
  "RANGE_PAGE_LABEL_1": "0 van {{length}}",
  "RANGE_PAGE_LABEL_2": "{{startIndex}} - {{endIndex}} van {{length}}",
  "Rate": "Tarief",
  "Rate check": "Controle",
  "Rate deleted": "Tarief verwijderd",
  "Rate details": "Tariefdetails",
  "Rate discontinued": "Tarief beëindigd",
  "Rate number": "Tariefnummer",
  "Rate per year": "Tarief per jaar",
  "Rate profile saved": "Tariefprofiel opgeslagen",
  "Rate resumed": "Tarief hervat",
  "Rates": "Tarieven",
  "Ratios": "Ratio's",
  "Read more": "Lees meer",
  "Real estate": "Vastgoed",
  "Real estate part of your pension provision": "Vastgoed onderdeel van pensioenvoorziening",
  "Real estate plan analysis": "Vastgoedplan analyse",
  "Real estate portfolio": "Vastgoedportefeuille",
  "Real estate tax": "Onroerendezaak belasting",
  "Real estate value": "Waarde vastgoed",
  "Real estate value based on": "Waarde vastgoed gebasseerd op",
  "RealEstate": "Vastgoed",
  "RealEstatePortfolio": "Vastgoedportefeuille",
  "Realization risk": "Realisatierisico",
  "RealizationRisk": "Realisatie risico",
  "Reason": "Reden",
  "Reasonable": "Redelijk",
  "Reasonable to good": "Redelijk tot goed",
  "ReasonableToGood": "Redelijk tot goed",
  "Recalculate": "Herbereken",
  "Received": "Ontvangen",
  "Received documents": "Ontvangen documenten",
  "Received mediation fees": "Bemiddelingsvergoeding ontvangen",
  "ReceivedByLender": "Verzonden naar geldverstrekker",
  "Receivers": "Ontvangers",
  "Recent financings": "Laatste berekeningen",
  "Recent purchase period": "Periode recente aankoop",
  "Recent reports": "Laatste rapporten",
  "Recognised as": "Herkend als",
  "Recognised automatically, please check the values": "Automatisch herkend, controleer de gegevens",
  "Recommended": "Aanbevolen",
  "Recreation": "Recreatie",
  "Redirect not found": "Doorverwijzing niet gevonden",
  "Redirecting you to the application": "U wordt doorverwezen naar de aanvraag",
  "Reference date": "Peildatum",
  "ReferenceDate": "Peildatum",
  "Refinance": "Herfinancieren",
  "Refinance mortgages": "Financieringen herfinancieren",
  "Refinance penalty": "Herfinancieringsboete",
  "Refinancing amount": "Herfinancieringsbedrag",
  "Refinancing penalty interest": "Herfinancierings boete rente",
  "RefinancingAmount": "Bedrag herfinanciering",
  "Reflection from": "Bedenktijd vanaf",
  "reflection period": "bedenktijd",
  "Reflection period (months)": "Bedenktijd (maanden)",
  "Refresh data": "Vernieuw gegevens",
  "Region": "Regio",
  "Regions": "Regio's",
  "Regions saved": "Regio's opgeslagen",
  "RegisteredPartnership community property": "Geregistreerd partnerschap met gemeenschap van goederen",
  "RegisteredPartnership prenup": "Geregistreerd partnerschap onder voorwaarde",
  "RegisteredPartnershipCommunityProperty": "Geregistreerd partnerschap met gemeenschap van goederen",
  "RegisteredPartnershipPrenup": "Geregistreerd partnerschap onder voorwaarde",
  "Regular / independent": "Regulier / zelfstandig",
  "Reject": "Afwijzen",
  "Reject document": "Document afwijzen",
  "Rejected": "Afgewezen",
  "RejectedByLender": "Afgewezen door geldverstrekker",
  "Rejection reason": "Afwijzingsreden",
  "Rejections": "Afwijzingen",
  "Related": "Gerelateerd",
  "Relation": "Relatie",
  "Relation with real estate": "Relatie met vastgoed",
  "RelationWithRealEstate": "Relatie met vastgoed",
  "Relocation arrangement": "Verhuisregeling",
  "Remaining": "Resterend",
  "Remaining contract duration": "Resterende contractduur",
  "Remaining days": "Resterende dagen",
  "Remaining fixed-rate period": "Resterende rentevast periode",
  "Remaining loan": "Resterende hypotheekbedrag",
  "Remaining mortgage amount": "Resterende hypotheek bedrag",
  "Remark": "Opmerking",
  "Remove": "Verwijder",
  "Remove attachment": "Bijlage verwijderen",
  "Remove earlier renovations?": "Eerdere verbouwingen verwijderen?",
  "Remove form": "Verwijder formulier",
  "Remove guarantor": "Verwijder borgsteller",
  "Remove tenant": "Verwijder huurder",
  "Remove this fixed interest period": "Deze rentevaste periode verwijderen",
  "Remove this loan to value class": "Deze LTV-klasse verwijderen",
  "Removed buildings": "Niet gevonden panden",
  "Removed buildings marked as still owned": "Niet gevonden panden die nog steeds in bezit zijn",
  "Removed mortgages": "Niet gevonden hypotheken",
  "Rendement": "Rendement",
  "Renovate": "Verbouw",
  "Renovation": "Verbouwing",
  "Renovation costs": "Verbouwingskosten",
  "Renovation costs pro rata": "Verbouwingskosten pro rato",
  "Renovation date": "Verbouwingsdatum",
  "Renovation included": "Inclusief verbouwing",
  "Renovation planned": "Verbouwing gepland",
  "RenovationCosts": "Verbouwingskosten",
  "Renovations": "Verbouwingen",
  "Rent": "Verhuren",
  "Rent amount": "Huur",
  "Rent and ratios": "Huur en ratio's",
  "Rent component": "Huur component",
  "Rent income": "Huuropbrengst",
  "Rent income updated at": "Huuropbrengst gewijzigd op",
  "Rent per month": "Huur per maand",
  "Rent totals": "Huur totalen",
  "Rent type": "Soort huur",
  "Rentability": "Verhuurbaarheid",
  "RentabilityRating": "Verhuurbaarheid beoordeling",
  "Rental contract": "Huurcontract",
  "Rental contract expires": "Huurcontract loopt af",
  "Rental contracts": "Huurcontracten",
  "Rental points": "Puntenhuur",
  "Rental through company?": "Verhuurd via bedrijf?",
  "Rental to family": "Verhuur aan familie",
  "Rental type": "Soort verhuur",
  "Rental value": "Huurwaarde",
  "Rental value after renovation": "Huurwaarde na verbouwing",
  "RentalContract": "Huurcontract",
  "Rentalcontract end date": "Einddatum huurcontract",
  "Rentalcontract name": "Huurcontract kenmerk",
  "RentalToFamily": "Verhuur aan familie",
  "RentalValue": "Huurwaarde",
  "RentalValueAfterRenovation": "Huurwaarde na verbouwing",
  "Rented": "Verhuurd",
  "Rented new": "Verhuurd nieuw",
  "Rented out for more than 12 months": "Langer dan 12 maanden verhuurd?",
  "Rented since": "Verhuurd vanaf",
  "Rented surface": "Vehuurde oppervlakte",
  "Rented to": "Verhuurd aan",
  "Rented to migrate workers?": "Verhuurd aan arbeidsmigranten?",
  "Rented value, or vacant value when for sale": "Waarde verhuurde staat, of leegwaarde bij verkoop",
  "RentedAreaM2": "Verhuurde vierkante meters",
  "RentIncome": "Huuropbrengst",
  "Rents house": "Huurt huis",
  "RentsHouse": "Huurt huis",
  "Repay in": "Aflossen in",
  "Repayed": "Afgelost",
  "Repaying": "Aflossen",
  "Repaying only": "Alleen aflossend",
  "repayment": "aflossing",
  "Repayment": "Aflossing",
  "Repayment (annually)": "Aflossing (per jaar)",
  "Repayment amount": "Aflossingsbedrag",
  "Repayment amount first year": "Aflossingsbedrag eerste jaar",
  "Repayment amount for the first year": "Aflossingsbedrag voor het eerste jaar",
  "Repayment existing mortgage": "Aflossing lopende financiering",
  "Repayment free": "Aflossingsvrij",
  "Repayment free at loan to value": "Aflossingsvrij bij LTV",
  "Repayment free from LTV": "Aflossingsvrij vanaf LTV",
  "Repayment free only": "Alleen aflossingsvrij",
  "Repayment per year": "Aflossing per jaar",
  "Repayment percentage per year without penalty": "Boetevrij aflossingspercentage per jaar",
  "Repayment rate": "Aflossingspercentage",
  "Repayment rate first year": "Aflossingspercentage eerste jaar",
  "Repayment required": "Aflossing vereist",
  "Repayment rules": "Aflossingsregels",
  "Repayment type": "Aflossingstype",
  "Repayment variant": "Aflosvorm",
  "Repayment without penalty": "Boetevrij aflossen",
  "Repayment without penalty restrictions": "Beperkingen boetevrij aflossen",
  "RepaymentAmountFirstYear": "Aflossing bedrag eerste jaar",
  "RepaymentFree": "Aflossingsvrij",
  "RepaymentFreeAndAnnuity": "Annuïteit + {{value}}% aflossingsvrij",
  "RepaymentFreeAndLinear": "Lineair + {{value}}% aflossingsvrij",
  "RepaymentRateFirstYear": "Aflossing percentage eerste jaar",
  "Repayments": "Aflossingen",
  "Replace": "Vervangen",
  "Report": "Rapport",
  "Report type": "Rapport type",
  "ReportBox3Analysis": "Box 3 analyserapport",
  "ReportBox3AnalysisDescription": "Het box 3 rapport berekent belastingverschillen tussen het oude regime en het overgangsregime en toont de opbouw van het belastingbedrag. Het bepaalt ook de leegwaarderatio en de fiscale waarde per pand. Klanten kunnen waardes voor spaargeld, overige bezittingen en schulden toevoegen voor een nauwkeuriger belastingbedrag.  ",
  "ReportBox3AnalysisTitle": "Box 3 analyserapport",
  "ReportBox3AnalysisTitleDescription": "Dit rapport berekent het verschil in belastingbedrag tussen het oude regime box 3 en het overgangsregime.",
  "ReportBusinessPlanAnalysis": "Businessplan analyserapport",
  "ReportBusinessPlanAnalysisDescription": "Het rapport 'Businessplan' is ontworpen voor vastgoedbeleggers en geeft inzicht in hun huidige situatie en toekomstplannen om het maximale rendement uit hun vastgoedportefeuille te halen. Deze analyse brengt tevens de cashflow per pand in kaart en laat het zien of het haalbaar is om deze cashflow positief te beïnvloeden door aanpassing van het energielabel. De klant kan aan de hand van alle berekende waardes het gewenste scenario voor elk pand ingeven, zodat uiteindelijk een businessplan naar de toekomst ontstaat.",
  "ReportBusinessPlanAnalysisTitle": "Businessplan analyserapport",
  "ReportBusinessPlanAnalysisTitleDescription": "Het nieuwste rapport in Unite leidt tot een actieplan, waarbij per pand in beeld wordt gebracht wat de impact is van zowel Box 3, de geplande Middenhuur-regeling als de stijgende rente.",
  "ReportMidRentAnalysis": "Middenhuur analyserapport",
  "ReportMidRentAnalysisDescription": "Op dit moment vallen sommige woningen nog in de vrijesector en kun je zelf de huurprijs bepalen. Echter, vanaf 2024 zal een deel van de vrijesector veranderen in de middenhuur, wat kan leiden tot een daling in de huurinkomsten. In dit rapport kun je terugvinden wat de impact hiervan is en hoe je de mogelijke daling van de huur kunt voorkomen door bijvoorbeeld het aanpassen van het energielabel. Het rapport geeft per pand aan of een woning nu en na 2024 binnen de sociale sector valt, in de middenhuur of in de vrijesector en welk energielabel je kunt aanpassen om de huur te verhogen en de waarde van je portefeuille te vergroten.",
  "ReportMidRentAnalysisTitle": "Middenhuur analyserapport",
  "ReportMidRentAnalysisTitleDescription": "Dit rapport toont het verschil in huurinkomsten als gevolg van de voorgenomen plannen rond middenhuur per 1-1-2024, inclusief de impact die aanpassing naar een hoger energielabel op de huuropbrengst zou hebben.",
  "ReportPurchaseAnalysis": "Aankoop analyserapport",
  "ReportPurchaseAnalysisDescription": "Het berekenen van het te behalen rendement wordt steeds complexer door de huidige veranderingen. Dit rapport rekent alle relevante ratio's en rendementen, zoals BAR, NAR, ROE en ROI, door, bij een voorgenomen aankoop van 1 of meerdere panden. Zowel de effecten zonder als met de middenhuurplannen en gewijzigde BOX 3-regelgeving worden meegenomen, samen met de actuele rentetarieven. En voert u een gewenst rendement in?  Dan wordt de maximale investering berekend.",
  "ReportPurchaseAnalysisTitle": "Aankoop analyserapport",
  "ReportPurchaseAnalysisTitleDescription": "Dit rapport toont het rendement bij de voorgenomen aankoop van één of meerdere panden, rekening houdend met actuele wet- en regelgeving, inclusief aanstaande veranderingen.",
  "ReportRefinancingAnalysis": "Herfinanciering analyserapport",
  "ReportRefinancingAnalysisDescription": "De rente die een belegger betaalt, heeft grote invloed op de financiële situatie van de belegger. Als  de rentevast periode van een lening afloopt, kunnen de financieringslasten behoorlijk wijzigen. Er wordt in dit rapport in beeld gebracht welk bedrag maximaal kan worden geleend en wat dan het effect van een rente wijziging op de cashflow is. De berekende financiering komt tot stand door een real-time vergelijking van de tarieven, actuele rentes en aflossingscondities van vrijwel alle geldverstrekkers in Nederland.",
  "ReportRefinancingAnalysisTitle": "Herfinanciering analyserapport",
  "ReportRefinancingAnalysisTitleDescription": "Dit rapport analyseert het effect van een rentewijziging op de cashflow, aan de hand van een berekening voor een herfinanciering.",
  "Reports": "Rapporten",
  "ReportStructuralRiskAnalysis": "Structuurrisico analyserapport",
  "ReportStructuralRiskAnalysisDescription": "Als een belegger verschillende financiers en/of verschillende types onderpand in bezit heeft ontstaat er een structuurrisico. De opstelling van de ene financier kan de positie van de ander financier beïnvloeden, daarom is belangrijk om dit risico in beeld te hebben. Dit rapport brengt in kaart welke (type) panden in bezit zijn met bijbehorende huuropbrengsten. De lopende financieringen van de verschillende financiers worden vervolgens aan de panden gekoppeld. Bij de lopende financieringen worden de openstaande hoofdsommen, de rente, de aflossing en expiratiedatum van de rentevast periode in het rapport verwerkt. Ratio’s als DSCR, ICR en LLD worden daardoor in 1 oogopslag inzichtelijk en zijn desgewenst aan de hand van diverse parameters als type panden, geldverstrekker of financiering te filteren.",
  "ReportStructuralRiskAnalysisTitle": "Structuurrisico analyserapport",
  "ReportStructuralRiskAnalysisTitleDescription": "Met dit rapport worden ratio’s als DSCR, ICR en LLD inzichtelijk gemaakt, waardoor in geval van meerdere financieringen bij verschillende geldverstrekkers het structuurrisico eenvoudig kan worden ingeschat.",
  "Request": "Verzoek",
  "Request analysis report": "Analyserapport aanvragen",
  "Request documents": "Documenten opvragen",
  "Request financing advice": "Financieringsadvies aanvragen",
  "Request new valuation": "Waardering uitzetten",
  "Request non-committal application": "Vrijblijvende offerte aanvragen",
  "Request purchase analysis report": "Aankoop analyserapport aanvragen",
  "Request valuation": "Waardering uitzetten",
  "Request valuation approval and send request automatically": "Verzoek klant om goedkeuring automatisch taxatieverzoek",
  "Requested": "Opgevraagd",
  "Requested documents at": "Documenten opgevraagd bij",
  "requested on": "aangevraagd op",
  "Required by lender": "Vereist door geldverstrekker",
  "Required documents": "Benodigde documenten",
  "Requires a combination building": "Vereist een combinatiepand",
  "Requires a listed postcode": "Vereist een postcode uit de lijst",
  "Resend verification email": "Verificatie e-mail opnieuw versturen",
  "Reset": "Reset",
  "Reset filters": "Reset filters",
  "Reset password": "Verstuur wachtwoord herstel e-mail",
  "Retry": "Opnieuw proberen",
  "Residential": "Residentieel",
  "Residential building with a good energy label.": "Woning met een goed energielabel.",
  "Residential building.": "Woning.",
  "Residential rent only": "Alleen residentiele huur",
  "Residential units only": "Alleen woonunits",
  "Residential, good energy label": "Woning, goed energielabel",
  "Restaurant": "Restaurant",
  "Result": "Resultaat",
  "Results": "Resultaten",
  "Resume": "Hervatten",
  "Resume rate": "Tarief hervatten",
  "Resuming reopens the rate with a copy of its last version, from the given day (not before the day it ended).": "Hervatten heropent het tarief met een kopie van de laatste versie, vanaf de opgegeven dag (niet voor de dag waarop het eindigde).",
  "RET": "OZB",
  "Retrieve owners": "Eigenaren opzoeken",
  "Retrieving ... addresses": "{{value}} Adressen ophalen",
  "Retrieving 1 address": "1 Adres ophalen",
  "Retrieving addresses": "Adressen ophalen",
  "Retrieving applications": "Aanvragen ophalen",
  "Retrieving audit entries": "Ophalen audit log regels",
  "Retrieving audit log": "Ophalen audit log",
  "Retrieving building details at Kadaster": "Pandgegevens ophalen bij kadaster",
  "Retrieving buildings": "Panden ophalen",
  "Retrieving clients": "Klanten ophalen",
  "Retrieving compositions": "Ophalen combinaties",
  "Retrieving dates": "Datums ophalen",
  "Retrieving documents": "Documenten ophalen",
  "Retrieving engery label": "Energielabel ophalen",
  "Retrieving executing applications": "Ophalen te passeren aanvragen",
  "Retrieving expiring mortgages": "Ophalen aflopende financieringen",
  "Retrieving financings": "Berekeningen ophalen",
  "Retrieving information": "Informatie ophalen",
  "Retrieving lenders": "Geldverstrekkers ophalen",
  "Retrieving mortgages": "Hypotheken ophalen",
  "Retrieving mortgages in reflection period": "Financieringen in rentebedenktijd ophalen",
  "Retrieving new building information": "Meest recente gegevens worden opgehaald",
  "Retrieving ongoing mortgages": "Lopende financieringen ophalen",
  "Retrieving owned buildings": "Panden in bezit worden geladen",
  "Retrieving possible receivers": "Ophalen mogelijke ontvangers",
  "Retrieving properties for valuation": "Objecten ophalen voor waardering",
  "Retrieving proposals": "Voorstellen ophalen",
  "Retrieving rate details": "Tariefdetails ophalen",
  "Retrieving recent financings": "Laatste berekeningen ophalen",
  "Retrieving recent reports": "Laatste rapporten ophalen",
  "Retrieving registered addresses from land registry and comparing them to the current real estate porfolio": "Ophalen geregistreerde adressen bij het kadaster en ze vergelijken met de huidige vastgoedportefeuille",
  "Retrieving reports": "Rapporten ophalen",
  "Retrieving results": "Resultaten worden opgehaald",
  "Retrieving tasks": "Taken ophalen",
  "Retrieving valuators": "Taxateurs ophalen",
  "Retrieving WOZ-value": "WOZ-waarde ophalen",
  "Retrieving your data": "Uw gegevens ophalen",
  "Return": "Rendement",
  "Return on equity": "Rendement op eigen vermogen",
  "Return on investment": "Return on investment",
  "Return on own equity": "Rendement op eigen vermogen",
  "Return on own investment": "Rendement op eigen investering",
  "Return to financing": "Terug naar de berekening",
  "Returns": "Rendementen",
  "Revenue": "Inkomsten",
  "ROE": "ROE",
  "ROE own investment": "ROE eigen investering",
  "ROI": "ROI",
  "Room": "Kamer",
  "Room 1": "Kamer 1",
  "Room rental": "Kamerverhuur",
  "Room rental only in student cities": "Kamerverhuur alleen in studentensteden",
  "Room rental.": "Kamerverhuur.",
  "Room units": "Kamerunits",
  "Rooms": "Kamers",
  "Roomrental": "Kamerverhuur",
  "RoomRental": "Kamerverhuur",
  "RoomRentalAfterRenovation": "Kamerverhuur na verbouwing",
  "Rooms and board": "Kost en inwoning",
  "Rows in the same group are alternatives: at most one applies, the first one (by order) whose condition holds. Rows in different groups add up.": "Regels in dezelfde groep zijn alternatieven: er geldt er hooguit één, de eerste (op volgorde) waarvan de voorwaarde klopt. Regels uit verschillende groepen tellen op.",
  "Run check": "Controle uitvoeren",
  "Running": "Bezig",
  "Saleability": "Verkoopbaarheid",
  "SaleabilityRating": "",
  "SaleOfInvestments": "Verkoop van investeringen",
  "SaleOfProperty": "Verkoop van object",
  "Same as other buildings": "Zoals andere objecten",
  "Save": "Opslaan",
  "Save ... changes": "{{value}} wijzigingen opslaan",
  "Save ... collaborations": "{{value}} samenwerkingen opslaan",
  "Save account": "Account opslaan",
  "Save all": "Alles opslaan",
  "Save all ... buildings": "Alle {{value}} panden opslaan",
  "Save all and proceed": "Alles opslaan en doorgaan",
  "Save application": "Aanvraag bewaren",
  "Save arrangement": "Sla afspraak op",
  "Save AVM": "AVM opslaan",
  "Save building": "Sla pand op",
  "Save collaboration": "Sla samenwerking op",
  "Save company": "Sla bedrijf op",
  "Save fee settings": "Sla vergoeding instellingen op",
  "Save mortgage": "Sla lopende financiering op",
  "Save ongoing mortgage": "Sla lopende financiering op",
  "Save organization": "Organisatie opslaan",
  "Save person": "Sla persoon op",
  "Save postcodes": "Postcodes opslaan",
  "Save profile": "Profiel opslaan",
  "Save regions": "Regio's opslaan",
  "Save settings": "Instellingen opslaan",
  "Save tenant": "Huurder opslaan",
  "Save user": "Gebruiker opslaan",
  "Save valuation": "Waardering opslaan",
  "Save valuator": "Taxateur opslaan",
  "saved": "opgeslagen",
  "Saved": "Opgeslagen",
  "Saved!": "Opgeslagen!",
  "Savings, receivables and other": "Spaargeld, vorderingen en overige",
  "Scale:": "Schaal:",
  "Score": "Score",
  "Screensharing": "Scherm delen",
  "search": "zoek",
  "Search": "Zoeken",
  "Search a valuator": "Zoek een taxateur",
  "Search company by name": "Zoek bedrijf op naam",
  "Search document": "Zoek document",
  "Search existing": "Zoek bestaande",
  "Search for a person": "Zoeken naar een persoon",
  "Search for a person or company": "Zoeken naar een bedrijf of persoon",
  "Search for address": "Zoek naar adres",
  "Search for application": "Zoek naar aanvraag",
  "Search for client, property, mortgage": "Zoeken naar klant, pand of financiering",
  "Search for document types": "Zoek naar documentsoorten",
  "Search for existing document": "Zoeken naar bestaand document",
  "Search in documents": "Zoeken in documenten",
  "Search on a buildings address, purpose, status or type": "Zoek het adres, doel, status of type van een pand op",
  "Search person": "Zoek persoon",
  "Searching for matching documents": "Bijpassende documenten zoeken",
  "Second": "Tweede",
  "Second mortgage charges per month": "Lasten tweede hypotheek per maand",
  "Seizures": "Beslagleggingen",
  "Select": "Selecteer",
  "Select a client": "Selecteer een klant",
  "Select a document": "Selecteer een document",
  "Select a lender from the list or enter the name of the lender": "Selecteer een geldverstrekker uit de lijst of voeg hem toe",
  "Select a person": "Selecteer een persoon",
  "Select document": "Selecteer document",
  "Select existing": "Selecteer bestaande",
  "Select or drag file": "Selecteer of sleep bestand",
  "Select report": "Rapport selecteren",
  "Select the addresses to be financed": "Selecteer de te financieren adressen",
  "Select the buildings to which this mortgage is linked": "Selecteer de gerelateerde panden",
  "Select the documents that will be requested in the e-mail": "Selecteer de documenten die per e-mail opgevraagd",
  "Select the owner that matches ...": "Selecteer de eigenaar die overeenkomt met {{value}}",
  "Select the owners that will apply for financing": "Selecteer de eigenaren die de financiering aanvragen",
  "Select the related buildings": "Selecteer de gerelateerde panden",
  "Select the target customer per building": "Selecteer de gewenste klant per pand",
  "Select your report": "Selecteer je rapport",
  "Selected buildings": "Geselecteerde panden",
  "Selected ongoing financings": "Geselecteerde lopende financieringen",
  "Selected profile:": "Geselecteerde profiel:",
  "Selection": "Selectie",
  "Sell": "Verkopen",
  "SellOff": "Uitponden",
  "Send": "Versturen",
  "Send additional information": "Verstuur aanvullende informatie",
  "Send document": "Verstuur document",
  "Send password reset email": "Stuur wachtwoord reset mail",
  "Send signed loan agreement": "Verstuur getekende leningsovereenkomst",
  "Send to": "Verstuur naar ",
  "Sending application": "Verstuur aanvraag",
  "Sending the valuations to the lender": "Waarderingen worden verstuurd naar de geldverstrekker",
  "Sent documents": "Verzonden documenten",
  "Service charge": "Servicekosten",
  "Service charge per month": "Prijs servicekosten",
  "Session": "Sessie",
  "Set financial position": "Vul financiele positie in",
  "Set income": "Inkomen bijwerken",
  "Set to Dutch": "Stel in op Nederlands",
  "Set to English": "Stel in op Engels",
  "Setting": "Instelling",
  "Settings": "Instellingen",
  "Settings saved": "Instellingen opgeslagen",
  "Severity": "Ernst",
  "Sewage charges": "Rioolheffing",
  "Share": "Aandeel",
  "Share %": "Aandeelpercentage",
  "Share:": "Aandeel:",
  "Shareholder of": "Aandeelhouder van",
  "Shareholders": "Aandeelhouders",
  "Short": "Kort",
  "Short stay": "Shortstay",
  "Shorter": "Korter",
  "Shortstay": "Shortstay",
  "Show all": "Toon alle",
  "Show all conversation reports": "Toon alle gespreksverslagen",
  "Show all notes": "Toon alle notities",
  "Show all rejections": "Laat alle afwijzingen zien",
  "Show all results": "Laat alle resultaten zien",
  "Show details": "Toon details",
  "Show in dashboard": "Toon in dashboard",
  "Show more": "Toon meer",
  "Show screen sharing code": "Code voor scherm delen laten zien",
  "Shrinking region": "Krimpregio",
  "Single": "Alleenstaand",
  "Single / family": "Alleenstaand(e) / familie",
  "Single cap for a rate that does not distinguish building types.": "Eén maximum voor een tarief dat geen onderscheid maakt in soorten objecten.",
  "Single proposal per lender": "Enkel voorstel per geldverstrekker",
  "sir": "meneer",
  "Situation": "Situatie",
  "Skip": "Overslaan",
  "Skip building": "Pand overslaan",
  "Skip this step": "Sla deze stap over",
  "SMS on status change": "SMS bij status wijziging",
  "SMS on status update disabled": "SMS bij status wijziging uitgeschakeld",
  "SMS on status update enabled": "SMS bij status wijziging ingeschakeld",
  "Social rent": "Sociale huur",
  "Sold": "Verkocht",
  "SoleProprietorship": "Eenmanszaak",
  "Solve the following problems, so that you can send the application to the lender:": "Voordat u de aanvraag kunt indienen bij de hypotheekverstrekker, dient u de volgende zaken nog aan te vullen:",
  "Something else…": "Iets anders…",
  "Something went wrong": "Er ging iets verkeerd. Probeer de actie opnieuw",
  "Sort": "Sortering",
  "Sort by": "Sorteer op",
  "SortDirection": "Sortering",
  "Source": "Bron",
  "Special rent": "Bijzonder verhuur",
  "Specific amount": "Specifiek leenbedrag",
  "Specific loan amount": "Specifiek leenbedrag",
  "Specifications": "Specificaties",
  "Specifications mortgage": "Specificaties financiering",
  "Specified": "Opgegeven",
  "split": "splitsen",
  "Split": "Splitsen",
  "Split costs": "Splitsingskosten",
  "Split costs pro rata": "Splitsingskosten pro rato",
  "SplitCosts": "Splitsingskosten",
  "SplitPermitsAvailable": "Splitsing vergunningen aanwezig",
  "SplitPermitsIrrevocably": "Splitsing vergunningen onherroepnaar",
  "Start": "Start",
  "Start date": "Startdatum",
  "Start date contract": "Startdatum contract",
  "Start moment interest guarantee": "Startmoment rentegarantie",
  "Start moment period to pass at notary": "Startmoment termijn passeren bij notaris",
  "Start new finance": "Start nieuwe financiering",
  "Start purchase analysis": "Start aankoopanalyse",
  "Start VIR?": "VIR Starten?",
  "StartDate": "Startdatum",
  "Starting this VIR may result in high data costs": "Het starten van deze VIR kan resulteren in hoge kosten",
  "Starting this VIR will result in high data costs (€...)": "Het starten van deze VIR zal resulteren in hoge kosten (€ {{ value }})",
  "Starting VIR": "VIR wordt gestart",
  "Status": "Status",
  "Status (client)": "Status (klant)",
  "Status lender": "Status geldverstrekker",
  "Statutory location": "Statutair gevestigd",
  "Statutory name": "Statutaire naam",
  "Still owned": "Nog steeds in bezit",
  "Stop": "Stoppen",
  "Store": "Winkel",
  "Stores": "Winkels",
  "street": "Straat",
  "Street": "Straat",
  "Structural risk analysis": "Structuurrisico analyse",
  "Student city": "Studentenstad",
  "Student debt": "Studieschuld",
  "Student debt new system": "Studieschuld nieuwe leenstelsel",
  "Students": "Studenten",
  "Studio": "Studio",
  "Sublet": "Onderverhuur",
  "Subletting": "Onderverhuur",
  "Submit application to": "Aanvraag indienen bij",
  "Submit loan part": "Leningdeel toevoegen",
  "Submit renovation": "Verbouwing invoeren",
  "Submit valuation": "Waardering invoeren",
  "SubmitErrorAddress is missing": "Adres ontbreekt",
  "SubmitErrorAddress line 1 is missing": "Adres regel 1 ontbreekt",
  "SubmitErrorApplicant address country is missing": "Het land in het adres van de aanvrager ontbreekt",
  "SubmitErrorApplicant contact birthdate is missing": "Geboortedatum van de aanvrager contactpersoon ontbreekt",
  "SubmitErrorApplicant contact emailaddress is missing": "E-mailadres van de aanvrager contactpersoon ontbreekt",
  "SubmitErrorApplicant contact initials are missing": "Initialen van de aanvrager contactpersoon ontbreken",
  "SubmitErrorApplicant contact is missing": "Contactpersoon aanvrager ontbreekt",
  "SubmitErrorApplicant contact phone is missing": "Telefoonnummer van de aanvrager contactpersoon ontbreekt",
  "SubmitErrorApplicant contact surname is missing": "Achternaam van de aanvrager contractpersoon ontbreekt",
  "SubmitErrorApplicant emailaddress is missing": "E-mailadres aanvrager ontbreekt",
  "SubmitErrorApplicant emailaddress tax partner is missing": "E-mailadres fiscaal partner van de aanvrager ontbreekt",
  "SubmitErrorApplicant founding date is missing": "De oprichtingsdatum van de aanvrager ontbreekt",
  "SubmitErrorApplicant investment profile is missing": "Investeringsprofiel van de aanvrager ontbreekt",
  "SubmitErrorApplicant legal form is missing": "Rechtsvorm aanvrager ontbreekt",
  "SubmitErrorApplicant marital status is missing": "Burgerlijke staat van de aanvrager ontbreekt",
  "SubmitErrorApplicant nationality is missing": "Nationaliteit van de aanvrager ontbreekt",
  "SubmitErrorApplicant phone is missing": "Telefoonnummer van de aanvrager ontbreekt",
  "SubmitErrorApplicant statutory location is missing": "De statutaire locatie van de aanvrager ontbreekt",
  "SubmitErrorApplicant statutory name is missing": "De statutaire naam van de aanvrager ontbreekt",
  "SubmitErrorApplicant tax partner is missing": "Fiscaal partner van de aanvrager ontbreekt",
  "SubmitErrorBorrower address country is missing": "Het land in het adres kredietnemer ontbreekt",
  "SubmitErrorBorrower contact is missing": "Contactpersoon kredietnemer ontbreekt",
  "SubmitErrorBorrower emailaddress is missing": "E-mailadres kredietnemer ontbreekt",
  "SubmitErrorBorrower emailaddress tax partner is missing": "E-mailadres fiscaal partner van kredietnemer ontbreekt",
  "SubmitErrorBorrower founding date is missing": "Oprichtingsdatum kredietnemer ontbreekt",
  "SubmitErrorBorrower investment profile is missing": "Investeringsprofiel kredietnemer ontbreekt",
  "SubmitErrorBorrower legal form is missing": "Rechtsvorm kredietnemer ontbreekt",
  "SubmitErrorBorrower marital status is missing": "Burgerlijke staat kredietnemer ontbreekt",
  "SubmitErrorBorrower nationality is missing": "Nationaliteit kredietnemer ontbreekt",
  "SubmitErrorBorrower phone is missing": "Telefoonnummer kredietnemer ontbreekt",
  "SubmitErrorBorrower statutory location is missing": "Oprichtingsplaats kredietnemer ontbreekt",
  "SubmitErrorBorrower statutory name is missing": "Statutaire naam kredietnemer ontbreekt",
  "SubmitErrorBorrower tax partner is missing": "Fiscaal partner kredietnemer is verplicht",
  "SubmitErrorChamber of commerce nummer is missing": "KvK nummer ontbreekt",
  "SubmitErrorContact Birthdate is missing": "Contactpersoon: Geboortedatum ontbreekt",
  "SubmitErrorContact Phone number is missing": "Contactpersoon: Telefoonnummer ontbreekt",
  "SubmitErrorException while validating the application": "Er is een fout opgetreden bij het valideren van de aanvraag",
  "SubmitErrorGuarantor address country is missing": "Het land in het adres borgsteller ontbreekt",
  "SubmitErrorGuarantor emailaddress is missing": "E-mailadres borgsteller ontbreekt",
  "SubmitErrorGuarantor is not a natural person": "Borgsteller is geen natuurlijk persoon",
  "SubmitErrorGuarantor marital status is missing": "Burgerlijke staat borgsteller ontbreekt",
  "SubmitErrorGuarantor nationality is missing": "Nationaliteit borgsteller ontbreekt",
  "SubmitErrorGuarantor phone is missing": "Telefoonnummer borgsteller ontbreekt",
  "SubmitErrorPurchase date is missing": "Aankoopdatum ontbreekt",
  "SubmitErrorPurchase value is missing": "Aankoopsom ontbreekt",
  "SubmitErrorRenovation executed by (main)contractor is missing": "Verbouwing uitgevoerd door (hoofd)aannemer is niet gevuld",
  "SubmitErrorRented is missing": "Verhuurd is onbekend",
  "SubmitErrorSublet is unknown": "Onderverhuur is niet bekend",
  "SubmitErrorUbo address country is missing": "Het land in het adres UBO ontbreekt",
  "SubmitErrorUbo address is missing": "Het adres UBO ontbreekt",
  "SubmitErrorUbo emailaddress is missing": "E-mailadres UBO ontbreekt",
  "SubmitErrorUbo marital status is missing": "Burgerlijke staat UBO ontbreekt",
  "SubmitErrorUbo nationality is missing": "Nationaliteit UBO ontbreekt",
  "SubmitErrorUbo phone is missing": "Telefoonnummer UBO ontbreekt",
  "Subscription": "Abonnement",
  "Successfully uploaded your logo": "Uw logo is sucessvol geüpload",
  "Sufficient buffer for vacancy?": "Voldoende buffer voor leegstand?",
  "Suggested automatically, please check the values before saving": "Automatisch voorgesteld, controleer de gegevens voor het opslaan",
  "Sum of the units": "Som van de units",
  "Summary": "Samenvatting",
  "Supported logo format": " Op dit moment accepteren we alleen logos kleiner dan 1 mb en met de .png of .jpg extensie",
  "Surcharge": "Opslag",
  "Surety required": "Borgstelling vereist",
  "Surety required above loan to value": "Borgstelling vereist boven LTV",
  "surface": "Oppervlakte",
  "Surface": "Oppervlakte",
  "Surface after renovation": "Oppervlakte na verbouwing",
  "Surface of the room": "Oppervlakte van de kamer",
  "Surface of the unit": "Oppervlakte van de eenheid",
  "SurfaceAfterRenovation": "Oppervlakte na verbouwing",
  "Surname": "Achternaam",
  "Sustainability": "Duurzaamheid",
  "Switching service": "Overstap service",
  "Synchronize buildings": "Synchroniseer panden",
  "Take": "In behandeling nemen",
  "Target in years": "Doel in jaren",
  "Target loan to value": "Doel-LTV",
  "Task details": "Taak details",
  "Task requests": "Taakverzoeken",
  "Tasks": "Taken",
  "Tasks overview": "Taken overzicht",
  "Tax declaration year": "Belastingjaar",
  "Tax partner": "Fiscaal partner",
  "Tax value": "Waarde box 3",
  "Telephone": "Telefoon",
  "Template rate": "Sjabloontarief",
  "Template:": "Sjabloon:",
  "Temporarily": "Tijdelijk",
  "Tenant": "Huurder",
  "TenantPerson": "Huurder",
  "Tenants": "Huurders",
  "Tenants form a family?": "Vormen huurders één gezin?",
  "Terminated": "Geannuleerd",
  "TermSheet": "Indicatieve offerte",
  "TermSheetApproved": "Indicatieve offerte akkoord",
  "TermSheetDelivered": "Indicatieve offerte geleverd",
  "TermSheetInProgress": "Indicatieve offerte in behandeling",
  "TermSheetReceived": "Indicatieve offerte ontvangen",
  "TermSheetRequested": "Indicatieve offerte aangevraagd",
  "Test charges per month": "Toetslasten per maand",
  "Test income": "Toetsinkomen",
  "Test interest rate for fixed periods shorter than 10 years": "Toetsrente bij rentevaste periodes korter dan 10 jaar",
  "The (expected) basic rent per month. The basic rent is the rent excluding service costs and other costs.": "De (verwachte) kale huur per maand. De kale huur is de huur exclusief servicekosten en overige kosten.",
  "The absolute maximum loan per building (collateral), applied after all other rules.": "De absolute maximale lening per object (onderpand), toegepast na alle andere regels.",
  "The absolute maximum of the total loan of the rate (all buildings together), applied after the building loans are summed.": "Het absolute maximum van de totale lening van het tarief (alle objecten samen), toegepast nadat de leningen per object zijn opgeteld.",
  "The actual monthly interest and repayment per month. You will receive a mortgage interest deduction from the tax authorities on the interest paid.": "De werkelijke maandelijkse rente en aflossing per maand. Over de betaalde rente ontvang je hypotheekrenteaftrek van de belastingdienst.",
  "The additional costs such as transfer tax, notary fees, appraisal costs and any financing costs.": "Additionele kosten zoals overdrachtsbelasting, notaris-, taxatie- en financieringskosten.",
  "The adjustment is also added to the interest used for the ratio tests (DSCR/ICR), not only to the offered interest rate. Duration filters do not apply there; only the repayment variant filter does.": "De aanpassing wordt ook opgeteld bij de rente voor de ratiotoetsen (DSCR/ICR), niet alleen bij de aangeboden rente. Daar gelden de filters op rentevaste periode niet, alleen het filter op aflosvorm.",
  "The AFM number is empty. Therefore consumer rates & features are disabled. Every customer is expected to be a professional.": "Vanwege het ontbreken van het AFM nummer zijn consumenten tarieven en mogelijkheden uitgeschakeld. Iedere klant wordt geacht een professionele vastgoedbelegger te zijn.",
  "The application was submitted but a popup blocker prevented a link te be opened": "De aanvraag is ingediend, maar een popup blocker voorkwam dat een link werd geopend",
  "The arrangement": "De afspraak",
  "The asset classes the rate finances; a building none of whose asset classes is listed is not financed. Residential: apartment, house, room, studio. Commercial: business space, cafe, garage, hotel, office, practice space, restaurant, store, parking and other. Mixed use: a combination building with residential and non-residential units. Leisure: recreation.": "De vastgoedcategorieën die het tarief financiert; een object waarvan geen enkele categorie in de lijst staat, wordt niet gefinancierd. Residentieel: appartement, woning, kamer, studio. Commercieel: bedrijfsruimte, café, garage, hotel, kantoor, praktijkruimte, restaurant, winkel, parkeergelegenheid en overige. Gemengd gebruik: een combinatiepand met woon- en niet-woonunits. Recreatief: recreatie.",
  "The assistant needs access to": "De assistent heeft toegang nodig tot",
  "The assistant wants to call": "De assistent wil",
  "The base interest rate per LTV band and fixed interest period. The applicable interest adjustments are added to it to give the offered rate. When a band has no rate for a period, that period is not offered for loan parts in that band.": "De basisrente per LTV-klasse en rentevaste periode. De geldende renteaanpassingen worden erbij opgeteld tot de aangeboden rente. Heeft een klasse geen rente voor een periode, dan wordt die periode niet aangeboden voor leningdelen in die klasse.",
  "The browser is reloading due to inactivity.": "De browser wordt opnieuw geladen vanwege inactiviteit.",
  "The browser will reload": "De browser wordt opnieuw geladen",
  "The building statuses the rate finances.": "De objectstatussen die het tarief financiert.",
  "The calculation service checks the configuration of this version for settings that are missing, contradict each other or cannot be used. The check runs after every save.": "De berekening controleert de configuratie van deze versie op instellingen die ontbreken, elkaar tegenspreken of niet bruikbaar zijn. De controle draait na elke keer opslaan.",
  "The category the lender uses to look up the maximum loan to value of a building. The lender decides which category a building falls into, for example by building type, location, energy label or portfolio mix.": "De categorie waarmee de geldverstrekker de maximale LTV van een object opzoekt. De geldverstrekker bepaalt in welke categorie een object valt, bijvoorbeeld op basis van soort object, locatie, energielabel of samenstelling van de portefeuille.",
  "The check has not run yet": "De controle is nog niet uitgevoerd",
  "The closing commission means that ... less is available for a purchase or refinancing.": "Door de afsluitprovisie is er <strong>{{value}}</strong> minder beschikbaar voor een aankoop of herfinanciering.",
  "The code of the repayment (see the repayments table) this rule assigns.": "De code van de aflossing (zie de tabel aflossingen) die deze regel toewijst.",
  "The commission (closing fee) charged instead of the normal commission when the financing type is investment with renovation.": "De afsluitprovisie die in plaats van de normale provisie geldt wanneer het financieringstype belegging met verbouwing is.",
  "The condition under which the surcharge applies, evaluated over the buildings in the financing.": "De voorwaarde waaronder de opslag geldt, beoordeeld over de objecten in de financiering.",
  "The configuration and interest rates of the rates as used by the calculation. Select a rate and a version to see its details.": "De configuratie en rentes van de tarieven zoals gebruikt door de berekening. Selecteer een tarief en een versie om de details te bekijken.",
  "The contract": "Het contract",
  "The contract has a duration of": "Het contract heeft een looptijd van",
  "The costs of applying for this financing are": "De kosten voor het aanvragen van deze financiering bedragen ",
  "The customer has opted for the WOZ value": "De klant heeft gekozen voor de WOZ-waarde",
  "The date on which the real estate becomes property": "De datum waarop het pand wordt overgeschreven.",
  "The date the total rent income was updated.": "De datum waarop de huurinkomsten zijn bijgewerkt",
  "The evaluation order within the group. Lower values are checked first; the first row whose condition holds applies and the rest of the group is ignored.": "De volgorde binnen de groep. Lagere waarden worden eerst gecontroleerd; de eerste regel waarvan de voorwaarde klopt geldt en de rest van de groep wordt genegeerd.",
  "The financing must contain a combination building.": "De financiering moet een combinatiepand bevatten.",
  "The financing types the rate offers. A financing of another type is rejected and the rate is not offered.": "De financieringsvormen die het tarief aanbiedt. Een financiering van een andere vorm wordt afgewezen en het tarief wordt niet aangeboden.",
  "The financing value of the building as determined by the lender, for example the lowest of the purchase price and the value.": "De financieringswaarde van het object zoals bepaald door de geldverstrekker, bijvoorbeeld de laagste van koopsom en waarde.",
  "The fixed-interest period whose tariff is used as the interest for the ratio tests (DSCR/ICR), whatever period the client chooses. The tariff is looked up in the loan part's LTV class (without reflection period) and interest adjustments marked \"also for ratios\" are added.": "De rentevaste periode waarvan het tarief gebruikt wordt als rente voor de ratiotoetsen (DSCR/ICR), ongeacht de periode die de klant kiest. Het tarief komt uit de LTV-klasse van het leningdeel (zonder bedenktijd) en renteaanpassingen met \"ook voor ratio's\" worden erbij opgeteld.",
  "The fixed-interest period. The periods listed here are the periods the rate offers. A reflection period is shown when the lender prices it separately; a quote is only given for an exact period + reflection period match.": "De rentevaste periode. De periodes in deze lijst zijn de periodes die het tarief aanbiedt. Een bedenktijd wordt getoond als de geldverstrekker die apart prijst; er wordt alleen een rente gegeven bij een exacte combinatie van periode en bedenktijd.",
  "The following buildings have been synchronized": "De volgende panden zijn gesynchroniseerd",
  "The following fields need to be changed:": "De volgende velden moeten worden gewijzigd:",
  "The four digits of the postcode.": "De vier cijfers van de postcode.",
  "The future renovation costs are added to the loan, capped at the maximum LTV of the value after renovation when that value is known.": "De toekomstige verbouwingskosten worden bij de lening opgeteld, begrensd op de maximale LTV van de waarde na verbouwing als die bekend is.",
  "The highest share of non-residential rent in the portfolio; buildings above it are left out.": "Het hoogste aandeel niet-residentiële huur in de portefeuille; objecten daarboven worden buiten beschouwing gelaten.",
  "The highest share of non-residential value in the portfolio; buildings above it are left out.": "Het hoogste aandeel niet-residentiële waarde in de portefeuille; objecten daarboven worden buiten beschouwing gelaten.",
  "The highest share of the rent of the units of a combination building that may be non-residential.": "Het hoogste aandeel van de huur van de units van een combinatiepand dat niet-residentieel mag zijn.",
  "The highest share of the value of the units of a combination building that may be non-residential.": "Het hoogste aandeel van de waarde van de units van een combinatiepand dat niet-residentieel mag zijn.",
  "The interest deposit means that ... less is available for a purchase or refinancing.": "Door het rentedepot is er <strong>{{value}}</strong> minder beschikbaar voor een aankoop of herfinanciering.",
  "The lender offers a compensation of ... for all costs that the investor has to incur.": "De geldverstrekker biedt een tegemoetkoming aan van <strong>{{value}}</strong> voor alle kosten die de belegger moet maken.",
  "the lender offers a interest discount of ...% during the fixed-interest period.": "biedt de geldverstrekker een rente korting van <strong>{{value}}%</strong> gedurende de rentevast periode.",
  "The lender will be added to the list": "De geldverstrekker wordt toegevoegd aan de lijst",
  "The lenders could not be retrieved": "De geldverstrekkers konden niet worden opgehaald",
  "The lenders of the calculation service with their rates. A lender can only be deleted when it has no rates; a rate only while no version of it has applied yet.": "De geldverstrekkers van de berekening met hun tarieven. Een geldverstrekker kan alleen worden verwijderd als hij geen tarieven heeft; een tarief alleen zolang nog geen versie ervan heeft gegolden.",
  "The loan becomes the maximum LTV of the value after renovation; earlier caps no longer apply.": "De lening wordt de maximale LTV van de waarde na verbouwing; eerdere begrenzingen vervallen.",
  "The loan to value band of the class (lower bound exclusive, upper bound inclusive). A loan part falls into the class whose band contains its LTV; the rates apply to every repayment variant. A lower LTV usually gets a lower interest rate.": "De LTV-band van de klasse (ondergrens exclusief, bovengrens inclusief). Een leningdeel valt in de klasse waarvan de band zijn LTV bevat; de rentes gelden voor elke aflosvorm. Een lagere LTV krijgt meestal een lagere rente.",
  "The lowest share of the financed value that must be in the postcode list of the rate.": "Het laagste aandeel van de gefinancierde waarde dat in de postcodelijst van het tarief moet liggen.",
  "The lowest share of the value of the units of a combination building that must be non-residential.": "Het laagste aandeel van de waarde van de units van een combinatiepand dat niet-residentieel moet zijn.",
  "The LTV decision table: the first row by order whose conditions hold (asset class, mixed portfolio, combination building, postcode category or listing, room units, energy label, region, the band) gives the maximum LTV of a building. Empty: the row is not in the table and only found by its category.": "De LTV-beslistabel: de eerste regel op volgorde waarvan de voorwaarden kloppen (vastgoedcategorie, gemengde portefeuille, combinatiepand, postcodecategorie of -lijst, kamerunits, energielabel, regio, de band) geeft de maximale LTV van een object. Leeg: de regel staat niet in de tabel en wordt alleen via zijn categorie gevonden.",
  "The maximum fee, there is no max when you leave the field empty": "De maximale vergoeding, er is geen max wanneer u het veld leeg laat",
  "The maximum loan as a percentage of the building's value for this category. It is the \"X%\" in every maximum loan rule (value, purchase cap, renovation, caps) and appears in the restriction text shown to the client.": "De maximale lening als percentage van de waarde van het object voor deze categorie. Dit is de \"X%\" in elke regel voor de maximale lening (waarde, aankoop, verbouwing, begrenzingen) en staat in de beperkingstekst die de klant ziet.",
  "The maximum loan of a combination building depends on the share of non-residential units and their number.": "De maximale lening van een combinatiepand hangt af van het aandeel niet-woonunits en hun aantal.",
  "The maximum loan of a combination building is the sum of the maximum loans of its units.": "De maximale lening van een combinatiepand is de som van de maximale leningen van zijn units.",
  "The maximum of ... cadastral information hits within ... hours has been reached.": "Het maximale aantal van {{ max }} Kadaster bevragingen binnen {{ hours }} uur is bereikt.",
  "The maximum of ... cadastral information hits within ... hours has been reached. Please enter other owned addresses manually.": "Het maximale aantal van {{ max }} Kadaster bevragingen binnen {{ hours }} uur is bereikt. Gelieve overige adressen in bezit handmatig in te voeren.",
  "The maximum possible loan for this product related to this real estate is": "De maximaal mogelijke lening voor dit product in combinatie met dit vastgoed bedraagt",
  "The maximum rent according to the points system (home valuation system) is .... As a result, the house does not fall into the private sector. The lender will therefore not calculate the rental income, but this limited rent.": "De maximale huur volgens het puntensysteem (woningwaarderingssysteem) bedraagt {{value}}. Hierdoor valt de woning niet in de vrije sector. De geldverstrekker zal hierdoor niet met de huurinkomsten rekenen maar met deze gelimiteerde huur.",
  "The minimum energy label every building must have for the condition \"All buildings have at least energy label\". Ignored for other conditions.": "Het minimale energielabel dat elk object moet hebben voor de voorwaarde \"Alle objecten hebben minimaal energielabel\". Wordt genegeerd bij andere voorwaarden.",
  "The minimum fee": "De minimale vergoeding",
  "The minimum gross annual income of a borrower. A borrower whose tested gross income is at or below this amount gets a rejection, so the rate is not offered.": "Het minimale bruto jaarinkomen van een leningnemer. Een leningnemer met een getoetst bruto inkomen op of onder dit bedrag krijgt een afwijzing, waardoor het tarief niet wordt aangeboden.",
  "The minimum interest rate the affordability test uses for a loan part whose fixed-interest period is shorter than 10 years. For those loan parts the test annuity uses the higher of this rate and the part's own interest. The monthly test charges feed the income tests.": "De minimale rente waarmee de betaalbaarheidstoets rekent voor een leningdeel met een rentevaste periode korter dan 10 jaar. Voor die leningdelen gebruikt de toetsannuïteit de hoogste van deze rente en de eigen rente van het leningdeel. De maandelijkse toetslasten gaan mee in de inkomenstoetsen.",
  "The moment the loan is less than ... of the value, the repayment obligation lapses and only interest is due.": "Op het moment dat de lening minder dan {{ value }}% van de waarde bedraagt vervalt de aflossingsverplichting en is er slechts rente verschuldigd.",
  "The monthly interest and repayment that you pay belonging to the part of your owner-occupied home mortgage that falls in box 1. You will receive a mortgage interest deduction from the tax authorities on the interest paid on this part. In your tax return you can find out whether your mortgage (or part of your mortgage) belong to box 1 or 3.": "De maandelijkse rente en aflossing die je betaalt behorende tot het deel van je eigen woning hypotheek dat valt in box 1. Over de betaalde rente van dit deel ontvang je hypotheekrente aftrek van de belastingdienst. In je belastingaangifte kun je vinden of je hypotheek (of een deel van je hypotheek) in box 1 of 3 valt.",
  "The monthly interest and repayment that you pay belonging to the part of your owner-occupied home mortgage that falls in box 3. You will not receive a mortgage interest deduction from the tax authorities on the interest paid on this part. In your tax return you can find out whether your mortgage (or part of your mortgage) belong to box 1 or 3.": "De maandelijkse rente en aflossing die je betaalt behorende tot het deel van je eigen woning hypotheek dat valt in box 3. Over de betaalde rente van dit deel ontvang je géén hypotheekrente aftrek van de belastingdienst. In je belastingaangifte kun je vinden of he hypotheek (of een deel van je hypotheek) in box 1 of 3 valt.",
  "The mortgage information might not be complete since mortgages are not fetched for ever building": "Hypotheekinformatie is wellicht niet volledig omdat deze niet zijn opgehaald voor ieder pand",
  "The mortgage is not valid, because one or more properties are outside the limits:": "De lening is niet geldig, omdat een of meerdere velden buiten de minimale en maximale grenzen ligt:",
  "The mortgage is valid": "De lening is geldig",
  "The most mixed combination buildings in the portfolio; buildings above it are left out.": "Het hoogste aantal gemengde combinatiepanden in de portefeuille; objecten daarboven worden buiten beschouwing gelaten.",
  "The most rental contracts a building or unit may have.": "Het hoogste aantal huurcontracten dat een object of unit mag hebben.",
  "The name under which a formula of the calculation reads this number.": "De naam waaronder een formule van de berekening dit getal uitleest.",
  "The number of calendar days before the execution date in which a purchase still counts as recent. A building that is being purchased always counts; 0 means only those. For a recently purchased building the maximum loan is capped by its purchase amount (see purchase cap). Also used by the planned investment cap.": "Het aantal kalenderdagen voor de passeerdatum waarin een aankoop nog als recent telt. Een object dat wordt aangekocht telt altijd; 0 betekent alleen die. Voor een recent gekocht object wordt de maximale lening begrensd door het aankoopbedrag (zie maximum op basis van aankoop). Wordt ook gebruikt voor de begrenzing op geplande investering.",
  "The number of leases allowed on this property.": "Het aantal huurcontracten dat toegestaan is op dit object.",
  "The number of rooms on this property": "Hoeveel kamers heeft dit object?",
  "The ownership information might not be complete and accurate since ownership is not fetched for ever building": "De eigendomsinformatie is niet volledig & accuraat omdat eigendomsinformatie niet voor ieder pand is opgehaald",
  "The percentage the value of a recent purchase may exceed its purchase price.": "Het percentage waarmee de waarde van een recente aankoop boven de koopsom mag liggen.",
  "The places per region: the municipalities, cities or provinces that count as an excluded area, shrinking region, student city, big city and so on. The eligibility settings and the LTV decision table refer to these regions.": "De plaatsen per regio: de gemeenten, steden of provincies die gelden als uitgesloten gebied, krimpregio, studentenstad, grote stad enzovoort. De acceptatiecriteria en de LTV-beslistabel verwijzen naar deze regio's.",
  "The portfolio condition under which the adjustment applies, evaluated over all buildings in the financing.": "De voorwaarde op de portefeuille waaronder de aanpassing geldt, beoordeeld over alle objecten in de financiering.",
  "The postcode category the LTV decision table and the maximum LTV categories refer to.": "De postcodecategorie waarnaar de LTV-beslistabel en de maximale LTV-categorieën verwijzen.",
  "The postcode of the building must be in the postcode list of the rate (see the location tab).": "De postcode van het object moet in de postcodelijst van het tarief staan (zie het tabblad Locatie).",
  "The postcodes (four digits) the rate finances in, each with its category. The LTV decision table and the maximum LTV categories refer to the category.": "De postcodes (vier cijfers) waarin het tarief financiert, elk met de categorie. De LTV-beslistabel en de maximale LTV-categorieën verwijzen naar de categorie.",
  "The postcodes could not be retrieved": "De postcodes konden niet worden opgehaald",
  "The price a real estate investor is willing to pay for a property after renovation that is rented out.": "De prijs die een andere vastgoedbelegger bereid is te betalen voor dit pand als het verhuurd is (na verbouwing).",
  "The price a real estate investor is willing to pay for a property that is rented out.": "De prijs die een andere vastgoedbelegger bereid is te betalen voor dit pand als het verhuurd is.",
  "The price for which the property is acquired excluding transfer tax and other purchase costs.": "De prijs waarvoor het vastgoed wordt verkregen exclusief overdrachtsbelasting en andere aankoopkosten.",
  "The purchase amount that caps the maximum loan of a building that is being purchased or was bought within the recent purchase period. Only applies when the building has a purchase price, and only lowers the loan.": "Het aankoopbedrag dat de maximale lening begrenst van een object dat wordt aangekocht of binnen de periode recente aankoop is gekocht. Geldt alleen als het object een koopsom heeft en verlaagt de lening alleen.",
  "The purchase price excluding transfer tax and other additional costs.": "De aankoopprijs exclusief overdrachtsbelasting en bijkomende kosten",
  "The purchase price plus costs plus the € 2,500 advisory allowance.": "De koopsom plus kosten plus de advieskostenvergoeding van € 2.500 (investeringswaarde).",
  "The purchase price plus notary, transfer tax and valuation costs.": "De koopsom plus notaris-, overdrachtsbelasting- en taxatiekosten.",
  "The purposes of a building the rate accepts.": "De bestemmingen van een object die het tarief accepteert.",
  "The rate details could not be retrieved": "De tariefdetails konden niet worden opgehaald",
  "The rate is offered to a professional investor.": "Het tarief wordt aangeboden aan een professionele belegger.",
  "The rate is offered to a starting private investor.": "Het tarief wordt aangeboden aan een startende particuliere belegger.",
  "The rate profile could not be saved": "Het tariefprofiel kon niet worden opgeslagen",
  "The recognised document type and dates are correct": "Het herkende documenttype en de datums kloppen",
  "The regions could not be retrieved": "De regio's konden niet worden opgehaald",
  "The regions of the location lists of the rate in which the rate does not finance. \"Big cities are never excluded\" exempts the big cities (Randstad, city list).": "De regio's uit de locatielijsten van het tarief waarin het tarief niet financiert. \"Grote steden zijn nooit uitgesloten\" zondert de grote steden uit (Randstad, stedenlijst).",
  "The rent income on the building will be updated": "De huurinkomsten op het pand worden bijgewerkt",
  "The repayment decision table: a building (the units of a combination building) gets the repayment of the first rule by order whose conditions hold. A rate with rules only offers the repayments whose codes were assigned.": "De aflossingsbeslistabel: een object (de units van een combinatiepand) krijgt de aflossing van de eerste regel op volgorde waarvan de voorwaarden kloppen. Een tarief met regels biedt alleen de aflossingen aan waarvan de codes zijn toegewezen.",
  "The seizure information might not be complete since seizures are not fetched for ever building": "Informatie over beslagleggingen is misschien niet volledig omdat deze niet voor ieder pand is opgevraagd",
  "The selected proposals cannot be requested with the supplied customer data. Please select a new financing proposal.": "Het geselecteerde financieringsvoorstel kan niet aangevraagd worden op basis van de opgegeven klantgegevens. Gelieve een nieuw financieringsvoorstel te selecteren.",
  "The server is unreachable. Please try again in a few minutes": "De server is onbereikbaar. Probeer het over een paar minuten opnieuw",
  "The source documents on which the cadastral information is based. These are added in Unite under document management.": "De brondocumenten waarop de kadastrale informatie is gebaseerd is. Deze worden opgeslagen in Unite onder documentenbeheer en zijn nuttig bij het indienen van een financieringsaanvraag bij de geldverstrekker.",
  "The special forms of rental the rate permits on top of normal rental: rooms rented out separately, subletting, tenants that do not form a family and short stay. Normal rental is always allowed and never listed; a building or unit with a special form of rental that is not listed is not financed.": "De bijzondere vormen van verhuur die het tarief naast reguliere verhuur toestaat: kamerverhuur, onderverhuur, huurders die geen gezin vormen en shortstay. Reguliere verhuur is altijd toegestaan en staat nooit in de lijst; een object of unit met een bijzondere vorm van verhuur die niet in de lijst staat, wordt niet gefinancierd.",
  "The surface area of the property in square meters": "De oppervlakte van het pand in vierkante meters",
  "The total invested renovation costs.": "De totaal geinvesteerde verbouwingskosten",
  "The total investment made for this property. With this we calculate the various returns.": "De totale investering in dit pand. Hiermee berekenen we de diverse rendementen",
  "The total purchase costs": "De totale aankoopkosten",
  "The total rent income (excluding service fees).": "De huidige huurinkomsten (excl. servicekosten) per maand.",
  "The user has been created. An email was sent to the user through which the password can be set.": "De gebruiker is aangemaakt. Er is een e-mail verstuurd naar de gebruiker waarmee het wachtwoord kan worden ingesteld.",
  "The user has not sufficient permissions for this action": "De gebruiker heeft onvoldoende rechten voor deze actie",
  "The user is not authorized": "De gebruiker is niet ingelogd",
  "The user will receive an email on '...'. The user than needs to verify the email and choose a password.": "De gebruiker zal een email ontvangen op {{value}}. De gebruiker dient dan zijn email te verifiëren en een wachtwoord te kiezen.",
  "The value each building's maximum loan starts from: the maximum LTV of the building times this value, before any other caps. Financing value is used when the lender determines a (lowest) financing value per building; otherwise the value in rented condition is used.": "De waarde waar de maximale lening per object van uitgaat: de maximale LTV van het object maal deze waarde, voor alle andere begrenzingen. Financieringswaarde wordt gebruikt als de geldverstrekker per object een (laagste) financieringswaarde bepaalt; anders de waarde in verhuurde staat.",
  "The value in rented condition, or the vacant value when \"Uses value vacant when not rented\" applies.": "De waarde in verhuurde staat, of de leegwaarde wanneer \"Gebruikt leegwaarde bij niet verhuurd\" van toepassing is.",
  "The value the calculation finances a building on.": "De waarde waarop de berekening een object financiert.",
  "Theoretical space": "Theoretische ruimte",
  "There are already applications based on this financing.": "Er zijn reeds aanvragen aanwezig gebaseerd op deze berekening. ",
  "There are no differences found between the building and current building information.": "Er zijn geen verschillen tussen het pand en de huidige pandgegevens gevonden.",
  "There are no differences found between the values of the renovation and the building.": "Er zijn geen verschillen tussen het pand en de verbouwing van het pand gevonden.",
  "There are no rejections found.": "Er zijn geen afwijzingen gevonden.",
  "There are no suitable compositions found that meets your demands.": "Er zijn geen geschikte combinaties gevonden die aan uw wensen voldoen.",
  "There are no suitable proposals found that meets your demands.": "Er zijn geen geschikte voorstellen gevonden die aan uw eisen voldoen.",
  "There are no suitable proposals found.": "Er zijn geen geschikte voorstellen gevonden.",
  "There is an update available. Do you want to update?": "Er is een nieuwe versie beschikbaar. Wilt u updaten?",
  "There is no remaining loan": "Er is geen resterend leenbedrag",
  "These are registrations that have been found in the Land Registry, but for which we have not been able to find any addresses.": "Hier worden registraties getoond die niet konden worden herleid tot een adres. Dit komt voor bij parkeerplaatsen, landbouwgrond, of wanneer er geen koppeling is gelegd met de Basisadministratie Adressen en Gebouwen.",
  "These cadastral registrations could not be resolved into a (complete) address": "Deze kadastrale registraties konden niet worden omgezet in een adres",
  "These units will be created and the parent building will be deleted.": "Deze eenheden worden gemaakt en het bovenliggende gebouw wordt verwijderd.",
  "These values will be divided over the residential buildings in this selection": "Deze waardes worden verdeeld over alle residentiele panden in de selectie",
  "Third": "Derde",
  "This ... is being renovated": "Dit {{value}} wordt verbouwd",
  "This ... is being rented": "Dit {{value}} wordt verhuurd",
  "This ... is being split from the": "Dit {{value}} wordt gesplist uit",
  "This ... is part of the building": "Dit {{value}} maakt deel uit van het pand",
  "This ... will be split into new units": "Dit {{value}} wordt gesplitst in nieuwe eenheden",
  "This action cannot be undone.": "Deze actie kan niet ongedaan worden gemaakt.",
  "This address has a different owner than ...": "Dit adres heeft een andere eigenaar dan {{ value }}",
  "This address seems part of combination building. Create all addresses?": "Dit adres lijkt onderdeel van een combinatiepand. Alle adressen aanmaken?",
  "this application": "deze aanvraag",
  "This building is not financed": "Dit pand is niet gefinancierd",
  "This can take a while if you have multiple buildings": "Dit kan even duren als u meerdere panden hebt",
  "This concerns a linear loan. The monthly costs (interest & repayment) decrease during the fixed-rate interest period.": "Dit betreft een lineaire lening. De maandelijkse lasten (rente & aflossing) dalen gedurende de rentevaste periode.",
  "This deletes the lender from the calculation service. This cannot be undone.": "Dit verwijdert de geldverstrekker uit de berekening. Dit kan niet ongedaan worden gemaakt.",
  "This deletes the rate with every version from the calculation service and from the list of rates. This cannot be undone.": "Dit verwijdert het tarief met alle versies uit de berekening en uit de lijst met tarieven. Dit kan niet ongedaan worden gemaakt.",
  "This document is accepted by the acceptor.": "Dit document is geaccepteerd door de acceptant.",
  "This document is rejected by the acceptor and needs to be resubmitted.": "Dit document is afgewezen door de acceptant en moet opnieuw worden geüpload.",
  "This document is still missing and must be uploaded.": "Dit document ontbreekt en moet worden geüpload.",
  "This document is submitted but still needs to be checked by the acceptor.": "Dit document is geüpload maar moet nog worden gecontroleerd door de acceptant.",
  "This field is required": "Dit is een vereist veld",
  "This fixed interest period already exists": "Deze rentevaste periode bestaat al",
  "This is an annuity loan. The monthly charges (interest & repayment) remain the same throughout the fixed-rate interest period.": "Dit betreft een annuïtaire lening. De maandelijkse lasten (rente & aflossing) blijven gelijk gedurende de rentevaste periode.",
  "This is an estimate based on our data. Feel free to change it of you believe it is not correct.": "Dit is een schatting gebaseerd op onze data. U kunt deze aanpassen indien u van mening bent dat deze niet correct is.",
  "This is an interest-only loan. You do not repay anything, and only pay interest. The monthly costs (interest) remain the same during the fixed-rate interest period.": "Dit betreft een aflossingsvrije lening. Je lost niets af en betaalt alleen rente. De maandelijkse lasten (rente) blijven gelijk gedurende de rentevaste periode.",
  "This is not a valid address": "Dit is geen valide adres",
  "This is the balance of the mortgage from which moment Unite will use the repayment. For example, the starting date of the mortgage or the current balance for a current mortgage.": "Dit is het saldo van de hypotheek vanaf welk moment Unite met de aflossing gaat rekenen. Bijvoorbeeld aanvangsdatum van de hypotheek of het actuele saldo bij een lopende hypotheek.",
  "This is the folder in which Unite saves cadastral information for caching purposes. This is generated automatically and for security reasons can only be changed by a Unite employee.": "Dit is de map waarin Unite kadastrale informatie opslaat voor hergebruik. Deze wordt automatisch gegenereerd en kan alleen worden gewijzigd door een medewerker van Unite.",
  "This is the logincode of the main land registry account": "Dit is de logincode van het hoofd kadaster account",
  "This is the penalty interest based on the current interest rate of ... (...%)": "Dit is de boeterente gebaseerd op het huidige tarief ({{newInterestRate}}%) van {{ newInterestProductDescription}}",
  "This loan has an interest-only & annuity part. The monthly charges (interest & repayment) remain the same throughout the fixed-rate interest period.": "Deze lening heeft een aflossingsvrij & annuïtair deel. De maandelijkse lasten (rente & aflossing) blijven gelijk gedurende de rentevaste periode.",
  "This loan has an interest-only & linear part. The monthly costs (interest & repayment) decrease during the fixed-rate interest period.": "Deze lening heeft een aflossingsvrij & lineair deel. De maandelijkse lasten (rente & aflossing) dalen gedurende de rentevaste periode.",
  "This loan is subject to a closing fee of ...%.": "Bij deze lening is er sprake van een afsluitprovisie van <strong>{{value}}%</strong>.",
  "This loan requires an additional income of": "Bij deze lening is er een aanvullend inkomen vereist van",
  "This means you only pay ...% interest monthly and you can often borrow more.": "Hierdoor betaal je maandelijks maar <strong>{{value}}%</strong> rente en kan je vaak meer lenen.",
  "this mortgage": "deze lopende financiering",
  "This property has recently been valuated, if you want to use that valuation you can select it below.": "Dit object is recent gewaardeerd, als u die waardering wilt gebruiken kunt u die onderaan selecteren.",
  "This rate is discontinued": "Dit tarief is beëindigd",
  "this renovation": "deze verbouwing",
  "This residential building will be rented out in the free sector": "Deze woning wordt verhuurd in de vrije sector",
  "This result is a combination of the following providers and products:": "Dit resultaat is een combinatie van de volgende aanbieders en producten:",
  "this task": "deze taak",
  "this valuation": "deze waardering",
  "This value comes from the active mortgage of {{org}}": "Deze waarde komt uit de lopende financiering van {{org}}",
  "This value comes from the valuation by {{org}}": "Deze waarde komt uit de waardering door {{org}}",
  "This value is estimated by the customer": "Deze waarde is door de klant geschat",
  "This value is estimated by {{org}}": "Deze waarde is geschat door {{org}}",
  "This version is closed and can no longer be changed; edit the current version or start a new one.": "Deze versie is afgesloten en kan niet meer worden gewijzigd; bewerk de huidige versie of maak een nieuwe aan.",
  "This years totals": "Totalen dit jaar",
  "Tick in the fields below with which (own) resources the property was purchased and possibly renovated after purchase": "Vink in onderstaande velden aan met welke (eigen) middelen het pand is aangekocht en na aankoop eventueel is verbouwd",
  "Tick the source(s) of origin of the own funds to be contributed to this loan in the fields below": "Vink in onderstaande velden de bron(nen) van herkomst van de in te brengen eigen middelen bij deze lening aan",
  "Timestamp": "Tijdstip",
  "Timestap": "Tijdstip",
  "Title": "Titel",
  "To": "Aan",
  "to add a mortgage yourself": "zelf een lopende financiering toe te toevoegen",
  "To amount": "Tot bedrag",
  "to create the customer's profile": "om de klant zijn profiel aan te maken",
  "To generate a report, simply enter 1 address of an investment property from your client.": "Om een rapport te genereren, voer je simpelweg 1 adres van een beleggingspand van je klant in.",
  "To loan to value": "Tot LTV",
  "To percentage": "Tot percentage",
  "To period in months": "Tot periode in maanden",
  "To process the request faster, we recommend using our secure personal environment.": "Om de aanvraag sneller te kunnen verwerken raden we aan om gebruik te maken van onze beveiligde persoonlijke omgeving.",
  "To type": "Naar soort",
  "To which customer should the buildings be moved?": "Naar welke klant moeten de panden worden verplaatst?",
  "today": "vandaag",
  "Tool approval required": "Goedkeuring van tool vereist",
  "Top 3 proposals": "Top 3 aanbieders",
  "Total": "Totaal",
  "total": "totaal",
  "Total buildings value": "Totale vastgoed waarde",
  "Total by client": "Totaal door klant",
  "Total by us": "Totaal door ons",
  "total collateral value": "totale waarde onderpand",
  "Total costs": "Totale kosten",
  "Total financing costs": "Totale financieringskosten",
  "Total financing needs": "Totale financieringsbehoefte",
  "Total fiscal capital": "Totaal fiscaal kapitaal",
  "Total income per year": "Totaal jaarinkomen",
  "Total investment": "Totale investering",
  "Total loan": "Totale lening",
  "Total mortgage amount": "Totale lening bedrag",
  "Total operating costs": "Totale exploitatiekosten",
  "Total points": "Totaal aantal punten",
  "Total purchase investment": "Totale aankoop investering",
  "Total real estate value": "Totale waarde vastgoed",
  "Total renovation costs": "Totale verbouwkosten",
  "Total renovation costs:": "Totale verbouwingskosten:",
  "Total rental value": "Totale huurwaarde",
  "Total rented surface": "Totaal verhuurde oppervlakte",
  "Total repayment per year": "Totale aflossing per jaar",
  "Total value in rented condition": "Totale waarde in verhuurde staat",
  "Total value vacant": "Totale leegwaarde",
  "totalCosts": "Totale kosten",
  "Totals": "Totalen",
  "TotalValue": "Totale waarde",
  "Tourists": "Toeristen",
  "Trackrecord": "Trackrecord",
  "TrackRecord": "TrackRecord",
  "Trade": "Handelsfinanciering",
  "Transfer tax": "Overdrachtsbelasting",
  "Transformation": "Transformatie",
  "Transformed": "Getransformeerd",
  "TransformedInto": "Getransformeerd naar",
  "True": "Waar",
  "Turn into combined building": "Samenvoegen tot combinatiepand",
  "Type": "Soort",
  "Type advice here": "Vul hier het advies in",
  "Type description here": "Vul hier een omschrijving in",
  "Type expanation here": "Vul hier een toelichting in",
  "Type of advice": "Type advies",
  "Type of rental": "Soort verhuur",
  "Type summary here": "Typ hier uw samenvatting",
  "Type tenant": "Type huurder",
  "Type wish here": "Vul hier de wensen in",
  "Type your chat here": "Typ uw bericht hier",
  "Type your message…": "Typ je bericht…",
  "Unable to find the lender application": "Kan de aanvraag niet bij de geldverstrekker vinden",
  "Under construction": "Wordt gemaakt 👷‍♂️",
  "Undo": "Ongedaan maken",
  "Unit": "Unit",
  "Unit details": "Unit informatie",
  "Unit from": "Unit van",
  "Unite Assistant": "Unite Assistant",
  "UNITE_PLUS_INFO_LINK": [
    "Laat het",
    "Unite+ team",
    "deze aanvraag afhandelen"
  ],
  "Units": "Eenheden",
  "Unknown": "Onbekend",
  "Unknown label allowed": "Onbekend label toegestaan",
  "Unknown lender": "Onbekende geldverstrekker",
  "Unmatched addresses": "Niet gevonden adressen",
  "Unmatched registrations": "Niet gematchte registraties",
  "Unowned addresses": "Adressen niet in bezit",
  "Unregistered buildings": "Niet geregistreerde panden",
  "Unregistred buildings": "Ongeregistreerde panden",
  "Up to duration in months": "Tot looptijd in maanden",
  "Up to fixed interest period": "Tot en met rentevaste periode",
  "Up to LTV": "Tot en met LTV",
  "Up to non-residential share": "Tot niet-residentieel aandeel",
  "Update all rental income using Excel": "Werk alle huuropbrengsten bij met behulp van Excel",
  "Update application": "Aanvraag bijwerken",
  "Update building": "Bewerk pand",
  "Update existing application": "Werk een bestaande aanvraag bij",
  "Update mortgage": "Bijwerken lopende financiering",
  "Update rental income": "Huuropbrengst bijwerken",
  "Update shares": "Aandelen bijwerken",
  "Update valuation": "Bijwerken waardering",
  "Updated buildings": "Bijgewerkte panden",
  "Upload document": "Upload document",
  "Upload document for this application": "Upload document voor deze aanvraag",
  "Upload document for this building": "Upload document voor dit pand",
  "Upload document for this collaboration": "Upload document voor deze samenwerking",
  "Upload document for this company": "Upload document voor dit bedrijf",
  "Upload document for this mortgage": "Upload document voor deze financiering",
  "Upload document for this person": "Upload document voor deze persoon",
  "Upload failed": "Upload mislukt",
  "Upload document for this task": "Upload document voor deze taak",
  "Upload file": "Bestand uploaden",
  "Upload from my computer": "Uploaden vanaf mijn computer",
  "Upload logo": "Upload uw logo",
  "Upload progress": "Upload voortgang",
  "Upload the file again": "Upload het bestand opnieuw",
  "Upload the updated rental list to Unite": "Upload de bijgewerkte huurlijst naar Unite",
  "Upload year": "Upload jaar",
  "Uploading document": "Document aan het uploaden",
  "Uploading documents": "Documenten worden geüpload",
  "Uploading file": "Bestand uploaden",
  "Use document": "Document gebruiken",
  "Use repayment free": "Aflossingsvrij gebruiken",
  "Use repayment free:": "Aflossingvrij gebruiken:",
  "Use this document": "Dit document gebruiken",
  "Use value after renovation": "Waarde na verbouwing gebruiken",
  "User": "Gebruiker",
  "User deleted": "Gebruiker verwijderd",
  "User information": "Gebruiker informatie",
  "UseRepaymentFree": "Aflossingsvrij gebruiken",
  "Username": "Gebruikersnaam",
  "UserProxy": "UserProxy",
  "Users": "Gebruikers",
  "Uses label after renovation": "Gebruikt label na verbouwing",
  "Uses value vacant when not rented": "Gebruikt leegwaarde bij niet verhuurd",
  "Vacancy risk": "Leegstandsrisico",
  "VacancyRisk": "Leegstandrisico",
  "Valid from": "Geldig vanaf",
  "Valuated by ... on ...": "Getaxeerd door {{valuator}} op {{date}}",
  "Valuation": "Waardering",
  "Valuation costs": "Taxatiekosten",
  "Valuation date": "Waarderingsdatum",
  "Valuation details": "Waardering details",
  "Valuation history": "Waardering geschiedenis",
  "Valuation report": "Taxatierapport",
  "Valuation requested": "Waardering uitgezet",
  "Valuation summary": "Samenvatting waarderingen",
  "Valuations": "Waarderingen",
  "Valuator": "Taxateur",
  "Valuator added": "Taxateur toegevoegd",
  "Valuators": "Taxateurs",
  "Value": "Waarde",
  "Value after renovation": "Waarde na verbouwing",
  "Value collateral": "Waarde onderpand",
  "Value for financing": "Waarde voor financiering",
  "value in rented condition": "waarde in verhuurde staat",
  "Value in rented condition": "Waarde in verhuurde staat",
  "Value in rented condition after renovation": "Waarde in verhuurde staat na verbouwing",
  "Value in rented condition before renovation": "Waarde in verhuurde staat voor verbouwing",
  "Value in rented condition commercial": "Waarde in verhuurde staat commercieel",
  "Value in rented condition is set on the combination building": "Waarde in verhuurde staat wordt verdeeld vanaf het combinatiepand",
  "Value in rented condition pro rata": "Waarde in verhuurde staat pro rato",
  "Value in rented condition residential": "Waarde in verhuurde staat residentieel",
  "Value increase": "Waardestijging",
  "Value used for the maximum loan": "Waarde voor de maximale lening",
  "Value vacant": "Leegwaarde",
  "Value vacant after renovation": "Leegwaarde na verbouwing",
  "ValueInRentedCondition": "Waarde in verhuurde staat",
  "ValueInRentedConditionAfterRenovation": "Waarde in verhuurde staat na verbouwing",
  "ValueVacant": "Leegwaarde",
  "ValueVacantAfterRenovation": "Leegwaarde na verbouwing",
  "Variable": "Variabele",
  "Variable interest": "Variabele rente",
  "Verification email sent": "Verificatie e-mail verstuurd",
  "Verified": "Geverifieerd",
  "Verlopen op ...": "Verlopen op {{value}}",
  "Version": "Versie",
  "version": "versie",
  "versions": "versies",
  "Very bad": "Zeer slecht",
  "Very good": "Zeer goed",
  "VeryGood": "Zeer goed",
  "view": "bekijk",
  "View": "Bekijk",
  "View all": "Toon alles",
  "View all applications": "Toon aanvragen overzicht",
  "View all buildings": "Toon panden overzicht",
  "View all clients": "Toon klanten overzicht",
  "View all financings": "Toon berekeningen overzicht",
  "View all mortgages": "Toon lopende financieringen overzicht",
  "View client details": "Toon klantinformatie",
  "View details": "Bekijk details",
  "View financing": "Toon berekening",
  "View history": "Toon geschiedenis",
  "View list": "Toon lijst",
  "View raw data": "Bekijk ruwe data",
  "VIR processed!": "VIR verwerkt!",
  "Visible": "Zichtbaar",
  "VRC": "WVS",
  "Wait for verification": "Wacht op verificatie",
  "WaitForExecution": "Wachten op passeren",
  "Waiting for authorization in popup…": "Wachten op autorisatie in pop-up…",
  "Waiting for customer approval": "Wachten op goedkeuring klant",
  "Waiting for final offer from ...": "Wachten op definitieve offerte van {{value}}",
  "Waiting for indicative offer from ...": "Wachten op indicatieve offerte van {{value}}",
  "Waiting for the valuator": "Wachten op de taxateur",
  "Waiting for your approval": "Wachten op je akkoord",
  "Waiting for your final approval": "Wachten op je definitieve akkoord",
  "WaitingForCustomerApproval": "Wacht op goedkeuring klant",
  "WaitingForLoanAdjustments": "Wachten op afstellen van de lening",
  "WaitingForLoanAgreementDocuments": "Wachten op de documenten van de leningsovereenkomst",
  "WaitingForTermSheetDocuments": "Wachten op de documtenten van de indicatieve offerte",
  "WaitingForValuation": "Wachten op waardering",
  "Warning": "Waarschuwing",
  "Water authority tax": "Waterschapsbelasting",
  "We are creating your application: ... 🚀!": "We maken uw nieuwe aanvraag aan: {{value}} 🚀!",
  "We could not find the account": "We konden het account niet vinden",
  "Website": "Webpagina",
  "weeks": "weken",
  "Welcome ...": "Welkom {{name}}",
  "WELCOME_INTRO": "U kunt starten met het invoeren van een klant en een pand dat hij of zij wenst te financieren. Vervolgens kunt u de indicatieve financieringsvoorstellen laten berekenen en een aanvraagformulier downloaden. In deze video kunt u zien hoe u uw eerste aanvraagformulier creëert.<br /> <br />Heeft u meer hulp nodig? Lees dan onze <a href='https://unite.nl/faq/' target='_blank'>veel gestelde vragen</a> of neem contact met ons op.",
  "WELCOME_TITLE": "Welkom bij Unite!",
  "What applies to this building?": "Wat is er op dit pand van toepassing?",
  "What are the customer's expected annual net rental income in the next 3 years?": "Wat zijn in de komende 3 jaar de klant zijn verwachte jaarlijkse netto huurinkomsten?",
  "What are the customer's monthly interest and repayments on his/her first mortgage?": "Wat zijn de klant zijn maandelijkse rente en aflossing op zijn/haar eerste hypotheek?",
  "What are the customer's monthly interest and repayments on his/her mortgage?": "Wat zijn de klant zijn maandelijkse rente en aflossing op zijn/haar hypotheek?",
  "What are the customer's monthly interest and repayments on his/her second mortgage?": "Wat zijn de klant zijn maandelijkse rente en aflossing op zijn/haar tweede hypotheek?",
  "What are the loan details?": "Wat zijn de leninggegevens?",
  "What are the rental contract details?": "Wat zijn de details van het huurcontract?",
  "What are you planning to do with this building?": "Wat bent u van plan met dit pand te doen?",
  "What is the address of the new building?": "Wat is het adres van het nieuwe pand?",
  "What is the address of the new unit?": "Wat is het adres van het nieuwe eenheid?",
  "What is the current value prior renovation?": "Wat is de huidige waarde voor verbouwing?",
  "What is the customer's living situation?": "Wat is de klant zijn huidige woonsituatie?",
  "What is the customer's source of income?": "Wat is de klant zijn inkomsten bron?",
  "What is the description of the renovation?": "Wat is de omschrijving van de verbouwing?",
  "What is the expected rent income after renovation?": "Wat zijn de verwachte huurinkomsten (excl. servicekosten) na verbouwing",
  "What is the expected rent income and number of potential tenants after renovation?": "Wat zijn de verwachte huurinkomsten (excl. servicekosten) en aantal mogelijke huurcontracten na verbouwing",
  "What is the expected rent income and number of potential tenants?": "Wat zijn de verwachte huurinkomsten (excl. servicekosten) en het aantal mogelijke huurcontracten?",
  "What is the expected rent income?": "Wat zijn de verwachte huurinkomsten (excl. servicekosten)?",
  "What is the expected sales value after renovation?": "Wat is de verwachte verkoopwaarde na verbouwing?",
  "What is the expected sales value?": "Wat is de verwachte verkoopwaarde?",
  "What is the gender of the tenant?": "Wat is het geslacht van de huurder?",
  "What is the mortgage number and how high is the remaining loan?": "Wat is het financieringskenmerk en hoe hoog is de resterende lening?",
  "What is the name of the tenant?": "Wat is de naam van de huurder?",
  "What is the purpose of the real estate?": "Wat is het doel van het vastgoed?",
  "What is the rent income and number of potential tenants?": "Wat zijn de huurinkomsten (excl. servicekosten) en het aantal mogelijke huurcontracten?",
  "What is the repayment per year?": "Wat is de aflossing per jaar?",
  "What is the repayment type?": "Wat is de aflossingstype van de lopende financiering?",
  "What is the repayment?": "Wat is de aflossing?",
  "What is the source of income of the customer's tax partner?": "Wat is de inkomsten bron van de fiscaal partner?",
  "What is the start date and duration of the finance?": "Per welke datum zou u de financiering in willen laten gaan?",
  "What is the start date and duration of this building?": "Wat is de startdatum en duur van dit pand?",
  "What is the total value in rented condition?": "Hoeveel bedraagt de totale waarde in verhuurde staat?",
  "What is the total value of the investment properties?": "Wat is de totale waarde van de beleggingspanden?",
  "What is the total value vacant?": "Hoeveel bedraagt de totale leegwaarde?",
  "What is the type of valuation?": "Wat voor soort waardering is het?",
  "What is the value in rented condition?": "Wat is de waarde in verhuurde staat?",
  "What is your current mortgage for this building?": "Wat is uw huidige financiering voor dit pand?",
  "What tax year does this information come from?": "Uit welk belastingjaar komen deze gegevens?",
  "What type of building is this?": "Wat voor soort pand is dit?",
  "What type of building will it be?": "Welk type pand zal het zijn?",
  "When a building has completed renovation costs, its maximum loan is raised to at least the maximum LTV of (purchase price + completed renovation costs) if that is higher than the value based loan. Rewards finished renovations that are not yet in the valuation.": "Als een object afgeronde verbouwingskosten heeft, wordt de maximale lening verhoogd tot minimaal de maximale LTV van (koopsom + afgeronde verbouwingskosten) als dat hoger is dan de lening op basis van de waarde. Beloont afgeronde verbouwingen die nog niet in de taxatie zitten.",
  "When did the renovation start and how long does it take?": "Wanneer is de verbouwing gestart en hoe lang duurt de verbouwing?",
  "When did the valuation took place?": "Wanneer heeft de waardering plaats gevonden?",
  "When do you want to add the mortgage?": "Wanneer wenst u de financiering toevoegen?",
  "When was the renovation?": "Wanneer was de verbouwing?",
  "When will the renovation start and how long will it take?": "Wanneer start de verbouwing en hoe lang duurt de verbouwing?",
  "When you choose for the repayment type Annuity you need to fill in the start date of the mortgage otherwise we can not calculate the repayment.": "Wanneer u voor de aflossingstype 'Annuïteit' kiest, dan moet u ook de startdatum van de hypotheek invullen anders kunnen we niet de aflossing uitrekenen.",
  "When your building is not in the list, add the building here!": "Als het adres niet in de lijst staat, voeg hem dan eerst hier toe",
  "Whether the names are municipalities, cities or provinces; matched on the building's address, ignoring case.": "Of de namen gemeenten, steden of provincies zijn; vergeleken met het adres van het object, ongeacht hoofdletters.",
  "Which buildings do you want to add?": "Welke panden wilt u toevoegen?",
  "Which buildings do you want to finance?": "Welke panden zou u willen financieren?",
  "Which buildings do you want to merge?": "Welke panden wilt u samenvoegen?",
  "Which buildings do you want to move?": "Welke panden wilt u verplaatsen?",
  "Which buildings do you want to update?": "Welke panden wilt u bijwerken?",
  "Which buildings have been valuated?": "Welke panden zijn er gewaardeerd?",
  "Which buildings would you like to create an application for?": "Voor welke panden wil je een aanvraag maken?",
  "Which buildings would you like to see valuated?": "Welke panden wil je laten taxeren?",
  "Which lender is supplying this mortgage?": "Welke geldverstrekker levert deze hypotheek?",
  "Which permits are needed?": "Welke vergunningen zijn van toepassing?",
  "Which valuator has valuated?": "Welke taxateur heeft getaxeerd?",
  "Which value model is used?": "Welk waardemodel is gebruikt?",
  "Who estimated the value?": "Wie doet de schatting?",
  "Who has supplied this valuation?": "Wie heeft het taxatierapport gemaakt?",
  "Why do you want to cancel this applications?": "Waarom wilt u deze aanvraag annuleren?",
  "Widowed": "Verweduwd",
  "Will be added in the e-mail on your behalf": "Wordt namens u toegevoegd in de e-mail",
  "Will be purchased within a company?": "Wordt aangekocht binnen een BV?",
  "Will be renovated": "Wordt verbouwd",
  "Will the building be transformed into another type? (e.g. office to home)": "Zal het pand worden omgezet in een ander type? (e.g. kantoor naar huis)",
  "Will the contact also be a UBO?": "Is de contactpersoon tevens UBO?",
  "Will the object be renovated before it is rented or sold?": "Wordt het pand verbouwd voordat deze wordt verhuurd of verkocht?",
  "Will the UBO also be the contact?": "Wordt deze UBO ook de contactpersoon?",
  "WillBeRenovated": "Wordt verbouwd",
  "Wish for contribution own resources and remaining buffer for rental": "Wens voor inbreng eigen geld en resterende buffer voor verhuur",
  "Wish for repayment type, form and fixed-rate interest period": "Wens ten aanzien van aflosvorm, hoogte en rentevast periode",
  "Wish for responsible monthly costs": "Wens ten aanzien van verantwoorde maandlasten",
  "with": "met",
  "With existing clients": "Bij bestaande klanten",
  "Within ... days": "Binnen {{value}} dagen",
  "With new clients": "Bij nieuwe klanten",
  "With this loan there is an interest deposit.": "Bij deze lening is er sprake van een rente depot.",
  "With this tool you can quickly update all current rental income in his / her portfolio with the help of the customer.": "Met deze tool kunt u met behulp van de klant op een snelle manier alle actuele huuropbrengsten in zijn/haar portefeuille bijwerken.",
  "Would you like other buildings to be valuated?": "Wilt u nog meer panden laten taxeren?",
  "Would you like to add other buildings?": "Wilt u nog andere panden toevoegen?",
  "Would you like to include all lenders?": "Wilt u alle geldverstrekkers berekenen?",
  "Would you like to update these buildings?": "Wilt u deze panden bijwerken?",
  "WOZ start date": "WOZ-waarde peildatum",
  "WOZ-value": "WOZ-waarde",
  "WOZ-value reference date": "WOZ-waarde peildatum",
  "Writing": "Schrijven",
  "WritingAdvisoryReport": "Adviesrapport schrijven",
  "WWS-points by estimation": "WWS-punten volgens schatting",
  "WWS-points by landlord": "WWS-punten volgens verhuurder",
  "year": "jaar",
  "Year": "Jaar",
  "Year ...": "Jaar {{value}}",
  "Yearly net rent income from rental properties": "Jaarlijkse huurinkomsten uit verhuurd vastgoed?",
  "Years": "Jaren",
  "years": "jaren",
  "Years of professional experience in real estate": "Aantal jaar ervaring in de vastgoedsector",
  "Yes": "Ja",
  "Yes, allow applicants to upload required documents through a secure personal environment.": "Ja, laat aanvragers benodigde documenten uploaden via een beveiligde persoonlijke omgeving.",
  "Yield": "Rendement",
  "Yield based on": "Rendement op basis van",
  "You already own this building": "Uw heeft het pand al in bezit",
  "You are going to buy this building on": "U gaat dit pand kopen op",
  "You are not an administrator": "U bent geen beheerder",
  "You can also drag and drop files in this window.": "U kunt ook bestanden op dit scherm slepen.",
  "You can check the progress here": "U kunt de voortgang hier monitoren",
  "You can choose": "U kunt er voor kiezen",
  "You can only adjust your loan when the application status is 'Created' or 'Term sheet Delivered'.": "U kunt alleen uw lening aanpassen wanneer de status van de aanvraag 'Aangemaakt' of 'Indicatieve offerte geleverd' is.",
  "You can only adjust your valuations when the application status is on 'Term sheet Delivered'.": "U kunt alleen uw waarderingen aanpassen wanneer de status van de aanvraag 'Indicatieve offerte geleverd' is.",
  "You can only choose a notary when the application status is 'Loan agreement delivered'.": "U kunt alleen een notaris kiezen na ontvangst van de definitieve leningovereenkomst",
  "You can only insert your valuations when the application status is on 'Term sheet Delivered'. If you want to enter the valuation in advance, you can do that on the page of the building.": "U kunt alleen uw waarderingen invoeren wanneer de status van de aanvraag 'Indicatieve offerte geleverd' is. Als u de waardering vooraf wilt invoeren, kunt u dat doen op de pagina van het betreffende pand.",
  "You can review the application before finally submitting it.": "U kunt de aanvraag reviewen voordat u hem definitief indient.",
  "You don't have any applications": "U heeft nog geen aanvragen",
  "You don't have any ongoing mortgages or applications": "U heeft nog geen lopende financieringen of aanvragen",
  "You don't have any ongoing mortgages or applications for these buildings": "U heeft nog geen lopende financieringen of aanvragen voor deze panden",
  "You don't have any ongoing mortgages or applications for this building": "U heeft nog geen lopende financieringen of aanvragen voor dit pand",
  "You have the option to choose from various reports that have been specifically compiled for real estate investors.": "Je hebt de mogelijkheid om uit verschillende rapporten te kiezen die speciaal voor vastgoedbeleggers zijn samengesteld.",
  "You have tried to login in with an unknown account. Please login using a social account with the same emailaddress as through which you have an account": "U probeert in te loggen met een onbekend account. U kunt een account gebruiken dat hetzelfde e-mailadres heeft waarop u hier een account heetft.",
  "You must select at least 2 properties to merge.": "U dient minimaal 2 panden te selecteren om samen te voegen.",
  "You'll receive a quotation as soon as possible.": "U ontvangt zo spoedig mogelijk een offerte.",
  "You'll receive another email through which you can use to setup your password": "U ontvangt nog een e-mail waarmee u uw wachtwoord kunt instellen",
  "Your applications": "Uw aanvragen",
  "Your buildings": "Uw panden",
  "Your code is: ": "Jouw code is: ",
  "Your email is successfully verified!": "Uw emailadres is succesvol geverifieerd! 🚀",
  "Your generated financing proposals": "Uw gegenereerde financieringsvoorstellen:",
  "Your investment portfolio (buildings where the purpose = renting, or where the buildings is rented)": "Uw beleggingsportefeuille (panden waarbij verhuren als doel is aangegeven of het pand gemarkeerd is als verhuurd)",
  "Your logo": "Uw logo",
  "Your mortgages": "Uw lopende financieringen",
  "Your organization": "Uw organisatie",
  "Your organization does not support consumers.": "Uw organisatie ondersteunt geen consumenten.",
  "Your rental contracts": "Uw huurcontracten",
  "Your report has been generated and is ready for download.": "Je rapport is gegenereerd en kan worden gedownload.",
  "Your report is being generated and will be ready for download shortly. Please wait a moment.": "Je rapport wordt gegenereerd en is bijna klaar om te downloaden, een moment geduld.",
  "Your request is being processed": "Uw verzoek wordt verwerkt",
  "Interest sheet": "Rentekaart",
  "New interest sheet": "Nieuwe rentekaart",
  "Create interest sheet": "Rentekaart aanmaken",
  "A new interest sheet changes the interest rates from a date within this version, without a new version. It starts as a copy of the latest sheet, which applies until the new one starts.": "Een nieuwe rentekaart wijzigt de rentes vanaf een datum binnen deze versie, zonder nieuwe versie. Hij begint als kopie van de laatste rentekaart, die geldt tot de nieuwe ingaat.",
  "This interest sheet is closed and can no longer be changed; editing changes the latest sheet.": "Deze rentekaart is afgesloten en kan niet meer worden gewijzigd; bewerken wijzigt de laatste rentekaart.",
  "New interest sheet created; edit it to change the interest rates from its start date": "Nieuwe rentekaart aangemaakt; bewerk hem om de rentes vanaf de ingangsdatum te wijzigen",
  "Discounts": "Kortingen",
  "Open the latest version in the rate details": "Open de laatste versie in de tariefdetails",
  "This rate is not available in the rate details": "Dit tarief is niet beschikbaar in de tariefdetails",
  "Rate settings": "Tariefinstellingen",
  "Only an admin can open the rate settings": "Alleen een beheerder kan de tariefinstellingen openen",
  "Combination shares": "Aandelen combinatiepanden",
  "Required with the combination buildings setting \"By non-residential share and count\", unused otherwise.": "Verplicht bij de instelling combinatiepanden \"Naar niet-wonenaandeel en aantal\", anders niet gebruikt.",
  "Loan after renovation": "Lening na renovatie",
  "With a planned renovation, the loan on the increased registration: the value after renovation, capped by the factors below, times the LTV.": "Bij een geplande renovatie de lening op de verhoogde inschrijving: de waarde na renovatie, begrensd door de factoren hieronder, maal de LTV.",
  "Big city loan cap": "Leningplafond grote steden",
  "Caps the total loan by whether every building is in a big city.": "Begrenst de totale lening naar of elk pand in een grote stad ligt.",
  "Low purchase price cap": "Begrenzing bij lage aankoopprijs",
  "Lowers the LTV when the purchase price is far below the value.": "Verlaagt de LTV als de aankoopprijs ver onder de waarde ligt.",
  "Mixed use reduction": "Korting gemengd gebruik",
  "Reduces the financing of a combination building with a large non-residential part.": "Verlaagt de financiering van een combinatiepand met een groot niet-wonengedeelte.",
  "Rent of non-residential space": "Huur van niet-woonruimte",
  "Not used": "Niet gebruikt",
  "Use": "Gebruiken",
  "Do not use": "Niet gebruiken",
  "Whole rent": "Volledige huur",
  "Maximum non-residential share of the loan": "Maximaal niet-wonenaandeel van de lening",
  "The highest share of the total maximum loan that may rest on non-residential buildings and units; above it the total is capped to exactly that share.": "Het hoogste aandeel van de totale maximale lening dat op niet-woonpanden en -eenheden mag rusten; daarboven wordt het totaal begrensd tot precies dat aandeel.",
  "Portfolio cap threshold": "Drempel portefeuilleplafond",
  "Above this total loan the loan may not exceed the \"Portfolio above threshold\" maximum LTV of the financing value, but it never drops below this amount.": "Boven deze totale lening mag de lening niet hoger zijn dan de maximale LTV \"Portefeuille boven drempel\" van de financieringswaarde, maar nooit lager dan dit bedrag.",
  "Full value up to non-residential share": "Volledige waarde tot niet-wonenaandeel",
  "With at most the maximum number of combination buildings, up to this non-residential value share the whole value of a combination building counts.": "Bij ten hoogste het maximale aantal combinatiepanden telt tot dit niet-wonenaandeel van de waarde de hele waarde van een combinatiepand mee.",
  "Maximum non-residential share": "Maximaal niet-wonenaandeel",
  "Up to this non-residential value share only the residential units count (and, with more combination buildings, the whole value at the \"Combination portfolio\" LTV); above it the policy's maximum loan stays.": "Tot dit niet-wonenaandeel van de waarde tellen alleen de wooneenheden mee (en bij meer combinatiepanden de hele waarde tegen de LTV \"Combinatieportefeuille\"); daarboven blijft de maximale lening van het beleid.",
  "Maximum number at the default LTV": "Maximaal aantal tegen de standaard-LTV",
  "The number of combination buildings up to which the building's own LTV applies; with more, the \"Combination portfolio\" LTV applies.": "Het aantal combinatiepanden tot waar de eigen LTV van het pand geldt; bij meer geldt de LTV \"Combinatieportefeuille\".",
  "Factor of the renovation costs": "Factor van de renovatiekosten",
  "The value after renovation counts up to the financing value plus this factor times the renovation costs (e.g. 1.25).": "De waarde na renovatie telt mee tot de financieringswaarde plus deze factor maal de renovatiekosten (bijv. 1,25).",
  "Factor of the financing value": "Factor van de financieringswaarde",
  "The value after renovation counts up to this factor times the financing value (e.g. 1.5).": "De waarde na renovatie telt mee tot deze factor maal de financieringswaarde (bijv. 1,5).",
  "Minimum loan increase": "Minimale verhoging van de lening",
  "The loan after renovation only counts when it adds at least this amount to the loan.": "De lening na renovatie telt alleen mee als die minstens dit bedrag aan de lening toevoegt.",
  "Maximum total loan in big cities": "Maximale totale lening in grote steden",
  "The maximum total loan when every building is in a big city.": "De maximale totale lening als elk pand in een grote stad ligt.",
  "Maximum total loan elsewhere": "Maximale totale lening elders",
  "The maximum total loan when a building is outside the big cities.": "De maximale totale lening als een pand buiten de grote steden ligt.",
  "Purchase price threshold": "Drempel aankoopprijs",
  "The cap applies when the purchase price is at most this percentage of the value in rented condition.": "De begrenzing geldt als de aankoopprijs ten hoogste dit percentage van de waarde in verhuurde staat is.",
  "Purchase price threshold with renovation": "Drempel aankoopprijs met renovatie",
  "With planned renovation costs the cap applies when the purchase price is at most this percentage of the value after renovation.": "Met geplande renovatiekosten geldt de begrenzing als de aankoopprijs ten hoogste dit percentage van de waarde na renovatie is.",
  "Capped loan to value": "Begrensde loan to value",
  "A higher maximum LTV drops to this one when the cap applies.": "Een hogere maximale LTV daalt naar deze als de begrenzing geldt.",
  "A combination building whose non-residential value share is above this percentage is reduced.": "Een combinatiepand met een niet-wonenaandeel van de waarde boven dit percentage krijgt korting.",
  "Factor of the residential value": "Factor van de woonwaarde",
  "Such a building is financed on at most this factor times the value of its residential units (1: the residential value only).": "Zo'n pand wordt gefinancierd op ten hoogste deze factor maal de waarde van de wooneenheden (1: alleen de woonwaarde).",
  "Counted rent of non-residential units": "Meetellende huur van niet-wooneenheden",
  "The share of the rental value and rent of a non-residential unit in a combination building that counts, minus the ground lease (gross) or the operating costs (net).": "Het aandeel van de huurwaarde en huur van een niet-wooneenheid in een combinatiepand dat meetelt, na aftrek van de erfpacht (bruto) of de exploitatiekosten (netto).",
  "Counted rent of non-residential buildings": "Meetellende huur van niet-woonpanden",
  "The share of the building-level rent of a building that is not residential (also a combination building with a non-residential unit) that counts.": "Het aandeel van de huur op pandniveau van een pand dat geen woonpand is (ook een combinatiepand met een niet-wooneenheid) dat meetelt.",
  "Admin settings": "Beheersinstellingen",
  "Only an admin can open the admin settings": "Alleen een beheerder kan de beheersinstellingen openen",
  "Add lender": "Geldverstrekker toevoegen",
  "Edit lender": "Geldverstrekker bewerken",
  "Save lender": "Geldverstrekker opslaan",
  "No lenders found": "Geen geldverstrekkers gevonden",
  "Hidden": "Verborgen",
  "A hidden lender can no longer be selected": "Een verborgen geldverstrekker kan niet meer gekozen worden",
  "The lender number in the calculation service (0: none)": "Het nummer van de geldverstrekker in de rekenservice (0: geen)",
  "Appointment email": "E-mail voor afspraken",
  "Financing email": "E-mail voor financieringen",
  "Alternative names": "Alternatieve namen",
  "One name per line, used to recognize the lender in documents": "Eén naam per regel, gebruikt om de geldverstrekker in documenten te herkennen",
  "Hidden: the lender can no longer be selected": "Verborgen: de geldverstrekker kan niet meer gekozen worden",
  "Add rate": "Tarief toevoegen",
  "Edit rate": "Tarief bewerken",
  "Save rate": "Tarief opslaan",
  "Rate added": "Tarief toegevoegd",
  "No rates found": "Geen tarieven gevonden",
  "Portal product": "Portaalproduct",
  "Not through the portal": "Niet via het portaal",
  "Applications with this rate are submitted through the lender's portal as this product": "Aanvragen met dit tarief worden via het portaal van de geldverstrekker ingediend als dit product",
  "Product name": "Productnaam",
  "Consumers only": "Alleen consumenten",
  "Added by a user, not calculated": "Toegevoegd door een gebruiker, wordt niet berekend",
  "The rate number in the calculation service, leave empty when the rate is not calculated": "Het tariefnummer in de rekenservice, leeg laten als het tarief niet berekend wordt",
  "Only for consumers": "Alleen voor consumenten",
  "This rate was added by a user and is not calculated": "Dit tarief is toegevoegd door een gebruiker en wordt niet berekend",
  "Document types": "Documentsoorten",
  "Add document type": "Documentsoort toevoegen",
  "Edit document type": "Documentsoort bewerken",
  "Save document type": "Documentsoort opslaan",
  "Document type created": "Documentsoort aangemaakt",
  "Document type deleted": "Documentsoort verwijderd",
  "Delete document type?": "Documentsoort verwijderen?",
  "This deletes the document type. This cannot be undone.": "Dit verwijdert de documentsoort. Dit kan niet ongedaan gemaakt worden.",
  "The document type could not be deleted": "De documentsoort kon niet verwijderd worden",
  "No document types found": "Geen documentsoorten gevonden",
  "Associated with": "Gekoppeld aan",
  "What documents of this type are linked to": "Waaraan documenten van deze soort gekoppeld worden",
  "Issue date": "Afgiftedatum",
  "Options": "Opties",
  "In use": "In gebruik",
  "In use by documents, required documents or forms, so it cannot be deleted": "In gebruik door documenten, benodigde documenten of formulieren, dus kan niet verwijderd worden",
  "Up to 16 characters, cannot be changed later": "Maximaal 16 tekens, kan later niet gewijzigd worden",
  "Documents of this type have a year": "Documenten van deze soort hebben een jaar",
  "Documents of this type have an issue date": "Documenten van deze soort hebben een afgiftedatum",
  "Documents of this type have an expiration date": "Documenten van deze soort hebben een expiratiedatum",
  "Users can upload documents of this type": "Gebruikers kunnen documenten van deze soort uploaden",
  "Required documents of this type are not matched automatically with the customer's documents": "Benodigde documenten van deze soort worden niet automatisch gekoppeld aan de documenten van de klant",
  "Documents of this type are not grouped when files are uploaded": "Documenten van deze soort worden niet gegroepeerd bij het uploaden van bestanden",
  "Not matched automatically": "Wordt niet automatisch gekoppeld",
  "Grouping disabled": "Groeperen uitgeschakeld",
  "Agent workflow": "Assistent-workflow",
  "The workflow the assistant starts once a document of this type is indexed; AUTO lets the assistant decide, empty: not handed to the assistant": "De workflow die de assistent start zodra een document van deze soort geïndexeerd is; AUTO laat de assistent kiezen, leeg: niet aan de assistent doorgegeven",
  "The assistant decides which workflow fits the document": "De assistent bepaalt welke workflow bij het document past",
  "The assistant starts this workflow once a document of this type is indexed": "De assistent start deze workflow zodra een document van deze soort geïndexeerd is",
  "OneDrive": "OneDrive",
  "Loading OneDrive settings": "OneDrive-instellingen laden",
  "Document sync": "Documenten synchroniseren",
  "The documents of your applications are copied to a folder per application in the OneDrive or SharePoint of your own Microsoft 365 tenant. Register an application in your tenant (Entra ID) with the application permission Files.ReadWrite.All and admin consent, and enter its details here.": "De documenten van je aanvragen worden gekopieerd naar een map per aanvraag in de OneDrive of SharePoint van je eigen Microsoft 365-tenant. Registreer een applicatie in je tenant (Entra ID) met de applicatiemachtiging Files.ReadWrite.All en beheerderstoestemming, en vul de gegevens hier in.",
  "Sync application documents to OneDrive": "Aanvraagdocumenten synchroniseren naar OneDrive",
  "Tenant id": "Tenant-id",
  "Leave empty to keep the stored secret": "Laat leeg om het opgeslagen secret te behouden",
  "SharePoint site url": "SharePoint-site-url",
  "The default document library of this site receives the documents": "De standaard documentbibliotheek van deze site ontvangt de documenten",
  "Or the OneDrive of user": "Of de OneDrive van gebruiker",
  "Only used when no site url is entered": "Alleen gebruikt als er geen site-url is ingevuld",
  "Root folder": "Hoofdmap",
  "A folder per application is created under this folder": "Onder deze map wordt een map per aanvraag aangemaakt",
  "Connection": "Verbinding",
  "Connected to": "Verbonden met",
  "The connection has not been tested yet": "De verbinding is nog niet getest",
  "Last synced": "Laatst gesynchroniseerd",
  "Last run": "Laatste run",
  "new": "nieuw",
  "uploaded": "geüpload",
  "removed": "verwijderd",
  "failed": "mislukt",
  "Test connection": "Verbinding testen",
  "Sync now": "Nu synchroniseren",
  "Sync completed": "Synchronisatie voltooid",
  "The settings could not be saved": "De instellingen konden niet worden opgeslagen",
  "The connection could not be tested": "De verbinding kon niet worden getest",
  "The sync could not be started": "De synchronisatie kon niet worden gestart",
  "Sync documents uploaded from": "Synchroniseer documenten geüpload vanaf",
  "Leave empty to sync all documents. Filled with today when the sync is switched on.": "Laat leeg om alle documenten te synchroniseren. Wordt gevuld met vandaag als de synchronisatie wordt ingeschakeld.",
  "Divide value in rented condition residential": "Verdeel waarde in verhuurde staat residentieel",
  "Divide value in rented condition commercial": "Verdeel waarde in verhuurde staat commercieel",
  "What is the total value in rented condition residential?": "Wat is de totale waarde in verhuurde staat residentieel?",
  "What is the total value in rented condition commercial?": "Wat is de totale waarde in verhuurde staat commercieel?",
  "How is the property rated?": "Hoe is het object beoordeeld?",
  "Environment, legal provisions and permits": "Milieu, juridische bepalingen en vergunningen",
  "Ground pollution": "Bodemverontreiniging",
  "Obligation to clean up ground pollution": "Saneringsplicht bodemverontreiniging",
  "Object pollution": "Verontreiniging in het object",
  "Removal pollution cost": "Kosten verwijdering verontreiniging",
  "Special private law provisions": "Bijzondere privaatrechtelijke bepalingen",
  "Public law provisions": "Publiekrechtelijke bepalingen",
  "Withdrawal permit needed": "Onttrekkingsvergunning nodig",
  "Environmental permit needed": "Omgevingsvergunning nodig",
  "Split permit needed": "Splitsingsvergunning nodig",
  "Proof of fire safety needed": "Bewijs brandveiligheid nodig",
  "Ratings": "Beoordelingen",
  "Pro rata": "Pro rata",
  "What the rate finances: the financing types, the loan and the size of the portfolio.": "Wat het tarief financiert: de financieringsvormen, de lening en de omvang van de portefeuille.",
  "Who the rate is offered to and the income test.": "Aan wie het tarief wordt aangeboden en de inkomenstoets.",
  "The buildings the rate finances and the rental it permits. The minimum energy labels are listed in their own card.": "De panden die het tarief financiert en de verhuur die het toestaat. De minimale energielabels staan in een eigen kaart.",
  "Combination buildings and non-residential space": "Combinatiepanden en niet-woonruimte",
  "The limits on the non-residential part of a combination building and of the portfolio, and the share of non-residential rent that counts. The maximum loan tab has the combination settings of the maximum loan.": "De grenzen aan het niet-woondeel van een combinatiepand en van de portefeuille, en het deel van de huur van niet-woonruimte dat meetelt. De combinatiepand-instellingen van de maximale lening staan op het tabblad Maximale lening.",
  "Financing and loan": "Financiering en lening",
  "Costs and fees": "Kosten en vergoedingen",
  "Other settings": "Overige instellingen",
  "Interest and repayment for the ratios": "Rente en aflossing voor de ratio's",
  "Location requirements": "Locatie-eisen",
  "Where the rate finances, by the postcode list and the regions below.": "Waar het tarief financiert, op basis van de postcodelijst en de regio's hieronder.",
  "OneDrive folder": "OneDrive-map",
  "SolidBriQ login": "SolidBriQ-login",
  "Loading SolidBriQ login": "SolidBriQ-login laden",
  "Applications to SolidBriQ are filled in at the SolidBriQ portal with your own account. Enter your SolidBriQ login here. It is encrypted right away: nobody can read it back, not even Stingray.": "Aanvragen bij SolidBriQ worden in het SolidBriQ-portaal ingevuld met je eigen account. Vul hier je SolidBriQ-login in. Die wordt direct versleuteld: niemand kan hem teruglezen, ook Stingray niet.",
  "Your SolidBriQ login is stored": "Je SolidBriQ-login is opgeslagen",
  "Enter it again to replace it, e.g. after changing your password.": "Vul hem opnieuw in om hem te vervangen, bijvoorbeeld na het wijzigen van je wachtwoord.",
  "Authenticator secret": "Authenticator-sleutel",
  "Save login": "Login opslaan",
  "Remove login": "Login verwijderen",
  "SolidBriQ login saved": "SolidBriQ-login opgeslagen",
  "The SolidBriQ login could not be saved": "De SolidBriQ-login kon niet worden opgeslagen",
  "Email address": "E-mailadres",
  "Scan the QR code with the camera": "QR-code scannen met de camera",
  "QR code read": "QR-code gelezen",
  "Scan the authenticator QR code": "Authenticator-QR-code scannen",
  "Hold the QR code in front of the camera: the QR code shown when you set up two-factor authentication at SolidBriQ, or a Google Authenticator export (Transfer accounts, Export accounts, only your SolidBriQ account).": "Houd de QR-code voor de camera: de QR-code bij het instellen van tweestapsverificatie bij SolidBriQ, of een export uit Google Authenticator (Accounts overzetten, Accounts exporteren, alleen je SolidBriQ-account).",
  "This QR code is not an authenticator QR code": "Deze QR-code is geen authenticator-QR-code",
  "This browser cannot use the camera here": "Deze browser kan de camera hier niet gebruiken",
  "Access to the camera was denied": "Toegang tot de camera is geweigerd",
  "No camera was found": "Er is geen camera gevonden",
  "Scan the QR code with the camera or upload a screenshot of it: the one shown when you set up two-factor authentication at SolidBriQ, or a Google Authenticator export. Or enter the code below the QR code.": "Scan de QR-code met de camera of upload er een screenshot van: die bij het instellen van tweestapsverificatie bij SolidBriQ, of een export uit Google Authenticator. Of vul de code onder de QR-code in.",
  "Upload a screenshot of the QR code": "Screenshot van de QR-code uploaden",
  "Upload a screenshot": "Screenshot uploaden",
  "Take a screenshot of the QR code on your phone and upload it here.": "Maak een screenshot van de QR-code op je telefoon en upload die hier.",
  "The image could not be opened": "De afbeelding kon niet worden geopend",
  "No QR code was found in the image": "Er is geen QR-code gevonden in de afbeelding",
  "In use by documents, required documents, required document rules or forms, so it cannot be deleted": "In gebruik door documenten, benodigde documenten, documentregels of formulieren, dus kan niet verwijderd worden",
  "Add rule": "Regel toevoegen",
  "All rules": "Alle regels",
  "Organization rules": "Regels van organisaties",
  "A rule for a lender replaces the rules for all lenders with the same document type and object. Changes only apply to new applications.": "Een regel voor een geldverstrekker vervangt de regels voor alle geldverstrekkers met dezelfde documentsoort en hetzelfde object. Wijzigingen gelden alleen voor nieuwe aanvragen.",
  "For": "Voor",
  "Not required for this lender": "Niet nodig voor deze geldverstrekker",
  "Per": "Per",
  "Phase": "Fase",
  "All lenders": "Alle geldverstrekkers",
  "Delete rule?": "Regel verwijderen?",
  "New applications no longer get this document; existing applications keep their documents.": "Nieuwe aanvragen krijgen dit document niet meer; bestaande aanvragen houden hun documenten.",
  "Rule deleted": "Regel verwijderd",
  "The rule could not be deleted": "De regel kon niet worden verwijderd",
  "Per rental contract": "Per huurcontract",
  "Last {{count}} tax years": "Laatste {{count}} belastingjaren",
  "Provisional assessment past year": "Voorlopige aanslag afgelopen jaar",
  "Last {{count}} years of financial statements": "Jaarstukken van de laatste {{count}} jaar",
  "No rules found": "Geen regels gevonden",
  "Edit rule": "Regel wijzigen",
  "Lender requires": "Geldverstrekker vraagt",
  "Organization requires": "Organisatie vraagt",
  "Organization id": "Organisatie-id",
  "Replaces the rules for all lenders with the same document type and object": "Vervangt de regels voor alle geldverstrekkers met dezelfde documentsoort en hetzelfde object",
  "This lender does not require the document": "Deze geldverstrekker vraagt dit document niet",
  "Choose a document type from the list": "Kies een documentsoort uit de lijst",
  "A building rule also applies to each unit of the building": "Een pandregel geldt ook voor elke unit van het pand",
  "Kind of customer": "Soort klant",
  "A company that is not a foundation": "Een bedrijf dat geen stichting is",
  "Only with status": "Alleen bij status",
  "Any status": "Elke status",
  "Lender documents are created once, when the application is created": "Documenten van de geldverstrekker worden één keer aangemaakt, bij het aanmaken van de aanvraag",
  "All chosen conditions must hold; none: always required": "Alle gekozen voorwaarden moeten gelden; geen: altijd nodig",
  "Once": "Eén keer",
  "Per tax year": "Per belastingjaar",
  "Provisional assessment past year (from May)": "Voorlopige aanslag afgelopen jaar (vanaf mei)",
  "Per year of financial statements": "Per jaar jaarstukken",
  "A note for admins, e.g. why the lender asks for it": "Een notitie voor beheerders, bijv. waarom de geldverstrekker erom vraagt",
  "Changes only apply to new applications; existing applications keep their required documents.": "Wijzigingen gelden alleen voor nieuwe aanvragen; bestaande aanvragen houden hun benodigde documenten.",
  "Save rule": "Regel opslaan",
  "Rule saved": "Regel opgeslagen",
  "Rule added": "Regel toegevoegd",
  "The rule could not be saved": "De regel kon niet worden opgeslagen",
  "Borrower or guarantor": "Kredietnemer of borg",
  "Export / Import": "Export / Import",
  "Downloads the rate and interest settings of the selected lenders as JSON: every version of every rate with its settings, interest sheets, postcodes and regions.": "Download de tarief- en renteinstellingen van de geselecteerde geldverstrekkers als JSON: elke versie van elk tarief met de instellingen, rentebladen, postcodes en regio's.",
  "rate": "tarief",
  "rates": "tarieven",
  "Download JSON": "JSON downloaden",
  "Reads an export and overwrites the versions that match on lender, rate number, valid from and valid to. Only open versions (without an end date) and their open interest sheet can be changed; closed and unknown versions are reported and left alone. Check first shows what would change without saving anything.": "Leest een export in en overschrijft de versies die overeenkomen op geldverstrekker, tariefnummer, geldig vanaf en geldig tot. Alleen open versies (zonder einddatum) en hun open renteblad kunnen worden gewijzigd; gesloten en onbekende versies worden gemeld en niet aangepast. Controleren laat eerst zien wat er zou wijzigen, zonder iets op te slaan.",
  "Choose file": "Bestand kiezen",
  "Exported on": "Geëxporteerd op",
  "Clear": "Wissen",
  "... versions will be overwritten": "{{count}} versie(s) worden overschreven",
  "Valid to": "Geldig tot",
  "Will be overwritten": "Wordt overschreven",
  "Overwritten": "Overschreven",
  "Unchanged": "Ongewijzigd",
  "Closed version": "Gesloten versie",
  "Not found": "Niet gevonden",
  "Import rate settings?": "Tariefinstellingen importeren?",
  "This overwrites the rate settings of ... versions in the calculation service. This cannot be undone.": "Hiermee worden de tariefinstellingen van {{count}} versie(s) in de rekenservice overschreven. Dit kan niet ongedaan worden gemaakt.",
  "The file is not an export of rate settings": "Het bestand is geen export van tariefinstellingen",
  "The import is done, but ... versions failed": "De import is klaar, maar {{count}} versie(s) zijn mislukt",
  "The rate settings were imported": "De tariefinstellingen zijn geïmporteerd",
  "The rate settings could not be exported": "De tariefinstellingen konden niet worden geëxporteerd",
  "The rate settings could not be imported": "De tariefinstellingen konden niet worden geïmporteerd"
}
